// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Helvetica.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts//Helvetica-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* font family helvetica */
@font-face {
  font-family: "Helvetica";
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "Helvetica Bold";
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

/* Common styles for elements */

/* Add this CSS to your stylesheet */
.canvas-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full viewport height */
}

canvas {
  width: auto;
  height: 100%;
}

body {
  font-family: Helvetica, sans-serif;
  margin: 0;
  padding: 0;
  font-size: 18px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Helvetica Bold", sans-serif;
}
input[type="number"] {
  -webkit-appearance: none; /* Remove arrows in WebKit browsers */
  -moz-appearance: textfield; /* Remove arrows in Firefox */
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none; /* Remove arrows in Chrome, Safari, Edge */
  margin: 0;
}
.affialiate-form-style input::placeholder,
.affialiate-form-style textarea::placeholder {
  color: #b4b4b4;
}
.cookie-preferences-container {
  padding: 20px;
  max-width: 600px;
  margin: 40px auto;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
}

.cookie-settings-modal .modal-content {
  max-height: min(90vh, 720px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cookie-settings-modal__header {
  position: sticky;
  top: 0;
  z-index: 2;
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
}

.cookie-settings-modal__body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 20px;
  -webkit-overflow-scrolling: touch;
}

.cookie-settings-modal__footer {
  flex-shrink: 0;
  border-top: 1px solid #e0e0e0;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  background: #fff;
}

.cookie-settings-modal__footer .cookie-settings-modal__btn-save:hover,
.cookie-settings-modal__footer .cookie-settings-modal__btn-save:focus {
  background-color: #c93312 !important;
  border-color: #c93312 !important;
  color: #fff !important;
}

.cookie-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;
  font-size: 14px;
}

.cookie-category-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cookie-category-panel {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.cookie-category-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
}

.cookie-category-panel__toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: #111;
  text-align: left;
  min-width: 0;
}

.cookie-category-panel__chevron {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  transition: transform 0.2s ease;
  color: #555;
}

.cookie-category-panel__chevron.is-expanded {
  transform: rotate(180deg);
}

.cookie-category-panel__title {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
}

.cookie-category-panel__always-active {
  color: #1f8a3b;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.cookie-category-panel__body {
  padding: 0 16px 16px;
}

.cookie-category-panel__description {
  font-size: 14px;
  color: #666;
  margin: 0 0 12px;
  line-height: 1.5;
}

.cookie-detail-list {
  background: #f5f5f5;
  border-radius: 6px;
  padding: 4px 14px;
}

.cookie-detail-item {
  padding: 14px 0;
  border-bottom: 1px solid #e4e4e4;
}

.cookie-detail-item:last-child {
  border-bottom: 0;
}

.cookie-detail-row {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 10px;
  margin-bottom: 8px;
  font-size: 13px;
  line-height: 1.45;
}

.cookie-detail-row:last-child {
  margin-bottom: 0;
}

.cookie-detail-label {
  color: #666;
  font-weight: 600;
}

.cookie-detail-value {
  color: #222;
  word-break: break-word;
}

@media (max-width: 575.98px) {
  .cookie-detail-row {
    grid-template-columns: 1fr;
    gap: 2px;
  }
}

.cookie-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.cookie-actions button {
  padding: 8px 14px;
  font-size: 14px;
  border: none;
  background: #000;
  color: white;
  border-radius: 5px;
  cursor: pointer;
}

.cookie-actions button:nth-child(1) {
  background: #c93312;
}
.cookie-actions button:nth-child(2) {
  background: #000;
}
.cookie-actions button:nth-child(3) {
  background: #c93312;
}

/* Toggle Switch */
.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 24px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  background-color: #ccc;
  border-radius: 34px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
input:checked + .slider {
  background-color: #c93312;
}
input:checked + .slider:before {
  transform: translateX(18px);
}

p {
  font-size: 18px;
  line-height: 1.5;
  font-family: "Helvetica", sans-serif;
}

p.large {
  font-size: 20px;
  line-height: 1.5;
}

a {
  color: #007bff;
  text-decoration: none;
}

.btn:hover {
  opacity: 0.75;
}

.back-arrow {
  left: -4.5%;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.back-arrow:hover {
  border: 1px solid #000;
}

.text-muted {
  text-align: end;
  font-size: 14px;
}

html body h1 {
  font-size: 4.6rem !important;
  line-height: 1.1;
  font-family: "Helvetica", sans-serif;
}

html body .grey-btn {
  background-color: #0e0e0e !important;
  color: #fff !important;
  border: none;
  padding: 7px 36px !important;
  border-radius: 5px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600 !important;
}

.red-buy {
  background-color: #c93312 !important;
  color: #fff !important;
  border: none;
  padding: 7px 36px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 400 !important;
  text-decoration: none;
  border: 1px solid #00000072;
  display: inline-block;
}

.grey-use {
  background-color: #0e0e0e !important;
  color: #fff !important;
  border: none;
  padding: 7px 36px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 400 !important;
  text-decoration: none;
  display: inline-block;
}
.css-shadow-6 {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important;
}
/* Base styles for the tab */
.tabcust {
  background-color: #f1f4f9 !important;
  border-radius: 19px;
  transition:
    background-color 1s,
    transform 1s !important;
  padding: 10px 20px !important;

  cursor: pointer !important;

  font-family: Arial, sans-serif;
}

/* Active state styles */
.tabcust.active {
  background-color: #a8c0ff !important;
  transform: scale(1.1) !important;
}

/* Example hover effect (optional) */
.tabcust:hover {
  background-color: #dce6f9 !important;
  cursor: pointer !important;
}

html body .red-btn {
  background-color: #c93312 !important;
  color: #fff !important;
  border: none;
  font-weight: 600 !important;
  padding: 6px 36px !important;
  border-radius: 5px;
  cursor: pointer;
  font-size: 15px;
  text-decoration: none;
}

html body .shadow {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px !important;
}

.card-img-wrapper {
  position: relative;
  overflow: hidden;
}

.listing-img {
  border-top-right-radius: 30px;
}

.card-img-wrapper img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  object-position: center;
  transition: transform 0.3s ease-in-out;
}

/* 👇 Apply 4:3 frame only on small → large screens */
@media (max-width: 1024px) {
  .card-img-wrapper {
    aspect-ratio: 4 / 3;
  }

  .listing-img {
    aspect-ratio: 4 / 3;
  }
  .card-img-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}

/* 👇 Keep the rounded corner on large screens and above */
@media (min-width: 1024px) {
  .card-img-wrapper,
  .listing-img {
    border-top-right-radius: 30px;
  }
}

@media (min-width: 992px) {
  .rounded-tr-lg {
    border-top-right-radius: 30px !important;
  }
}

.p-image-mask {
  z-index: 1300 !important;
}
.p-component-overlay-enter {
  z-index: 1300 !important;
}
.p-image-action {
  color: #fff !important;
}
.testelips {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal {
  z-index: 1210 !important;
}

.modal-width {
  max-width: 80% !important;
  margin: auto !important;
  z-index: 1210;
  height: 100%;
  background-color: transparent;
}

.seller-popup {
  max-width: 73% !important;
}

.seller-popup .modal-content {
  height: 76vh !important;
  margin-bottom: 4% !important;
}

.stepper-modal {
  max-width: 90% !important;
  margin: auto !important;
  z-index: 1210;
  height: 100%;
  background-color: transparent;
}

.modal-width .modal-content {
  background-color: transparent;
  border: none;
  height: 90vh;
}

.modal-width .modal-body {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabs-wrapper .MuiTabs-root {
  padding: 8px;
  box-sizing: border-box;
}

.tabs-wrapper .MuiTabs-scroller,
.tabs-wrapper .MuiTabs-flexContainer,
.tabs-wrapper .MuiTabs-flexContainerVertical {
  width: 100%;
}

.tabs-wrapper .MuiTabs-flexContainerVertical {
  align-items: stretch;
  gap: 4px;
}

.tabs-wrapper .MuiButtonBase-root {
  align-items: flex-start !important;
  text-transform: none !important;
  font-weight: 700;
  border-radius: 12px;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  justify-content: flex-start !important;
  box-sizing: border-box;
}

.alert-modal .modal-content {
  border-radius: 32px;
}

.tabs-wrapper .MuiTabs-indicator {
  display: none;
}

.bg-announcement {
  background: rgba(235, 138, 62, 0.4);
  background: linear-gradient(
    173deg,
    rgba(235, 138, 62, 0.4) 0%,
    rgba(235, 138, 62, 0.2) 100%
  );
}

/* .seller-board{
 opacity: 0;
}

.avatar-wrapper:hover + .seller-board{
    opacity: 1;

} */

.tabs-wrapper .MuiButtonBase-root.Mui-selected {
  background-color: #373a3b !important;
  color: #fff !important;
}

.card:hover img {
  transform: scale(1.15);
}

.card .card-title {
  font-weight: 600;
}

.login-logo {
  max-width: 210px;
}

input {
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.main-wrapper {
  position: relative;
  min-height: 100vh;
}

.test {
  border: 2px solid red;
}

.main-content {
  padding-bottom: 60px !important;
}
.breadcrumb {
  background-color: #f8f9fa;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border-radius: 0.25rem;
}

.card-title {
  margin-bottom: 1.5rem;
}

.display-4 {
  font-weight: 300;
  font-size: 3.5rem;
}

.badge-success {
  background-color: #28a745;
}

.pagination .page-item .page-link {
  color: #007bff;
}

.pagination .page-item.disabled .page-link {
  color: #6c757d;
}

.nav-tabs .nav-link.active {
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 10px;
  font-weight: 700;
}

h1 {
  margin-top: 20px;
  font-size: 38px;
  line-height: 44px;
}

h2 {
  margin-top: 20px;
  font-size: 32px;
  line-height: 36px;
}

h3 {
  margin-top: 20px;
  font-size: 24px;
  line-height: 30px;
}

h4 {
  margin-top: 10px;
  font-size: 18px;
  line-height: 24px;
}

h5 {
  margin-top: 10px;
  font-size: 14px;
  line-height: 20px;
}

h6 {
  margin-top: 10px;
  font-size: 12px;
  line-height: 18px;
}

p {
  margin-top: 0;
  margin-bottom: 10px;
}

blockquote {
  border-left: 5px solid #e2e2e2;
  margin: 0 0 10px;
  padding: 10px 20px;
  font-size: 18px;
  line-height: 22px;
}

figure {
  margin: 0 0 10px;
}

figcaption {
  text-align: center;
  margin-top: 5px;
}

ul,
ol {
  margin-top: 0;
  margin-bottom: 10px;
  padding-left: 40px;
}

a {
  color: #0f141f;
}

.post-template-custom_blog_post_template {
  background-color: #fbfcfd;
}

.custom-blog-post {
  padding-top: 90px;
}

.custom-blog-post#content.post {
  max-width: 1114px;
  margin-top: 0;
}

.article-grid {
  max-width: 1114px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 110px;
  display: grid;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  grid-template-rows: auto;
  grid-template-columns: 2.75fr 1fr;
  border-bottom: 1px solid #eceef0;
  border-left: 1px solid #eceef0;
  border-right: 1px solid #eceef0;
  border-radius: 0 0 8px 8px;
  background-color: #fff;
}

.article {
  padding: 70px 80px 50px 50px;
  font-style: normal;
}

.article #ez-toc-container {
  display: none;
}

.sidebar {
  border-left: 1px solid #f8f9fa;
  padding: 70px 25px;
}

.sidebar-sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 100px;
}

.sidebar-sticky #ez-toc-container {
  background: none;
  border: none;
  box-shadow: none;
}

.sidebar-sticky div#ez-toc-container .ez-toc-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  color: #0f141f;
}

.sidebar-sticky .table-of-content nav {
  margin-top: 15px;
}

.sidebar-sticky .table-of-content nav ul {
  grid-row-gap: 4px;
  flex-direction: column;
  margin-bottom: 40px;
  display: flex;
}

.sidebar-sticky #ez-toc-container a {
  color: #667085;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
}

.sidebar-sticky #ez-toc-container a.active {
  color: #0a8bfe;
}

.post-head {
  width: 100%;
  padding-top: 50px;
  padding-left: 50px;
  padding-right: 50px;
  position: relative;
  max-width: 1114px;
  margin-left: auto;
  margin-right: auto;
  border-top: 1px solid #eceef0;
  border-bottom: 1px solid #f8f9fa;
  border-left: 1px solid #eceef0;
  border-right: 1px solid #eceef0;
  background-color: #fff;
  border-radius: 8px 8px 0 0;
}

/* post author wrapper */

.post-fields-wrap {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 60px;
  display: flex;
}

.post-main-heading {
  max-width: 33ch;
  letter-spacing: -1.28px;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 35.5px;
  font-weight: 600;
  line-height: 54px;
}

.post-subtitle-text {
  max-width: 66ch;
  color: #344054;
  margin-bottom: 0;
  line-height: 26px;
}

.post-subtitle-wrap {
  margin-top: 40px;
  margin-bottom: 60px;
}

.reading-time-wrap,
.fields-wrapper,
.author-wrap {
  grid-column-gap: 15px;
  align-items: center;
  display: flex;
}

.date-wrap {
  grid-column-gap: 5px;
  border-left: 0.5px solid rgba(152, 162, 179, 0.4);
  padding-left: 15px;
  display: flex;
}

.category-wrap {
  border-left: 1px rgba(152, 162, 179, 0.8);
  padding-left: 0;
}

.post-author-image {
  width: 42px;
  height: 42px;
  border-radius: 50%;
}

.reading-time-text {
  grid-column-gap: 3.5px;
  color: #667085;
  background-color: #eff0f4;
  border: 1px dashed #d0d5dd;
  border-radius: 10px;
  align-items: center;
  padding: 7px 10px;
  font-family: Geistmono, sans-serif;
  font-weight: 500;
  line-height: 18px;
  display: flex;
}

.category-text {
  color: #0081f1;
  font-size: 16px;
  font-weight: 500;
  line-height: 23px;
}

.category-nav-btn {
  transition: color 0.15s ease, border-color 0.15s ease;
}

.category-nav-btn:hover:not(.category-nav-btn--active) {
  color: #f5c4b8 !important;
}

.category-nav-btn--active {
  color: #c93312 !important;
  font-weight: 700 !important;
}

/* Categories page — main category navigation bar */
.category-nav-bar {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 14px;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.06);
  overflow: visible;
  position: relative;
}

.category-nav-bar__list {
  display: flex;
  flex-wrap: nowrap;
  gap: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0.35rem 0.5rem;
  scrollbar-width: thin;
}

.category-nav-bar__list::-webkit-scrollbar {
  height: 6px;
}

.category-nav-bar__list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 999px;
}

.category-nav-bar__item {
  flex: 1 1 0;
  min-width: 108px;
  position: relative;
}

.category-nav-bar__trigger {
  align-items: center;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  border-radius: 10px;
  color: #333;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  justify-content: center;
  min-height: 88px;
  padding: 0.65rem 0.5rem 0.55rem;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;
  width: 100%;
}

.category-nav-bar__trigger:hover,
.category-nav-bar__item--open .category-nav-bar__trigger {
  background: rgba(201, 51, 18, 0.04);
}

.category-nav-bar__trigger--active {
  border-bottom-color: #c93312;
  color: #c93312;
}

.category-nav-bar__icon {
  height: 28px;
  object-fit: contain;
  width: 28px;
}

.category-nav-bar__icon--fallback {
  align-items: center;
  color: #666;
  display: flex;
  flex-shrink: 0;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.category-nav-bar__icon--fallback svg {
  display: block;
}

.category-nav-bar__trigger--active .category-nav-bar__icon--fallback {
  color: #c93312;
}

.category-nav-bar__label {
  align-items: center;
  display: grid;
  font-size: 0.82rem;
  font-weight: 600;
  grid-template-columns: 1fr auto 1fr;
  line-height: 1.25;
  width: 100%;
}

.category-nav-bar__label-text {
  grid-column: 2;
  text-align: center;
}

.category-nav-bar__chevron {
  align-self: center;
  grid-column: 3;
  justify-self: start;
  margin-left: 0.1rem;
}

.category-nav-bar--panel-open .category-nav-bar__list {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.category-nav-bar__mega-panel {
  animation: categoryMegaFadeIn 0.15s ease;
  background: #fafafa;
  border-radius: 0 0 14px 14px;
  overflow: hidden;
}

@keyframes categoryMegaFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.category-nav-bar__mega-columns {
  display: flex;
  min-height: 220px;
}

.category-nav-bar__mega-columns--stacked {
  flex-direction: column;
  min-height: 0;
}

.category-nav-bar__mega-columns--subs-only {
  min-height: 0;
}

.category-nav-bar__mega-columns--subs-only .category-nav-bar__mega-col--subs {
  border-right: none;
  width: 100%;
}

.category-nav-bar__mega-col {
  padding: 1rem 1.15rem;
}

.category-nav-bar__mega-col--subs {
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  min-width: 240px;
  width: 38%;
}

.category-nav-bar__mega-columns--stacked .category-nav-bar__mega-col--subs {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  border-right: none;
  min-width: 0;
  width: 100%;
}

.category-nav-bar__mega-col--subsubs {
  flex: 1;
  min-width: 0;
}

.category-nav-bar__mega-heading {
  color: #6c757d;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  margin-bottom: 0.65rem;
  text-transform: uppercase;
}

.category-nav-bar__sub-list {
  list-style: none;
  margin: 0;
  max-height: 320px;
  overflow-y: auto;
  padding: 0;
}

.category-nav-bar__sub-btn {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #222;
  cursor: pointer;
  display: flex;
  font-size: 0.9rem;
  font-weight: 500;
  gap: 0.5rem;
  justify-content: space-between;
  padding: 0.65rem 0.75rem;
  text-align: left;
  transition: background 0.15s ease, color 0.15s ease;
  width: 100%;
}

.category-nav-bar__sub-btn:hover,
.category-nav-bar__sub-btn--hover {
  background: rgba(201, 51, 18, 0.08);
  color: #c93312;
}

.category-nav-bar__sub-btn--active {
  background: rgba(201, 51, 18, 0.14);
  color: #c93312;
  font-weight: 600;
}

.category-nav-bar__subsub-list--panel {
  list-style: none;
  margin: 0;
  max-height: 320px;
  overflow-y: auto;
  padding: 0;
}

.category-nav-bar__subsub-btn {
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #444;
  cursor: pointer;
  display: block;
  font-size: 0.875rem;
  padding: 0.55rem 0.75rem;
  text-align: left;
  transition: background 0.15s ease, color 0.15s ease;
  width: 100%;
}

.category-nav-bar__subsub-btn:hover,
.category-nav-bar__subsub-btn--active {
  background: rgba(201, 51, 18, 0.08);
  color: #c93312;
  font-weight: 600;
}

.category-nav-bar__view-all {
  align-items: center;
  background: #fff;
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  color: #c93312;
  cursor: pointer;
  display: flex;
  font-size: 0.88rem;
  font-weight: 700;
  gap: 0.25rem;
  justify-content: flex-start;
  padding: 0.85rem 1.15rem;
  width: 100%;
}

.category-nav-bar__view-all:hover {
  background: rgba(201, 51, 18, 0.04);
}

.category-nav-bar__empty {
  color: #6c757d;
  font-size: 0.85rem;
  padding: 0.5rem 0.75rem;
}

@media (max-width: 991px) {
  .category-nav-bar__list {
    display: grid;
    gap: 0.3rem;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    overflow-x: hidden;
    padding: 0.4rem;
  }

  .category-nav-bar__item {
    min-width: 0;
  }

  .category-nav-bar__trigger {
    min-height: 78px;
    padding: 0.55rem 0.35rem 0.5rem;
  }

  .category-nav-bar__icon,
  .category-nav-bar__icon--fallback {
    height: 24px;
    width: 24px;
  }

  .category-nav-bar__label {
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 0.76rem;
    gap: 0.1rem;
    width: 100%;
  }

  .category-nav-bar__label-text {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    line-height: 1.15;
    max-width: 100%;
    overflow: hidden;
    text-align: center;
    white-space: normal;
    word-break: break-word;
  }

  .category-nav-bar__chevron {
    display: none;
  }

  .category-nav-bar__mega-columns {
    min-height: 0;
  }
}

@media (max-width: 767px) {
  .category-nav-bar {
    border-radius: 12px;
  }

  .category-nav-bar__list {
    gap: 0.35rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 0.5rem;
  }

  .category-nav-bar__item {
    min-width: 0;
  }

  .category-nav-bar__trigger {
    min-height: 84px;
    padding: 0.55rem 0.4rem 0.5rem;
  }

  .category-nav-bar__label {
    font-size: 0.74rem;
  }

  .category-nav-bar__mega-panel {
    border-radius: 0 0 12px 12px;
  }

  .category-nav-bar__mega-col {
    padding: 0.85rem 1rem;
  }
}

.category-selection-breadcrumb {
  padding-left: 0.25rem;
  border-left: 2px solid #dee2e6;
  margin-left: 0.25rem;
  padding-left: 0.75rem;
}

/* Blog detail page */
.blog-detail__article {
  max-width: 100%;
  width: 100%;
}

.blog-detail__title {
  color: #1e1e1e;
  font-family: "Helvetica Bold", Helvetica, Arial, sans-serif;
  font-size: clamp(1.5rem, 5vw, 2.75rem);
  font-weight: 700;
  line-height: 1.3;
  margin: 0 0 1rem;
  max-width: 100%;
  word-break: break-word;
}

/* article post content */

.article p {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: #0f141f;
  letter-spacing: -0.14px;
  margin-bottom: 14px;
  white-space: pre-wrap;
  word-break: break-word;
}

.article a {
  color: #0a8bfe;
}

.article em {
  background-color: #dcf6e1;
  font-style: normal;
}

.article img {
  display: block;
  max-width: 100%;
  border-radius: 8px;
}

.article ul,
.article ol {
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.article ul li,
.article ol li {
  font-size: 16px;
}

.article h2,
.article h3,
.article h4,
.article h5,
.article h6 {
  color: #0f141f;
  margin-bottom: 25px;
  margin-top: 50px;
  line-height: 1.3;
}

.article blockquote {
  /* border-left: 5px dashed #d0d5dd; */
  border: 1px solid #eaeaea;
  border-radius: 12px;
  padding: 20px 30px;
  font-size: 16px;
  line-height: 2;
  color: #344054;
  margin-top: 30px;
  margin-bottom: 30px;
  background: #f2f4f7;
}

.article figure {
  max-width: 100%;
  border-radius: 8px;
}

.article video {
  border-radius: 8px;
}

.sidebar-cta {
  background-color: #fff;
  border: 1px dashed #d0d5dd;
  border-radius: 14px;
  padding: 30px;
  display: block;
}

.sidebar-cta-paragraph {
  letter-spacing: -0.04px;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 21px;
}

.sidebar-cta-button {
  background-color: #0081f1;
  border-radius: 10px;
  justify-content: space-between;
  align-items: center;
  padding: 11.5px 15px;
  display: flex;
  cursor: pointer;
  gap: 8px;
}

.sidebar-cta-button:hover {
  background-color: #006adc;
}

.sidebar-cta-text {
  color: #fff;
  font-size: 12.8px;
  font-weight: 600;
  line-height: 1;
}

.after-blog-post-container {
  color: #fff;
  border: 1px solid #dfe3e6;
  background-color: transparent;
  background-image: radial-gradient(at top center, #172a3f 0%, #0f1720 63%);
  border-radius: 8px;
  padding-left: 20px;
  padding-right: 20px;
  max-width: 1114px;
  margin-left: auto;
  margin-right: auto;
  padding: 48px 0 64px 0;
  grid-row-gap: 20px;
  flex-direction: column;
  align-items: center;
  text-align: center;
  display: flex;
  margin-bottom: 150px;
}

.after-blog-post-container .forminator-custom-form {
  max-width: 360px;
}

.related-articles-container {
  max-width: 1114px;

  margin-left: auto;
  margin-right: auto;
  grid-row-gap: 20px;
  flex-direction: column;
  align-items: center;
  display: flex;
  padding-bottom: 20px;
}

.related-articles-container .collection-title {
  margin: 20px 0 60px 0;
}

.related-collection-list {
  grid-column-gap: 14px;
  grid-row-gap: 14px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  align-content: stretch;
  justify-content: stretch;
  margin: -1px;
  display: grid;
}

.post-card-wrapper {
  font-weight: normal;
}

.blog-cta-block {
  border-radius: 8px;
  border: 1px solid #b7d9f8;
  padding: 24px;
  width: 100%;
  background-color: #edf6ff;
  flex-direction: column;
  align-items: flex-start;
  display: flex;
}
.slider-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: auto;
}

.slider-container img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease-in-out;
}

.image-slide-in-right {
  animation: slideInRight 0.3s ease-in-out forwards;
}

.image-slide-out-left {
  animation: slideOutLeft 0.3s ease-in-out forwards;
}

.image-slide-in-left {
  animation: slideInLeft 0.3s ease-in-out forwards;
}

.image-slide-out-right {
  animation: slideOutRight 0.3s ease-in-out forwards;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOutLeft {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-100%);
    opacity: 0;
  }
}

@keyframes slideInLeft {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOutRight {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

/* Slider button styles */
.slider-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background: linear-gradient(135deg, #ff3e1f, #ff6b4e);
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
}

.slider-button svg {
  color: #fff;
  font-size: 18px;
}

.slider-button:hover:not(.disabled) {
  background: linear-gradient(135deg, #e63515, #f75a3d);
  transform: scale(1.1);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

.slider-button.disabled {
  background: #ccc;
  cursor: not-allowed;
  box-shadow: none;
}

.slider-button.disabled svg {
  color: #888;
}

/* Adjust spacing for buttons */
.d-flex.justify-content-end.gap-3 {
  margin-right: 10px;
}

/* Slider Image Animation */
@keyframes slideInFromRight {
  0% {
    opacity: 0;
    transform: translateX(20%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideOutToLeft {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-20%);
  }
}

@keyframes slideInFromLeft {
  0% {
    opacity: 0;
    transform: translateX(-20%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideOutToRight {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(20%);
  }
}

.image-slide-in-right {
  animation: slideInFromRight 0.8s ease-in-out;
}

.image-slide-out-left {
  animation: slideOutToLeft 0.8s ease-in-out;
}

.image-slide-in-left {
  animation: slideInFromLeft 0.8s ease-in-out;
}

.image-slide-out-right {
  animation: slideOutToRight 0.8s ease-in-out;
}

/* Button Hover Animation */
@keyframes buttonHover {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  }
  100% {
    transform: scale(1.1);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
}

.arrow-button {
  cursor: pointer;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
}

.arrow-button:hover {
  animation: buttonHover 0.3s ease-in-out forwards;
}

/* Optional: Styling for the buttons to make them more visible */
.arrow-button {
  font-size: 48px;
  padding: 10px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.1);
  color: #000;
}

/* Adding transitions for the entire slider section */
.slider-container {
  transition:
    transform 0.8s ease-in-out,
    opacity 0.8s ease-in-out;
}

.blog-cta-block .actions-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.blog-cta-block .actions-wrapper span {
  font-size: 12px;
  color: #00254d;
}

.blog-cta-block .letter-heading {
  font-size: 24px;
}

.blog-cta-block .letter-paragraph,
.blog-cta-block .letter-heading {
  margin-top: 0;
  margin-bottom: 0;
  line-height: 1.5;
}

.blog-cta-block .actions-wrapper {
  align-items: center;
}

.blog-cta-block .letter-heading {
  color: #006adc;
}

.blog-cta-block .letter-paragraph {
  color: #00254d;
}

.blog-cta-block .secondary-button {
  background-color: #fff;
  border-radius: 10px;
  justify-content: space-between;
  align-items: center;
  padding: 11.5px 15px;
  display: flex;
  cursor: pointer;
  border: 1px solid #d0d5dd;
}

.blog-cta-block .secondary-button:hover {
  background-color: #eceef0;
}

.blog-cta-block .secondary-button-text {
  color: #0f1720;
  font-size: 12.8px;
  font-weight: 600;
  line-height: 1;
}

.after-blog-post-container .actions-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.custom-blog-post .video-wrapper {
  padding: 0 24px;
  margin-bottom: 110px;
}

.custom-blog-post .video-wrapper video {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0px 0px 0px 8px #0081f1;
}

.after-blog-post-container .actions-wrapper span {
  font-size: 12px;
  color: #7e868c;
}
.comments-area a,
.page-content a {
  text-decoration: underline;
}

.alignright {
  float: right;
  margin-left: 1rem;
}

.alignleft {
  float: left;
  margin-right: 1rem;
}

.aligncenter {
  clear: both;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.alignwide {
  margin-left: -80px;
  margin-right: -80px;
}

.alignfull {
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  max-width: 100vw;
}

.alignfull,
.alignfull img {
  width: 100vw;
}

.wp-caption {
  margin-bottom: 1.25rem;
  max-width: 100%;
}

.wp-caption.alignleft {
  margin: 5px 20px 20px 0;
}

.wp-caption.alignright {
  margin: 5px 0 20px 20px;
}

.wp-caption img {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.wp-caption-text {
  margin: 0;
}

.gallery-caption {
  display: block;
  font-size: 0.8125rem;
  line-height: 1.5;
  margin: 0;
  padding: 0.75rem;
}

.pagination {
  margin: 20px auto;
}

.sticky {
  position: relative;
  display: block;
}

.bypostauthor {
  font-size: inherit;
}

.hide {
  display: none !important;
}

.post-password-form p {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
}

.post-password-form [type="submit"] {
  margin-left: 3px;
}

.screen-reader-text {
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  position: absolute !important;
  width: 1px;
  word-wrap: normal !important;
}

.screen-reader-text:focus {
  background-color: #eee;
  clip: auto !important;
  -webkit-clip-path: none;
  clip-path: none;
  color: #333;
  display: block;
  font-size: 1rem;
  height: auto;
  left: 5px;
  line-height: normal;
  padding: 15px 23px 14px;
  text-decoration: none;
  top: 5px;
  width: auto;
  z-index: 100000;
}

.site-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-top: 1rem;
  padding-bottom: 1rem;
  position: relative;
}

.site-header .site-navigation {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.site-header .site-branding {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.site-header .header-inner {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.site-header .header-inner .custom-logo-link {
  display: block;
}

.site-header .header-inner .site-branding .site-description,
.site-header .header-inner .site-branding .site-title {
  margin: 0;
}

.site-header .header-inner .site-branding.show-logo .site-title,
.site-header .header-inner .site-branding.show-title .site-logo {
  display: none !important;
}

.site-header:not(.header-stacked) .header-inner .site-branding {
  max-width: 30%;
}

.site-header:not(.header-stacked) .header-inner .site-navigation {
  max-width: 70%;
}

.site-header.header-inverted .header-inner {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
}

.site-header.header-inverted .header-inner .site-branding {
  text-align: right;
}

.site-header.header-inverted .header-inner .site-navigation {
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: start;
}

.site-header.header-stacked .header-inner {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  text-align: center;
}

@media (max-width: 576px) {
  .site-header .header-inner:not(.header-stacked) .site-branding {
    max-width: 80%;
  }
}

.site-footer {
  padding-top: 1rem;
  padding-bottom: 1rem;
  position: relative;
}

.site-footer .footer-inner {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.site-footer .footer-inner .custom-logo-link {
  display: block;
}

.site-footer .footer-inner .site-navigation {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.site-footer .footer-inner .site-branding {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.site-footer .footer-inner .site-branding .site-description,
.site-footer .footer-inner .site-branding .site-title {
  margin: 0;
}

.site-footer .footer-inner .site-branding.show-logo .site-title,
.site-footer .footer-inner .site-branding.show-title .site-logo {
  display: none !important;
}

.site-footer .footer-inner .copyright {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.site-footer .footer-inner .copyright p {
  margin: 0;
}

.site-footer.footer-inverted .footer-inner {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
}

.site-footer.footer-inverted .footer-inner .site-branding {
  text-align: right;
}

.site-footer.footer-inverted .footer-inner .site-navigation {
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.site-footer.footer-has-copyright .footer-inner .site-navigation {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.site-footer.footer-stacked .footer-inner {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  text-align: center;
}

.site-footer.footer-stacked .footer-inner .site-branding h4.site-title {
  text-align: center;
}

.site-footer.footer-stacked .footer-inner .site-navigation .menu {
  padding: 0;
}

.site-footer:not(.footer-stacked) .footer-inner .site-branding {
  max-width: 20%;
}

.site-footer:not(.footer-stacked) .footer-inner .site-navigation {
  max-width: 60%;
}

.site-footer:not(.footer-stacked) .footer-inner .copyright {
  max-width: 20%;
}

@media (max-width: 576px) {
  .site-footer:not(.footer-stacked) .footer-inner .copyright,
  .site-footer:not(.footer-stacked) .footer-inner .site-branding,
  .site-footer:not(.footer-stacked) .footer-inner .site-navigation {
    display: block;
    text-align: center;
    width: 100%;
    max-width: none;
  }

  .site-footer .footer-inner .site-navigation ul.menu {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .site-footer .footer-inner .site-navigation ul.menu li {
    display: inline-block;
  }
}

.post .entry-title a {
  text-decoration: none;
}

.post .wp-post-image {
  width: 100%;
  max-height: 500px;
  -o-object-fit: cover;
  object-fit: cover;
}

@media (max-width: 991px) {
  .post .wp-post-image {
    max-height: 400px;
  }
}

@media (max-width: 575px) {
  .post .wp-post-image {
    max-height: 300px;
  }
}

#comments .comment-list {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 0.9em;
}

#comments .comment,
#comments .pingback {
  position: relative;
}

#comments .comment .comment-body,
#comments .pingback .comment-body {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 30px 0 30px 60px;
  border-bottom: 1px solid #ccc;
}

body.rtl #comments .comment .comment-body,
body.rtl #comments .pingback .comment-body {
  padding: 30px 60px 30px 0;
}

.thumbnail-container {
  position: relative;
  display: inline-block;
}

.delete-icon {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 10;
  transition: opacity 0.2s;
}

.delete-button {
  cursor: pointer;
  background-color: white;
  border-radius: 50%;
  padding: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.delete-button:hover {
  background-color: #f5f5f5;
}

#comments .comment .avatar,
#comments .pingback .avatar {
  position: absolute;
  left: 0;
  border-radius: 50%;
  margin-right: 10px;
}

body.rtl #comments .comment .avatar,
body.rtl #comments .pingback .avatar {
  left: auto;
  right: 0;
  margin-right: 0;
  margin-left: 10px;
}

#comments .comment-meta {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-bottom: 0.9rem;
}

#comments .comment-metadata,
#comments .reply {
  font-size: 11px;
  line-height: 1;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Slightly darker for better contrast */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure it is above other content */
  backdrop-filter: blur(10px); /* Blurring the background */
  animation: fadeIn 0.5s ease-in-out; /* Smooth fade-in effect */
}

.loader-icon {
  border: 6px solid rgba(255, 255, 255, 0.3);
  border-top: 6px solid white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite; /* Spinning loader icon */
  margin-bottom: 20px;
}

.loader-text {
  font-size: 24px;
  color: white;
  font-weight: bold;
  text-align: center;
  animation: pulse 1.5s infinite; /* Pulsing effect for the text */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6); /* Subtle shadow for better readability */
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.loader-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.1),
    rgba(0, 0, 0, 0.1)
  );
  z-index: -1;
  pointer-events: none;
}

#comments .children {
  position: relative;
  list-style: none;
  margin: 0;
  padding-left: 30px;
}

body.rtl #comments .children {
  padding-left: 0;
  padding-right: 30px;
}

#comments .children li:last-child {
  padding-bottom: 0;
}

#comments ol.comment-list .children:before {
  display: inline-block;
  font-size: 1em;
  font-weight: 400;
  line-height: 100%;
  content: "\\21AA";
  position: absolute;
  top: 45px;
  left: 0;
  width: auto;
}

body.rtl #comments ol.comment-list .children:before {
  content: "\\21A9";
  left: auto;
  right: 0;
}

@media (min-width: 768px) {
  #comments .comment-author,
  #comments .comment-metadata {
    line-height: 1;
  }
}

@media (min-width: 1800px) {
  .stepper-modal {
    max-width: 70% !important;
  }
}

@media (max-width: 767px) {
  #comments .comment .comment-body {
    padding: 30px 0;
  }

  #comments .children {
    padding-left: 20px;
  }

  #comments .comment .avatar {
    position: inherit;
    float: left;
  }

  body.rtl #comments .comment .avatar {
    float: right;
  }
}

.site-header.header-inverted .site-navigation-toggle-holder {
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.site-header.header-stacked .site-navigation-toggle-holder {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  max-width: 100%;
}

.site-header.menu-layout-dropdown .site-navigation {
  display: none;
}

.site-navigation-toggle-holder {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 20%;
  padding: 8px 15px;
}

.site-navigation-toggle-holder,
.site-navigation-toggle-holder .site-navigation-toggle {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.site-navigation-toggle-holder .site-navigation-toggle {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 22px;
  padding: 0.25em;
  cursor: pointer;
  border: 0 solid;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.05);
  color: #494c4f;
}

.site-navigation-toggle-holder.elementor-active
  .site-navigation-toggle
  i:before {
  content: "\\e87f";
}

.site-navigation {
  grid-area: nav-menu;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

.site-navigation ul.menu,
.site-navigation ul.menu ul {
  list-style-type: none;
  padding: 0;
}

.site-navigation ul.menu {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.site-navigation ul.menu li {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.site-navigation ul.menu li a {
  display: block;
  padding: 8px 15px;
}

.site-navigation ul.menu li.menu-item-has-children {
  padding-right: 15px;
}

.site-navigation ul.menu li.menu-item-has-children:after {
  display: block;
  content: "\\25BE";
  font-size: 1.5em;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #666;
  position: absolute;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  text-decoration: none;
}

.site-navigation ul.menu li.menu-item-has-children:focus-within > ul {
  display: block;
}

.site-navigation ul.menu li ul {
  background: #fff;
  display: none;
  min-width: 150px;
  position: absolute;
  z-index: 2;
  left: 0;
  top: 100%;
}

.site-navigation ul.menu li ul li {
  border-bottom: 1px solid #eee;
}

.site-navigation ul.menu li ul li:last-child {
  border-bottom: none;
}

.site-navigation ul.menu li ul li.menu-item-has-children a {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

.site-navigation ul.menu li ul li.menu-item-has-children:after {
  -webkit-transform: translateY(-50%) rotate(-90deg);
  -ms-transform: translateY(-50%) rotate(-90deg);
  transform: translateY(-50%) rotate(-90deg);
}

.site-navigation ul.menu li ul ul {
  left: 100%;
  top: 0;
}

.site-navigation ul.menu li:hover > ul {
  display: block;
}

footer .site-navigation ul.menu li ul {
  top: auto;
  bottom: 100%;
}

footer .site-navigation ul.menu li ul ul {
  bottom: 0;
}

footer .site-navigation ul.menu a {
  padding: 5px 15px;
}

.site-navigation-dropdown {
  margin-top: 10px;
  -webkit-transition:
    max-height 0.3s,
    -webkit-transform 0.3s;
  transition:
    max-height 0.3s,
    -webkit-transform 0.3s;
  -o-transition:
    max-height 0.3s,
    transform 0.3s;
  transition:
    max-height 0.3s,
    transform 0.3s;
  transition:
    max-height 0.3s,
    transform 0.3s,
    -webkit-transform 0.3s;
  -webkit-transform-origin: top;
  -ms-transform-origin: top;
  transform-origin: top;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
}

.site-navigation-toggle-holder:not(.elementor-active)
  + .site-navigation-dropdown {
  -webkit-transform: scaleY(0);
  -ms-transform: scaleY(0);
  transform: scaleY(0);
  max-height: 0;
}

.site-navigation-toggle-holder.elementor-active + .site-navigation-dropdown {
  -webkit-transform: scaleY(1);
  -ms-transform: scaleY(1);
  transform: scaleY(1);
  max-height: 100vh;
}

.site-navigation-dropdown ul {
  padding: 0;
}

.site-navigation-dropdown ul.menu {
  position: absolute;
  width: 100%;
  padding: 0;
  margin: 0;
  background: #fff;
}

.site-navigation-dropdown ul.menu li {
  display: block;
  width: 100%;
  position: relative;
}

.site-navigation-dropdown ul.menu li a {
  display: block;
  padding: 20px;
  background: #fff;
  color: #55595c;
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.10196078431372549);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.10196078431372549);
}

.site-navigation-dropdown ul.menu li.current-menu-item a {
  color: #fff;
  background: #55595c;
}

.site-navigation-dropdown ul.menu > li li {
  -webkit-transition:
    max-height 0.3s,
    -webkit-transform 0.3s;
  transition:
    max-height 0.3s,
    -webkit-transform 0.3s;
  -o-transition:
    max-height 0.3s,
    transform 0.3s;
  transition:
    max-height 0.3s,
    transform 0.3s;
  transition:
    max-height 0.3s,
    transform 0.3s,
    -webkit-transform 0.3s;
  -webkit-transform-origin: top;
  -ms-transform-origin: top;
  transform-origin: top;
  -webkit-transform: scaleY(0);
  -ms-transform: scaleY(0);
  transform: scaleY(0);
  max-height: 0;
}

.site-navigation-dropdown ul.menu li.elementor-active > ul > li {
  -webkit-transform: scaleY(1);
  -ms-transform: scaleY(1);
  transform: scaleY(1);
  max-height: 100vh;
}
.no-hover-img:hover img {
  transform: none !important;
}
@media (max-width: 576px) {
  .site-header.menu-dropdown-mobile:not(.menu-layout-dropdown)
    .site-navigation {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .site-header.menu-dropdown-mobile:not(.menu-layout-dropdown)
    .site-navigation-toggle-holder {
    display: none !important;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .site-header.menu-dropdown-mobile:not(.menu-layout-dropdown)
    .site-navigation {
    display: none !important;
  }
}

@media (min-width: 992px) {
  .site-header.menu-dropdown-tablet:not(.menu-layout-dropdown)
    .site-navigation-toggle-holder {
    display: none !important;
  }
}

@media (max-width: 992px) {
  .site-header.menu-dropdown-tablet:not(.menu-layout-dropdown)
    .site-navigation {
    display: none !important;
  }
}

.site-header.menu-dropdown-none:not(.menu-layout-dropdown)
  .site-navigation-toggle-holder {
  display: none !important;
}

.page-header .entry-title,
.site-footer .footer-inner,
.site-footer:not(.dynamic-footer),
.site-header .header-inner,
.site-header:not(.dynamic-header),
body:not([class*="elementor-page-"]) .site-main {
  margin-right: auto;
  margin-left: auto;
  width: 100%;
}

@media (max-width: 575px) {
  .page-header .entry-title,
  .site-footer .footer-inner,
  .site-footer:not(.dynamic-footer),
  .site-header .header-inner,
  .site-header:not(.dynamic-header),
  body:not([class*="elementor-page-"]) .site-main {
    padding-right: 10px;
    padding-left: 10px;
  }
}

@media (min-width: 576px) {
  .page-header .entry-title,
  .site-footer .footer-inner,
  .site-footer:not(.dynamic-footer),
  .site-header .header-inner,
  .site-header:not(.dynamic-header),
  body:not([class*="elementor-page-"]) .site-main {
    max-width: 500px;
  }

  .site-footer.footer-full-width .footer-inner,
  .site-header.header-full-width .header-inner {
    max-width: 100%;
  }
}

@media (min-width: 768px) {
  .page-header .entry-title,
  .site-footer .footer-inner,
  .site-footer:not(.dynamic-footer),
  .site-header .header-inner,
  .site-header:not(.dynamic-header),
  body:not([class*="elementor-page-"]) .site-main {
    max-width: 600px;
  }

  .site-footer.footer-full-width,
  .site-header.header-full-width {
    max-width: 100%;
  }
}

@media (min-width: 992px) {
  .page-header .entry-title,
  .site-footer .footer-inner,
  .site-footer:not(.dynamic-footer),
  .site-header .header-inner,
  .site-header:not(.dynamic-header),
  body:not([class*="elementor-page-"]) .site-main {
    max-width: 800px;
  }

  .site-footer.footer-full-width,
  .site-header.header-full-width {
    max-width: 100%;
  }
}

@media (min-width: 1200px) {
  .page-header .entry-title,
  .site-footer .footer-inner,
  .site-footer:not(.dynamic-footer),
  .site-header .header-inner,
  .site-header:not(.dynamic-header),
  body:not([class*="elementor-page-"]) .site-main {
    max-width: 1140px;
  }

  .site-footer.footer-full-width,
  .site-header.header-full-width {
    max-width: 100%;
  }
}

.site-header + .elementor {
  min-height: calc(100vh - 320px);
}

@media screen and (max-width: 1440px) {
  .related-collection-list {
    margin-bottom: -2px;
  }
}

@media screen and (max-width: 991px) {
  .article {
    padding: 40px 30px 40px 20px;
  }
  .related-collection-list {
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 767px) {
  .post-head {
    padding-top: 30px;
    padding-left: 30px;
    padding-right: 30px;
  }
  .article-grid {
    grid-template-columns: 1fr;
  }
  .sidebar {
    padding-top: 40px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .post-fields-wrap {
    width: 100%;
    grid-row-gap: 15px;
    flex-direction: column;
    margin-bottom: 30px;
  }
  .post-main-heading {
    font-size: 30px;
    line-height: 42px;
  }
  .post-subtitle-wrap {
    margin-top: 25px;
    margin-bottom: 35px;
  }
  .post-subtitle-text {
    font-size: 14px;
  }

  .reading-time-wrap {
    align-items: center;
    margin-right: auto;
  }

  .fields-wrapper {
    width: 100%;
    flex-direction: row;
  }
  .category-text {
    font-size: 14px;
  }
  .related-collection-list {
    grid-template-rows: auto;
    grid-template-columns: 1fr;
  }
  .post-head,
  .article-grid {
    border-radius: 0;
  }
  .related-articles-container {
    padding: 0 20px;
  }
  .after-blog-post-container {
    margin-left: 20px;
    margin-right: 20px;
  }
}

@media screen and (max-width: 479px) {
  .site-main.custom-blog_post {
    padding-top: 20px;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .post-head {
    padding: 20px 20px 0;
  }
  .article-grid {
    grid-template-rows: auto auto;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    overflow: hidden;
  }

  .article {
    padding-right: 20px;
  }

  .sidebar {
    border-left-style: none;
    order: -9999;
    padding: 40px 20px 10px 20px;
  }
  .sidebar-sticky #ez-toc-container {
    margin-bottom: 40px;
  }
  .post-fields-wrap {
    grid-row-gap: 10px;
    margin-bottom: 0;
    padding-bottom: 20px;
  }
  .post-main-heading {
    font-size: 27.8px;
  }

  .post-subtitle-text {
    max-width: 100%;
    line-height: 23px;
  }

  .reading-time-wrap {
    grid-column-gap: 15px;
    align-items: center;
    display: flex;
  }

  .fields-wrapper {
    grid-column-gap: 10px;
    justify-content: flex-start;
  }

  .author-wrap {
    grid-column-gap: 10px;
  }

  .date-wrap {
    border-left-color: rgba(152, 162, 179, 0.4);
    align-items: center;
    padding-left: 10px;
    font-size: 12px;
  }

  .category-wrap {
    border-left-style: none;
    padding-left: 0;
  }

  .post-author-image {
    width: 24px;
    height: 24px;
  }

  .post-date {
    font-size: 12px;
  }

  .reading-time-text {
    padding: 4px 6px;
    font-size: 12px;
  }
  .category-text {
    font-size: 12px;
  }
  #ez-toc-container {
    padding: 0;
  }
  .after-blog-post-container {
    padding: 20px;
  }
  .blog-cta-block {
    padding: 20px;
    grid-row-gap: 16px;
  }
  .blog-cta-block .letter-heading {
    font-size: 24px;
  }

  .blog-cta-block .letter-paragraph {
    white-space: normal;
    margin: 10px 0;
  }
  .blog-cta-block .actions-wrapper {
    flex-direction: column;
  }
  .related-articles-container .collection-title {
    margin: 20px 0 30px 0;
  }
  .post-card-heading {
    min-height: 10px;
  }
}

/* Add more common styles as needed */

/* media query */

@media (min-width: 940px) and (max-width: 1170px) {
  .main-content {
    padding-bottom: 360px !important;
  }
}
@media (max-width: 1024px) {
  .main-wrapper {
    position: relative;
  }

  html body h1 {
    font-size: 3.6rem !important;
  }

  .back-arrow {
    left: 0px;
    top: -36px;
  }
}

@media (max-width: 900px) {
  .navbar {
    background-color: #c93312 !important;
  }
}
@media (max-width: 768px) {
  .navbar {
    background-color: #c93312 !important;
  }

  .seller-popup .modal-content {
    margin-bottom: 0vh;
  }

  .sales-items-wrapper h5 {
    font-size: 17px;
    margin-bottom: 4px;
  }

  .sales-items-wrapper p {
    font-size: 15px;
  }

  .card .card-body {
    padding: 12px;
  }

  body {
    font-size: 16px;
  }

  p.large {
    font-size: 17px;
  }

  .mb-hidden {
    display: none !important;
  }

  .modal-width {
    max-width: calc(100% - 24px) !important;
    margin: 12px auto !important;
  }

  .modal-width .modal-content {
    height: auto;
    max-height: 92vh;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
  }

  .seller-popup {
    max-width: 80% !important;
  }

  html body h1 {
    font-size: 2.4rem !important;
  }
  .tabs-wrapper {
    flex-wrap: wrap;
  }

  .tabs-wrapper .MuiTabs-root {
    width: 60%;
    margin: auto;
  }

  .tabs-wrapper .MuiBox-root {
    padding: 20px 10px;
  }

  .mb-radius {
    border-top-right-radius: 75px !important;
    border-bottom-left-radius: 75px !important;
  }
}

@media (max-width: 510px) {
  .btn-nav > a[href] > div {
    width: 30px;
  }
}

@media (max-width: 474px) {
  .login-btn {
    padding: 8px !important;
  }

  .login-logo {
    max-width: 170px;
  }

  .card .card-title {
    font-size: 17px;
  }

  .card .card-body {
    padding: 10px 8px;
  }

  .text-muted {
    font-size: 13px;
  }
}

/* Custom styles for Bootstrap toggle switches in cookie preferences */
.form-check-input:checked {
  background-color: #c93312 !important;
  border-color: #c93312 !important;
}

.form-check-input:focus {
  border-color: #c93312 !important;
  box-shadow: 0 0 0 0.25rem rgba(201, 51, 18, 0.25) !important;
}

.form-check-input:checked:focus {
  box-shadow: 0 0 0 0.25rem rgba(201, 51, 18, 0.25) !important;
}

/* Hide PrimeReact Image preview toolbar buttons */
.p-image-toolbar,
.p-image-preview-container .p-image-toolbar,
.p-component .p-image-toolbar,
div[data-pc-name="image"] .p-image-toolbar {
  display: none !important;
  visibility: hidden !important;
}

/* Seller dashboard */
.seller-dashboard {
  --seller-accent: #c93312;
  --seller-accent-dark: #954001;
  --seller-surface: #ffffff;
  --seller-muted: #6c757d;
  --seller-border: rgba(0, 0, 0, 0.06);
  --seller-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);
  max-width: 100%;
  overflow-x: hidden;
}

.seller-dashboard__hero {
  background: linear-gradient(135deg, #fff8f3 0%, #fff 55%, #faf6ef 100%);
  border: 1px solid var(--seller-border);
  border-radius: 20px;
  padding: 1.5rem 1.75rem;
  box-shadow: var(--seller-shadow);
}

.seller-dashboard__eyebrow {
  color: var(--seller-accent);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.seller-dashboard__title {
  color: #1a1a1a;
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  font-weight: 700;
  line-height: 1.15;
}

.seller-dashboard__subtitle {
  color: var(--seller-muted);
  font-size: 0.95rem;
  max-width: 42rem;
}

.seller-dashboard__stats-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0, 1fr);
}

@media (min-width: 576px) {
  .seller-dashboard__stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .seller-dashboard__stat-card:last-child:nth-child(3) {
    grid-column: 1 / -1;
  }
}

@media (min-width: 992px) {
  .seller-dashboard__stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .seller-dashboard__stat-card:last-child:nth-child(3) {
    grid-column: auto;
  }
}

.seller-dashboard__stat-card {
  background: var(--seller-surface);
  border: 1px solid var(--seller-border);
  border-radius: 18px;
  box-shadow: var(--seller-shadow);
  display: flex;
  gap: 1rem;
  min-height: 118px;
  min-width: 0;
  padding: 1.25rem 1.35rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

@media (hover: hover) {
  .seller-dashboard__stat-card:hover {
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
    transform: translateY(-2px);
  }
}

.seller-dashboard__stat-icon {
  align-items: center;
  border-radius: 14px;
  display: flex;
  flex-shrink: 0;
  height: 52px;
  justify-content: center;
  width: 52px;
}

.seller-dashboard__stat-icon--earnings {
  background: #e8f5e9;
  color: #2e7d32;
}

.seller-dashboard__stat-icon--listings {
  background: #e3f2fd;
  color: #1565c0;
}

.seller-dashboard__stat-icon--balance {
  background: #fff0eb;
  color: var(--seller-accent);
}

.seller-dashboard__pln-glyph,
.seller-dashboard__currency-glyph {
  font-family: "Helvetica Bold", Helvetica, Arial, sans-serif;
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1;
}

.admin-dashboard__pln-icon {
  align-items: center;
  color: #c93312;
  display: flex;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.admin-dashboard__pln-glyph {
  font-family: "Helvetica Bold", Helvetica, Arial, sans-serif;
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1;
}

.seller-dashboard__stat-label {
  color: var(--seller-muted);
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.35rem;
}

.seller-dashboard__stat-value {
  color: #111;
  font-size: clamp(1.25rem, 2.5vw, 1.75rem);
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
  overflow-wrap: anywhere;
}

.seller-dashboard__actions-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0, 1fr);
}

@media (min-width: 992px) {
  .seller-dashboard__actions-grid {
    grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
  }
}

.seller-dashboard__panel {
  background: var(--seller-surface);
  border: 1px solid var(--seller-border);
  border-radius: 20px;
  box-shadow: var(--seller-shadow);
  height: 100%;
  padding: 1.5rem;
}

.seller-dashboard__panel-header {
  align-items: flex-start;
  display: flex;
  gap: 0.875rem;
  margin-bottom: 1.25rem;
}

.seller-dashboard__panel-icon {
  align-items: center;
  background: #fff4ec;
  border-radius: 14px;
  color: var(--seller-accent-dark);
  display: flex;
  flex-shrink: 0;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.seller-dashboard__panel-title {
  color: #111;
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}

.seller-dashboard__panel-text {
  color: var(--seller-muted);
  font-size: 0.9rem;
  margin: 0;
}

.seller-dashboard__sale-form {
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0, 1fr);
}

@media (min-width: 576px) and (max-width: 991px) {
  .seller-dashboard__sale-form {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .seller-dashboard__sale-form .seller-dashboard__field:first-child {
    grid-column: 1 / -1;
  }
}

@media (min-width: 992px) {
  .seller-dashboard__sale-form {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.seller-dashboard__field-label {
  color: #444;
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.4rem;
}

.seller-dashboard__field .form-control,
.seller-dashboard__field .form-select {
  background: #f8f9fb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  min-height: 44px;
}

.seller-dashboard__field .form-control:focus,
.seller-dashboard__field .form-select:focus {
  border-color: rgba(201, 51, 18, 0.45);
  box-shadow: 0 0 0 0.2rem rgba(201, 51, 18, 0.12);
}

.seller-dashboard__btn {
  appearance: none;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.2;
  padding: 0.7rem 1.25rem;
  transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease;
}

.seller-dashboard__btn:hover:not(:disabled) {
  opacity: 0.92;
  transform: translateY(-1px);
}

.seller-dashboard__btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.seller-dashboard .seller-dashboard__btn--primary {
  background-color: #954001;
  color: #fff;
}

.seller-dashboard .seller-dashboard__btn--primary:hover:not(:disabled) {
  background-color: #7d3601;
  color: #fff;
}

.seller-dashboard .seller-dashboard__btn--primary:disabled {
  background-color: #954001;
  color: #fff;
}

.seller-dashboard .seller-dashboard__btn--danger {
  background-color: #c93312;
  color: #fff;
}

.seller-dashboard .seller-dashboard__btn--danger:hover:not(:disabled) {
  background-color: #a82910;
  color: #fff;
}

.seller-dashboard .seller-dashboard__btn--danger:disabled {
  background-color: #c93312;
  color: #fff;
}

.seller-dashboard__btn--ghost {
  background-color: #fff;
  border: 1px solid #ddd;
  color: #333;
}

.seller-dashboard__sale-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: flex-start;
  margin-top: 1.25rem;
}

.seller-dashboard__sale-actions .seller-dashboard__btn {
  flex: 1 1 140px;
  min-width: 140px;
}

.seller-dashboard__panel--sale {
  display: flex;
  flex-direction: column;
}

.seller-dashboard__sale-status {
  align-items: center;
  background: linear-gradient(90deg, #fff8f5 0%, #fff 100%);
  border: 1px solid rgba(149, 64, 1, 0.18);
  border-radius: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
}

.seller-dashboard__sale-status-label {
  color: #666;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.seller-dashboard__sale-status-value {
  color: #111;
  font-size: 0.95rem;
  font-weight: 700;
}

.seller-dashboard__sale-hint {
  color: var(--seller-muted);
  font-size: 0.85rem;
  margin-top: 0.85rem;
}

.seller-dashboard__current-sale {
  align-items: center;
  background: linear-gradient(90deg, #fff8f5 0%, #fff 100%);
  border: 1px solid rgba(149, 64, 1, 0.18);
  border-radius: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-between;
  padding: 1rem 1.25rem;
}

.seller-dashboard__current-sale-title {
  color: #111;
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.seller-dashboard__badge {
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.35rem 0.75rem;
}

.seller-dashboard__badge--active {
  background: #d1e7dd;
  color: #0f5132;
}

.seller-dashboard__badge--inactive {
  background: #e9ecef;
  color: #495057;
}

.seller-dashboard__payout-card {
  background: linear-gradient(160deg, #1f2937 0%, #111827 100%);
  border-radius: 20px;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
}

.seller-dashboard__payout-header {
  align-items: center;
  display: flex;
  gap: 0.875rem;
}

.seller-dashboard__payout-icon {
  align-items: center;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  display: flex;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.seller-dashboard__payout-label {
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.seller-dashboard__payout-title {
  color: #fff;
  font-size: 1.1rem;
  font-weight: 700;
}

.seller-dashboard__payout-copy {
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.9rem;
  line-height: 1.5;
}

.seller-dashboard__payout-footer {
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-between;
  margin-top: auto;
  padding-top: 1rem;
}

.seller-dashboard__payout-balance-label {
  color: rgba(255, 255, 255, 0.65);
  display: block;
  font-size: 0.78rem;
  margin-bottom: 0.15rem;
}

.seller-dashboard__payout-balance {
  color: #fff;
  display: block;
  font-size: 1.5rem;
  line-height: 1.1;
}


.seller-dashboard__balance-split {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.seller-dashboard__balance-row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  justify-content: space-between;
}

.seller-dashboard__balance-meta {
  align-items: center;
  display: inline-flex;
  gap: 0.45rem;
}

.seller-dashboard__balance-dot {
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.12);
  display: inline-block;
  flex: 0 0 auto;
  height: 0.55rem;
  width: 0.55rem;
}

.seller-dashboard__balance-dot--available {
  background: #34d399;
  box-shadow: 0 0 0 3px rgba(52, 211, 153, 0.22);
}

.seller-dashboard__balance-dot--pending {
  background: #fbbf24;
  box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.22);
}

.seller-dashboard__payout-balance--pending {
  color: rgba(255, 255, 255, 0.78);
  font-size: 1.2rem;
}

.seller-dashboard__stat-subvalue {
  color: #6b7280;
  font-size: 0.82rem;
  font-weight: 600;
  margin-top: 0.35rem;
}

.seller-dashboard__stat-label .seller-dashboard__balance-dot--available {
  box-shadow: 0 0 0 3px rgba(52, 211, 153, 0.18);
}

.seller-dashboard__stat-subvalue .seller-dashboard__balance-dot--pending {
  box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.18);
}

.seller-dashboard__payout-hint {
  color: rgba(255, 255, 255, 0.62);
  font-size: 0.82rem;
}

.seller-dashboard__transactions-header {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.seller-dashboard__section-title {
  color: #111;
  font-size: 1.35rem;
  font-weight: 700;
  margin: 0;
}

.seller-dashboard__billing-card {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.seller-dashboard__billing-card--pro {
  background: linear-gradient(160deg, #fffdfb 0%, #fff 45%, #fff8f3 100%);
}

.seller-dashboard__billing-title-row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.35rem;
}

.seller-dashboard__billing-stripe-icon {
  align-items: center;
  background: #f6f9fc;
  border: 1px solid #e6ebf1;
  border-radius: 14px;
  display: flex;
  flex-shrink: 0;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.seller-dashboard__billing-features {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  margin-top: 1rem;
}

.seller-dashboard__billing-feature {
  align-items: flex-start;
  color: var(--seller-muted);
  display: flex;
  font-size: 0.875rem;
  gap: 0.5rem;
  line-height: 1.45;
}

.seller-dashboard__billing-feature svg {
  color: #2e7d32;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.seller-dashboard__billing-status-text {
  color: var(--seller-muted);
  font-size: 0.9rem;
  line-height: 1.5;
  margin-top: 0.75rem;
}

.seller-dashboard__billing-actions {
  border-top: 1px solid var(--seller-border);
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: auto;
  padding-top: 1.25rem;
}

.seller-dashboard__billing-info {
  background: linear-gradient(135deg, #f8fafc 0%, #fff 100%);
}

.seller-dashboard__badge--warning {
  background: #fff3cd;
  color: #664d03;
}

@media (max-width: 575.98px) {
  .seller-dashboard__billing-title-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.35rem;
  }

  .seller-dashboard__billing-actions .seller-dashboard__btn {
    width: 100%;
  }
}

/* Stripe region selection modal (Payments connect flow) */
.stripe-region-modal .modal-content {
  border: none;
  border-radius: 20px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18);
  overflow: hidden;
}

.stripe-region-modal__header {
  background: linear-gradient(135deg, #f8fafc 0%, #fff 55%, #f6f9fc 100%);
  border-bottom: 1px solid #e8edf3;
  padding: 1.35rem 1.5rem 1.15rem;
}

.stripe-region-modal__header-content {
  align-items: flex-start;
  display: flex;
  gap: 0.85rem;
  padding-right: 1.5rem;
}

.stripe-region-modal__icon-wrap {
  align-items: center;
  background: #fff;
  border: 1px solid #e6ebf1;
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(99, 91, 255, 0.08);
  color: #635bff;
  display: flex;
  flex-shrink: 0;
  height: 44px;
  justify-content: center;
  width: 44px;
}

.stripe-region-modal__title {
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 0.35rem;
}

.stripe-region-modal__subtitle {
  color: #64748b;
  font-size: 0.875rem;
  line-height: 1.5;
}

.stripe-region-modal__body {
  padding: 1.25rem 1.5rem 0.5rem;
}

.stripe-region-modal__search-wrap {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  display: flex;
  gap: 0.65rem;
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
}

.stripe-region-modal__search-icon {
  color: #64748b;
  flex-shrink: 0;
}

.stripe-region-modal__search-input {
  background: transparent;
  border: none;
  box-shadow: none !important;
  color: #0f172a;
  font-size: 0.92rem;
  padding: 0;
}

.stripe-region-modal__search-input::placeholder {
  color: #94a3b8;
}

.stripe-region-modal__select-shell {
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
  padding: 1rem;
}

.stripe-region-modal__select-label {
  color: #475569;
  display: block;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  margin-bottom: 0.5rem;
}

.stripe-region-modal__select {
  appearance: none;
  -webkit-appearance: none;
  background:
    linear-gradient(45deg, transparent 50%, #475569 50%),
    linear-gradient(135deg, #475569 50%, transparent 50%),
    linear-gradient(to right, #fff, #fff);
  background-position:
    calc(100% - 20px) calc(50% - 3px),
    calc(100% - 14px) calc(50% - 3px),
    100% 0;
  background-repeat: no-repeat;
  background-size:
    6px 6px,
    6px 6px,
    2.75rem 100%;
  border: 1px solid #dbe4ee;
  border-radius: 14px;
  color: #0f172a;
  font-size: 0.95rem;
  font-weight: 500;
  outline: none;
  padding: 0.9rem 3rem 0.9rem 1rem;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
  width: 100%;
}

.stripe-region-modal__select:focus {
  border-color: #635bff;
  box-shadow: 0 0 0 4px rgba(99, 91, 255, 0.12);
}

.stripe-region-modal__selected-card {
  align-items: center;
  background: linear-gradient(135deg, #111827 0%, #1f2937 100%);
  border-radius: 18px;
  color: #fff;
  display: flex;
  gap: 0.9rem;
  margin-top: 1rem;
  padding: 1rem;
}

.stripe-region-modal__selected-flag {
  align-items: center;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 16px;
  display: flex;
  flex-shrink: 0;
  font-size: 1.9rem;
  height: 56px;
  justify-content: center;
  width: 56px;
}

.stripe-region-modal__selected-copy {
  flex: 1;
  min-width: 0;
}

.stripe-region-modal__selected-topline {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.3rem;
}

.stripe-region-modal__selected-name {
  font-size: 1rem;
  font-weight: 700;
}

.stripe-region-modal__selected-code {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  padding: 0.2rem 0.55rem;
}

.stripe-region-modal__selected-text {
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.84rem;
  line-height: 1.5;
}

.stripe-region-modal__selected-check {
  color: #86efac;
  flex-shrink: 0;
}

.stripe-region-modal__empty-state {
  align-items: center;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  color: #64748b;
  display: flex;
  gap: 0.55rem;
  justify-content: center;
  margin-top: 1rem;
  padding: 0.95rem 1rem;
  text-align: center;
}

.stripe-region-modal__empty-search {
  color: #b91c1c;
  font-size: 0.82rem;
  margin-top: 0.85rem;
  text-align: center;
}

.stripe-region-modal__note {
  color: #94a3b8;
  font-size: 0.78rem;
  line-height: 1.5;
  margin: 1rem 0 0;
  text-align: center;
}

.stripe-region-modal__footer {
  background: #f8fafc;
  border-top: 1px solid #e8edf3;
  gap: 0.65rem;
  justify-content: flex-end;
  padding: 1rem 1.5rem 1.25rem;
}

.stripe-region-modal__btn {
  appearance: none;
  -webkit-appearance: none;
  border: none;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.2;
  padding: 0.65rem 1.35rem;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    opacity 0.2s ease,
    transform 0.15s ease;
}

.stripe-region-modal__btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.stripe-region-modal__btn:disabled {
  cursor: not-allowed;
}

.stripe-region-modal__btn--ghost {
  background-color: transparent;
  border: 1px solid #cbd5e1;
  color: #475569;
}

.stripe-region-modal__btn--ghost:hover:not(:disabled) {
  background-color: #e8edf3;
  border-color: #94a3b8;
  color: #334155;
}

.stripe-region-modal__footer .stripe-region-modal__btn--primary {
  background-color: #111;
  border: 2px solid #111;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.18);
  color: #fff;
  min-width: 170px;
}

.stripe-region-modal__footer .stripe-region-modal__btn--primary:hover:not(:disabled) {
  background-color: #2d2d2d;
  border-color: #2d2d2d;
  color: #fff;
}

.stripe-region-modal__footer .stripe-region-modal__btn--primary:disabled {
  background-color: #94a3b8;
  border-color: #94a3b8;
  box-shadow: none;
  color: #fff;
  opacity: 1;
}

@media (max-width: 575.98px) {
  .stripe-region-modal__header,
  .stripe-region-modal__body,
  .stripe-region-modal__footer {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .stripe-region-modal__footer {
    flex-direction: column-reverse;
  }

  .stripe-region-modal__selected-card {
    align-items: flex-start;
    flex-direction: column;
  }

  .stripe-region-modal__selected-check {
    display: none;
  }

  .stripe-region-modal__btn {
    width: 100%;
  }
}

/* Dashboard sidebar (seller + user, mobile/tablet drawer + desktop) */
.dashboard-sidebar {
  background: linear-gradient(180deg, #171b26 0%, #12151d 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
}

.dashboard-sidebar__header {
  align-items: flex-start;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 1.25rem 1rem 1rem;
}

.dashboard-sidebar__brand {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  min-width: 0;
}

.dashboard-sidebar__logo {
  flex-shrink: 0;
  height: 36px;
  width: 36px;
}

.dashboard-sidebar__eyebrow {
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.dashboard-sidebar__title {
  color: #fff;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.2;
}

.dashboard-sidebar__close {
  align-items: center;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  height: 36px;
  justify-content: center;
  transition: background 0.2s ease;
  width: 36px;
}

.dashboard-sidebar__close:hover {
  background: rgba(255, 255, 255, 0.14);
}

.dashboard-sidebar__switch {
  align-items: center;
  background: linear-gradient(90deg, #c93312 0%, #a82910 100%);
  border-radius: 12px;
  color: #fff !important;
  display: flex;
  font-size: 0.875rem;
  font-weight: 600;
  gap: 0.5rem;
  justify-content: space-between;
  margin: 1rem 1rem 0.5rem;
  padding: 0.85rem 1rem;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.dashboard-sidebar__switch:hover {
  box-shadow: 0 8px 20px rgba(201, 51, 18, 0.28);
  color: #fff;
  transform: translateY(-1px);
}

.dashboard-sidebar__nav {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.35rem;
  overflow-y: auto;
  padding: 0.75rem 0.75rem 1rem;
}

.dashboard-sidebar__link {
  align-items: center;
  border-radius: 12px;
  color: rgba(255, 255, 255, 0.78);
  display: flex;
  gap: 0.75rem;
  min-height: 48px;
  padding: 0.65rem 0.85rem;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.dashboard-sidebar__link:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}

.dashboard-sidebar__link--active {
  background: rgba(201, 51, 18, 0.16);
  box-shadow: inset 3px 0 0 #c93312;
  color: #fff;
}

.dashboard-sidebar__link-icon {
  align-items: center;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  display: inline-flex;
  flex-shrink: 0;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.dashboard-sidebar__link--active .dashboard-sidebar__link-icon {
  background: rgba(201, 51, 18, 0.22);
  color: #ffb09a;
}

.dashboard-sidebar__link-label {
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.3;
}

.dashboard-sidebar__footer {
  align-items: center;
  background: rgba(255, 255, 255, 0.04);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  gap: 0.75rem;
  margin-top: auto;
  min-width: 0;
  overflow: hidden;
  padding: 1rem;
}

.dashboard-sidebar__profile {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.dashboard-sidebar__profile-name {
  color: #fff;
  font-size: 0.95rem;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-sidebar__profile-email {
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.78rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 767px) {
  .dashboard-sidebar__header {
    padding-top: 1rem;
  }

  .dashboard-sidebar__switch {
    margin-left: 0.85rem;
    margin-right: 0.85rem;
  }

  .dashboard-sidebar__nav {
    padding-left: 0.65rem;
    padding-right: 0.65rem;
  }

  .dashboard-sidebar__link {
    min-height: 50px;
  }
}

.seller-dashboard__transactions-scroll {
  -webkit-overflow-scrolling: touch;
  margin-left: -0.25rem;
  margin-right: -0.25rem;
  overflow-x: auto;
  padding-bottom: 0.25rem;
  width: 100%;
}

@media (max-width: 767px) {
  .seller-dashboard .container {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }

  .seller-dashboard__hero {
    border-radius: 16px;
    padding: 1.1rem 1rem;
  }

  .seller-dashboard__title {
    font-size: clamp(1.45rem, 6vw, 1.85rem);
  }

  .seller-dashboard__subtitle {
    font-size: 0.9rem;
  }


  .seller-dashboard__stat-card {
    min-height: 100px;
    padding: 1rem;
  }

  .seller-dashboard__stat-icon {
    height: 46px;
    width: 46px;
  }

  .seller-dashboard__panel,
  .seller-dashboard__payout-card {
    border-radius: 16px;
    padding: 1.1rem 1rem;
  }

  .seller-dashboard__panel-header {
    align-items: center;
  }

  .seller-dashboard__payout-footer {
    align-items: stretch;
    flex-direction: column;
  }

  .seller-dashboard__payout-footer .seller-dashboard__btn {
    width: 100%;
  }

  .seller-dashboard__sale-actions .seller-dashboard__btn {
    flex: 1 1 100%;
    width: 100%;
  }

  .seller-dashboard__current-sale {
    align-items: stretch;
    flex-direction: column;
  }

  .seller-dashboard__transactions-header {
    align-items: stretch;
    flex-direction: column;
  }

  .seller-dashboard__transactions-header .btn {
    width: 100%;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .seller-dashboard__hero {
    padding: 1.35rem 1.5rem;
  }

  .seller-dashboard__panel,
  .seller-dashboard__payout-card {
    padding: 1.25rem 1.35rem;
  }

  .seller-dashboard__payout-footer {
    align-items: center;
    gap: 1rem;
  }

  .seller-dashboard__current-sale {
    gap: 1rem;
  }
}

/* Site mobile/tablet nav drawer (main header hamburger menu) */
.site-mobile-nav {
  background: linear-gradient(180deg, #ffffff 0%, #faf8f5 100%);
  color: #111;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
}

.site-mobile-nav__header {
  align-items: flex-start;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 1rem 1rem 0.9rem;
}

.site-mobile-nav__brand {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  min-width: 0;
}

.site-mobile-nav__logo {
  flex-shrink: 0;
  height: 34px;
  width: 34px;
}

.site-mobile-nav__eyebrow {
  color: #c93312;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.site-mobile-nav__title {
  color: #111;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.2;
}

.site-mobile-nav__close {
  align-items: center;
  background: #f3f4f6;
  border: none;
  border-radius: 10px;
  color: #333;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  height: 36px;
  justify-content: center;
  transition: background 0.2s ease;
  width: 36px;
}

.site-mobile-nav__close:hover {
  background: #e9ecef;
}

.site-mobile-nav__account-card {
  align-items: center;
  background: linear-gradient(90deg, #fff4f0 0%, #fff 100%);
  border: 1px solid rgba(201, 51, 18, 0.12);
  border-radius: 14px;
  color: inherit;
  display: flex;
  gap: 0.75rem;
  margin: 0.85rem 1rem 0.25rem;
  padding: 0.85rem;
  text-decoration: none;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.site-mobile-nav__account-card:hover {
  box-shadow: 0 8px 20px rgba(201, 51, 18, 0.1);
  color: inherit;
  transform: translateY(-1px);
}

.site-mobile-nav__account-name {
  color: #111;
  font-size: 0.95rem;
  font-weight: 700;
}

.site-mobile-nav__account-link {
  color: #c93312;
  font-size: 0.8rem;
  font-weight: 600;
}

.site-mobile-nav__account-icon {
  color: #c93312;
  flex-shrink: 0;
  margin-left: auto;
}

.site-mobile-nav__body {
  flex: 1;
  overflow-y: auto;
  padding: 0.5rem 0.75rem 1rem;
}

.site-mobile-nav__group + .site-mobile-nav__group {
  margin-top: 1rem;
}

.site-mobile-nav__group-title {
  color: #6c757d;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 0.45rem;
  padding: 0 0.35rem;
  text-transform: uppercase;
}

.site-mobile-nav__links {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.site-mobile-nav__link {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 12px;
  color: #222;
  cursor: pointer;
  display: flex;
  font: inherit;
  gap: 0.75rem;
  min-height: 48px;
  padding: 0.65rem 0.75rem;
  text-align: left;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease;
  width: 100%;
}

.site-mobile-nav__link:hover {
  background: rgba(201, 51, 18, 0.06);
  color: #111;
}

.site-mobile-nav__link-icon {
  align-items: center;
  background: #f5f6f8;
  border-radius: 10px;
  color: #c93312;
  display: inline-flex;
  flex-shrink: 0;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.site-mobile-nav__link-label {
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 1.35;
}

.site-mobile-nav__footer {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  margin-top: auto;
  padding: 0.85rem 1rem 1rem;
}

.site-mobile-nav__logout {
  align-items: center;
  background: #fff;
  border: 1px solid rgba(201, 51, 18, 0.22);
  border-radius: 12px;
  color: #c93312;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.92rem;
  font-weight: 700;
  gap: 0.55rem;
  justify-content: center;
  min-height: 46px;
  padding: 0.7rem 1rem;
  transition: background 0.2s ease;
  width: 100%;
}

.site-mobile-nav__logout:hover {
  background: rgba(201, 51, 18, 0.06);
}

.site-mobile-nav__login {
  background: linear-gradient(90deg, #c93312 0%, #a82910 100%);
  border: none;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 700;
  min-height: 46px;
  padding: 0.75rem 1rem;
  transition: opacity 0.2s ease, transform 0.2s ease;
  width: 100%;
}

.site-mobile-nav__login:hover {
  opacity: 0.94;
  transform: translateY(-1px);
}

@media (max-width: 767px) {
  .site-mobile-nav__link {
    min-height: 50px;
  }
}

/* ── Filters panel (Categories & Search) ── */
.filters-panel {
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.filters-panel__header {
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1rem;
  min-height: 52px;
  padding: 0.75rem 1.25rem;
  user-select: none;
}

.filters-panel__header-left {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 0.5rem;
}

.filters-panel__icon {
  align-items: center;
  color: #c93312;
  display: flex;
}

.filters-panel__title {
  color: #111;
  font-size: 1rem;
  font-weight: 700;
}

.filters-panel__chevron {
  color: #666 !important;
  font-size: 1.35rem !important;
}

.filters-panel__breadcrumb {
  color: #555;
  flex: 1;
  font-size: 0.9rem;
  font-weight: 500;
  min-width: 0;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filters-panel__breadcrumb--empty {
  flex: 1;
}

.filters-panel__path {
  color: #444;
}

.filters-panel__clear {
  background: none;
  border: none;
  color: #c93312;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 0.875rem;
  font-weight: 600;
  margin-left: auto;
  padding: 0.25rem 0;
  transition: opacity 0.2s ease;
}

.filters-panel__clear:hover {
  opacity: 0.75;
  text-decoration: underline;
}

.filters-panel__body {
  border-top: 1px solid #eee;
  padding: 1.25rem 1.5rem 1.5rem;
}

.filters-panel__content {
  display: flex;
  flex-direction: column;
}

.filters-panel__subtitle {
  color: #111;
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 1.25rem;
}

.filters-panel__grid {
  display: grid;
  gap: 1.5rem 2rem;
  grid-template-columns: repeat(4, 1fr);
}

.filters-panel__column-title {
  color: #111;
  font-size: 0.95rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.filters-panel__options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.filters-panel__option {
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 0.5rem;
  margin: 0;
}

.filters-panel__option-label {
  color: #333;
  font-size: 0.9rem;
  line-height: 1.3;
}

.filters-panel__checkbox {
  accent-color: #c93312;
  appearance: none;
  background: #fff;
  border: 1.5px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  flex-shrink: 0;
  height: 18px;
  margin: 0;
  position: relative;
  width: 18px;
}

.filters-panel__checkbox:checked {
  background: #c93312;
  border-color: #c93312;
}

.filters-panel__checkbox:checked::after {
  border: solid #fff;
  border-width: 0 2px 2px 0;
  content: "";
  height: 9px;
  left: 5px;
  position: absolute;
  top: 1px;
  transform: rotate(45deg);
  width: 5px;
}

.filters-panel__checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.filters-panel__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
  padding-top: 0.5rem;
}

.filters-panel__apply {
  background: #fff;
  border: 1.5px solid #222;
  border-radius: 8px;
  color: #111;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  min-width: 140px;
  padding: 0.55rem 1.5rem;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.filters-panel__apply:hover {
  background: #f8f8f8;
  border-color: #000;
}

@media (max-width: 991px) {
  .filters-panel__grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .filters-panel__breadcrumb {
    flex-basis: 100%;
    order: 3;
    text-align: left;
  }

  .filters-panel__clear {
    margin-left: auto;
  }
}

@media (max-width: 575px) {
  .filters-panel__header {
    padding: 0.75rem 1rem;
  }

  .filters-panel__body {
    padding: 1rem;
  }

  .filters-panel__grid {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }

  .filters-panel__apply {
    width: 100%;
  }

  .filters-panel__actions {
    justify-content: stretch;
  }
}

/* ── Learn page ── */
.learn-page {
  --learn-accent: #c93312;
  --learn-accent-soft: rgba(201, 51, 18, 0.08);
  --learn-surface: #ffffff;
  --learn-muted: #6b7280;
  --learn-border: rgba(0, 0, 0, 0.08);
  --learn-shadow: 0 8px 32px rgba(15, 23, 42, 0.06);
}

.learn-page__hero-section {
  margin-top: 1.5rem;
  margin-bottom: 2rem;
}

.learn-page__hero {
  background: linear-gradient(135deg, #faefd1 0%, #fff6e8 45%, #fff 100%);
  border-bottom-left-radius: 24px;
  overflow: hidden;
}

@media (min-width: 768px) {
  .learn-page__hero {
    border-bottom-left-radius: 50px;
  }
}

.learn-page__hero-copy {
  max-width: 540px;
}

.learn-page__eyebrow {
  color: var(--learn-accent);
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 0.75rem;
  text-transform: uppercase;
}

.learn-page__title {
  color: #111;
  font-family: "Helvetica Bold", Helvetica, Arial, sans-serif;
  font-size: clamp(2rem, 5vw, 4rem);
  font-weight: 700;
  line-height: 1.1;
  margin: 0 0 1rem;
}

.learn-page__lead {
  color: #444;
  font-size: clamp(0.95rem, 2vw, 1.05rem);
  line-height: 1.65;
  margin-bottom: 1.5rem;
  max-width: 480px;
}

.learn-page__hero-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.learn-page__stat {
  align-items: center;
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid var(--learn-border);
  border-radius: 14px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 88px;
  padding: 0.65rem 1rem;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.learn-page__stat:hover {
  background: #fff;
  border-color: rgba(201, 51, 18, 0.25);
  transform: translateY(-1px);
}

.learn-page__stat--active,
.learn-page__stat--active:hover,
.learn-page__stat--active:focus-visible {
  background: #373a3b !important;
  border-color: #373a3b !important;
  color: #fff !important;
}

.learn-page__stat--active .learn-page__stat-value,
.learn-page__stat--active .learn-page__stat-label {
  color: #fff !important;
}

.learn-page__stat:not(.learn-page__stat--active) .learn-page__stat-value {
  color: #111;
}

.learn-page__stat:not(.learn-page__stat--active) .learn-page__stat-label {
  color: var(--learn-muted);
}

.learn-page__stat-value {
  font-size: 1.25rem;
  font-weight: 800;
  line-height: 1;
}

.learn-page__stat-label {
  color: var(--learn-muted);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.learn-page__hero-art {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: flex-end;
  min-height: 220px;
}

.learn-page__hero-img {
  border-top-left-radius: 60px;
  height: 100%;
  max-height: 320px;
  object-fit: contain;
  object-position: right center;
  width: 75%;
}

.learn-page__layout {
  background: var(--learn-surface);
  border: 1px solid var(--learn-border);
  border-radius: 20px;
  box-shadow: var(--learn-shadow);
  display: grid;
  grid-template-columns: 260px 1fr;
  min-height: 420px;
  overflow: hidden;
}

.learn-page__nav {
  background: #eef1f3;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 1rem;
}

.learn-page__nav-item {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 12px;
  color: #333;
  cursor: pointer;
  display: flex;
  font-size: 0.95rem;
  font-weight: 700;
  gap: 0.65rem;
  padding: 0.85rem 1rem;
  text-align: left;
  transition: background 0.2s ease, color 0.2s ease;
  width: 100%;
}

.learn-page__nav-item:hover:not(.learn-page__nav-item--active) {
  background: rgba(255, 255, 255, 0.7);
  color: #333;
}

.learn-page__nav-item.learn-page__nav-item--active,
.learn-page__nav-item.learn-page__nav-item--active:hover,
.learn-page__nav-item.learn-page__nav-item--active:focus-visible {
  background: #373a3b !important;
  color: #fff !important;
}

.learn-page__nav-item--active .learn-page__nav-icon,
.learn-page__nav-item--active .learn-page__nav-label {
  color: #fff !important;
}

.learn-page__nav-item:not(.learn-page__nav-item--active) .learn-page__nav-icon,
.learn-page__nav-item:not(.learn-page__nav-item--active) .learn-page__nav-label {
  color: #333;
}

.learn-page__nav-icon {
  flex-shrink: 0;
  font-size: 1.25rem;
  color: inherit;
}

.learn-page__nav-label {
  flex: 1;
  min-width: 0;
  color: inherit;
}

.learn-page__nav-count {
  background: rgba(0, 0, 0, 0.06);
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 1.5rem;
  padding: 0.15rem 0.45rem;
  text-align: center;
}

.learn-page__nav-item--active .learn-page__nav-count {
  background: rgba(255, 255, 255, 0.2);
  color: #fff !important;
}

.learn-page__nav-item:not(.learn-page__nav-item--active) .learn-page__nav-count {
  background: rgba(0, 0, 0, 0.06);
  color: #333;
}

.learn-page__content {
  padding: 1.75rem 2rem 2rem;
}

.learn-page__panel-header {
  border-bottom: 1px solid #eee;
  margin-bottom: 1.5rem;
  padding-bottom: 1.25rem;
}

.learn-page__panel-title {
  color: #111;
  font-size: clamp(1.35rem, 3vw, 1.75rem);
  font-weight: 800;
  margin: 0 0 0.35rem;
}

.learn-page__panel-desc {
  color: var(--learn-muted);
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
}

.learn-page__loader {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 200px;
  padding: 2rem 0;
}

.learn-page__empty {
  background: #f9fafb;
  border: 1px dashed #ddd;
  border-radius: 14px;
  color: var(--learn-muted);
  padding: 2.5rem 1.5rem;
  text-align: center;
}

.learn-page__empty p {
  margin: 0;
}

/* FAQ accordion overrides */
.learn-page__faq .MuiAccordion-root {
  background: #fff;
  border: 1px solid #eee !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  margin-bottom: 0.65rem !important;
  overflow: hidden;
}

.learn-page__faq .MuiAccordion-root::before {
  display: none;
}

.learn-page__faq .MuiAccordionSummary-root {
  min-height: 56px !important;
  padding: 0 1.25rem;
}

.learn-page__faq .MuiAccordionSummary-content {
  margin: 0.85rem 0 !important;
}

.learn-page__faq .MuiAccordionSummary-content b {
  color: #111;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.4;
}

.learn-page__faq .MuiAccordionDetails-root {
  border-top: 1px solid #f0f0f0;
  color: #555;
  line-height: 1.65;
  padding: 0 1.25rem 1.1rem;
}

.learn-page__faq .MuiSvgIcon-root {
  color: var(--learn-accent);
}

/* Video cards */
.learn-page__video-grid {
  display: grid;
  gap: 1.25rem;
  grid-template-columns: repeat(2, 1fr);
}

.learn-page__video-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
  text-align: left;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  width: 100%;
}

.learn-page__video-card:hover {
  border-color: rgba(201, 51, 18, 0.3);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  transform: translateY(-2px);
}

.learn-page__video-thumb {
  aspect-ratio: 16 / 9;
  background: #1a1a1a;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.learn-page__video-thumb img {
  height: 100%;
  object-fit: cover;
  transition: transform 0.35s ease;
  width: 100%;
}

.learn-page__video-card:hover .learn-page__video-thumb img {
  transform: scale(1.04);
}

.learn-page__video-thumb-placeholder {
  background: linear-gradient(135deg, #2d2d2d, #444);
  height: 100%;
  width: 100%;
}

.learn-page__video-play {
  align-items: center;
  background: rgba(201, 51, 18, 0.92);
  border-radius: 50%;
  color: #fff;
  display: flex;
  height: 52px;
  justify-content: center;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: transform 0.2s ease, background 0.2s ease;
  width: 52px;
}

.learn-page__video-card:hover .learn-page__video-play {
  background: #c93312;
  transform: translate(-50%, -50%) scale(1.08);
}

.learn-page__video-body {
  padding: 1rem 1.15rem 1.15rem;
}

/* Blog cards */
.learn-page__blog-grid {
  display: grid;
  gap: 1.25rem;
  grid-template-columns: repeat(2, 1fr);
}

.learn-page__blog-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 16px;
  color: inherit;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-decoration: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.learn-page__blog-card:hover {
  border-color: rgba(201, 51, 18, 0.3);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  color: inherit;
  text-decoration: none;
  transform: translateY(-2px);
}

.learn-page__blog-thumb {
  aspect-ratio: 16 / 9;
  background: #f3f4f6;
  overflow: hidden;
}

.learn-page__blog-thumb img {
  height: 100%;
  object-fit: cover;
  transition: transform 0.35s ease;
  width: 100%;
}

.learn-page__blog-card:hover .learn-page__blog-thumb img {
  transform: scale(1.04);
}

.learn-page__blog-thumb-placeholder {
  align-items: center;
  color: #bbb;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.learn-page__blog-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 1rem 1.15rem 1.15rem;
}

.learn-page__blog-date {
  color: var(--learn-accent);
  display: block;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  margin-bottom: 0.45rem;
  text-transform: uppercase;
}

.learn-page__card-title {
  color: #111;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.35;
  margin: 0 0 0.5rem;
}

.learn-page__card-desc {
  -webkit-box-orient: vertical;
  color: var(--learn-muted);
  display: -webkit-box;
  flex: 1;
  font-size: 0.9rem;
  -webkit-line-clamp: 3;
  line-height: 1.55;
  margin: 0;
  overflow: hidden;
}

.learn-page__read-more {
  align-items: center;
  color: var(--learn-accent);
  display: inline-flex;
  font-size: 0.875rem;
  font-weight: 700;
  gap: 0.35rem;
  margin-top: 0.85rem;
}

.learn-page__blog-card:hover .learn-page__read-more {
  gap: 0.55rem;
}

@media (max-width: 991px) {
  .learn-page__layout {
    grid-template-columns: 220px 1fr;
  }

  .learn-page__content {
    padding: 1.5rem;
  }

  .learn-page__video-grid,
  .learn-page__blog-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .learn-page__hero-section {
    margin-top: 1rem;
    margin-bottom: 1.25rem;
  }

  .learn-page__hero-stats {
    gap: 0.5rem;
  }

  .learn-page__stat {
    flex: 1;
    min-width: 0;
  }

  .learn-page__layout {
    display: flex;
    flex-direction: column;
    grid-template-columns: unset;
  }

  .learn-page__nav {
    border-bottom: 1px solid #dde1e4;
    flex-direction: row;
    flex-shrink: 0;
    gap: 0.35rem;
    overflow-x: hidden;
    padding: 0.65rem;
    scrollbar-width: none;
  }

  .learn-page__nav::-webkit-scrollbar {
    display: none;
  }

  .learn-page__nav-item {
    align-items: center;
    flex: 1 1 0;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    padding: 0.6rem 0.35rem;
    text-align: center;
    width: auto;
  }

  .learn-page__nav-label {
    font-size: 0.72rem;
    line-height: 1.2;
    white-space: normal;
  }

  .learn-page__nav-count {
    display: none;
  }

  .learn-page__content {
    padding: 1.25rem 1rem 1.5rem;
  }

  .learn-page__panel-header {
    margin-bottom: 1.25rem;
    padding-bottom: 1rem;
  }
}

@media (max-width: 575px) {
  .learn-page__hero {
    border-bottom-left-radius: 20px;
  }

  .learn-page__nav-item {
    font-size: 0.82rem;
    gap: 0.3rem;
    padding: 0.55rem 0.25rem;
  }

  .learn-page__nav-label {
    font-size: 0.68rem;
  }

  .learn-page__faq .MuiAccordionSummary-root {
    padding: 0 0.85rem;
  }

  .learn-page__faq .MuiAccordionDetails-root {
    padding: 0 0.85rem 1rem;
  }
}

/* ── User profile settings ── */
.user-profile {
  --profile-accent: #c93312;
  --profile-accent-soft: rgba(201, 51, 18, 0.08);
  --profile-surface: #ffffff;
  --profile-muted: #6b7280;
  --profile-border: rgba(0, 0, 0, 0.08);
  --profile-shadow: 0 4px 24px rgba(15, 23, 42, 0.06);
  min-height: 60vh;
}

.user-profile__header {
  align-items: flex-start;
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.user-profile__back {
  align-items: center;
  background: #fff;
  border: 1px solid var(--profile-border);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  color: #111;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  height: 44px;
  justify-content: center;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
  width: 44px;
}

.user-profile__back:hover {
  background: #f8f8f8;
  border-color: rgba(0, 0, 0, 0.14);
  transform: translateY(-1px);
}

.user-profile__eyebrow {
  color: var(--profile-accent);
  display: inline-block;
  font-size:clamp(1.75rem, 4vw, 2.25rem);
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 0.35rem;
  text-transform: uppercase;
}

.user-profile__title {
  color: #111;
  font-family: "Helvetica Bold", Helvetica, Arial, sans-serif;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.15;
  margin: 0 0 0.5rem;
}

.user-profile__subtitle {
  color: var(--profile-muted);
  font-size: 0.95rem;
  line-height: 1.55;
  margin: 0;
  max-width: 520px;
}

.user-profile__layout {
  display: grid;
  gap: 1.25rem;
  grid-template-columns: minmax(260px, 320px) 1fr;
}

.user-profile__card {
  background: var(--profile-surface);
  border: 1px solid var(--profile-border);
  border-radius: 18px;
  box-shadow: var(--profile-shadow);
  padding: 1.5rem;
}

.user-profile__card--identity {
  height: 100%;
  text-align: center;
}

.user-profile__card-head {
  margin-bottom: 1.25rem;
}

.user-profile__card-title {
  color: #111;
  font-size: 1.05rem;
  font-weight: 800;
  margin: 0 0 0.35rem;
}

.user-profile__card-title--danger {
  color: #b42318;
}

.user-profile__card-desc {
  color: var(--profile-muted);
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0;
}

.user-profile__card-desc--danger {
  color: #9a3412;
}

.user-profile__main {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.user-profile__avatar-block {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.user-profile__avatar {
  align-items: center;
  background: linear-gradient(135deg, #fff4ee, #fde8dc);
  border: 3px solid #fff;
  border-radius: 50%;
  box-shadow: 0 8px 24px rgba(201, 51, 18, 0.12);
  display: flex;
  height: 120px;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 120px;
}

.user-profile__avatar img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.user-profile__avatar-initials {
  color: var(--profile-accent);
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.user-profile__avatar--loading {
  opacity: 0.85;
}

.user-profile__avatar-overlay {
  align-items: center;
  background: rgba(0, 0, 0, 0.45);
  bottom: 0;
  color: #fff;
  display: flex;
  font-size: 0.75rem;
  font-weight: 600;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.user-profile__upload-btn {
  align-items: center;
  background: #111;
  border: none;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.875rem;
  font-weight: 600;
  gap: 0.4rem;
  padding: 0.55rem 1rem;
  transition: background 0.2s ease, transform 0.2s ease;
}

.user-profile__upload-btn:hover {
  background: #222;
  transform: translateY(-1px);
}

.user-profile__upload-btn--disabled {
  cursor: not-allowed;
  opacity: 0.65;
  pointer-events: none;
}

.user-profile__identity-name {
  color: #111;
  font-size: 1.2rem;
  font-weight: 800;
  margin: 0 0 0.25rem;
  word-break: break-word;
}

.user-profile__identity-email {
  color: var(--profile-muted);
  font-size: 0.875rem;
  margin: 0;
  word-break: break-all;
}

.user-profile__identity-meta {
  margin-bottom: 1rem;
}

.user-profile__identity-badge {
  align-items: center;
  background: var(--profile-accent-soft);
  border-radius: 999px;
  color: var(--profile-accent);
  display: inline-flex;
  font-size: 0.8rem;
  font-weight: 700;
  gap: 0.35rem;
  padding: 0.4rem 0.85rem;
}

.user-profile__fields {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.user-profile__field-label {
  color: #374151;
  display: block;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 0.45rem;
  text-transform: uppercase;
}

.user-profile__field-value-row {
  align-items: center;
  background: #f9fafb;
  border: 1px solid #eee;
  border-radius: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: space-between;
  min-height: 52px;
  padding: 0.75rem 1rem;
}

.user-profile__field-value {
  color: #111;
  font-size: 0.95rem;
  font-weight: 600;
  word-break: break-word;
}

.user-profile__field-value--with-icon {
  align-items: center;
  display: inline-flex;
  gap: 0.5rem;
}

.user-profile__field-hint {
  color: var(--profile-muted);
  display: block;
  font-size: 0.8rem;
  line-height: 1.45;
  margin-top: 0.45rem;
}

.user-profile__edit-btn {
  align-items: center;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  color: #111;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 0.82rem;
  font-weight: 600;
  gap: 0.35rem;
  padding: 0.4rem 0.75rem;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.user-profile__edit-btn:hover {
  background: #f8f8f8;
  border-color: #bbb;
}

.user-profile__pref {
  align-items: flex-start;
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 14px;
  cursor: pointer;
  display: flex;
  gap: 0.85rem;
  margin: 0;
  padding: 1rem 1.1rem;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.user-profile__pref:hover {
  background: #fff;
  border-color: rgba(201, 51, 18, 0.25);
}

.user-profile__pref-input {
  height: 0;
  opacity: 0;
  position: absolute;
  width: 0;
}

.user-profile__pref-box {
  background: #fff;
  border: 2px solid #ccc;
  border-radius: 6px;
  flex-shrink: 0;
  height: 20px;
  margin-top: 2px;
  position: relative;
  transition: background 0.2s ease, border-color 0.2s ease;
  width: 20px;
}

.user-profile__pref-input:checked + .user-profile__pref-box {
  background: var(--profile-accent);
  border-color: var(--profile-accent);
}

.user-profile__pref-input:checked + .user-profile__pref-box::after {
  border: solid #fff;
  border-width: 0 2px 2px 0;
  content: "";
  height: 10px;
  left: 5px;
  position: absolute;
  top: 1px;
  transform: rotate(45deg);
  width: 6px;
}

.user-profile__pref-copy {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.user-profile__pref-title {
  color: #111;
  font-size: 0.95rem;
  font-weight: 700;
}

.user-profile__pref-text {
  color: var(--profile-muted);
  font-size: 0.875rem;
  line-height: 1.5;
}

.user-profile__card--danger {
  background: linear-gradient(180deg, #fff8f7 0%, #fff 100%);
  border-color: rgba(180, 35, 24, 0.15);
}

.user-profile__danger-head {
  align-items: flex-start;
  display: flex;
  gap: 0.75rem;
}

.user-profile__danger-icon {
  align-items: center;
  background: rgba(180, 35, 24, 0.1);
  border-radius: 12px;
  color: #b42318;
  display: inline-flex;
  flex-shrink: 0;
  height: 44px;
  justify-content: center;
  width: 44px;
}

.user-profile__danger-btn {
  background: #fff;
  border: 1.5px solid #b42318;
  border-radius: 10px;
  color: #b42318;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 700;
  padding: 0.65rem 1.15rem;
  transition: background 0.2s ease, color 0.2s ease;
}

.user-profile__danger-btn:hover:not(:disabled) {
  background: #b42318;
  color: #fff;
}

.user-profile__danger-btn:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.user-profile__modal {
  --profile-accent: #c93312;
  --profile-accent-soft: rgba(201, 51, 18, 0.08);
  border-radius: 16px !important;
}

.user-profile__modal .modal-body {
  padding-bottom: 1.5rem;
}

.user-profile__modal-title {
  font-size: 1.15rem;
  font-weight: 800;
}

.user-profile__modal-field {
  margin-bottom: 1.15rem;
}

.user-profile__input {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  color: #111;
  font-size: 0.95rem;
  padding: 0.65rem 0.85rem;
  width: 100%;
}

.user-profile__input:focus {
  border-color: #c93312;
  box-shadow: 0 0 0 3px rgba(201, 51, 18, 0.12);
  outline: none;
}

.user-profile__modal-readonly {
  color: #111;
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
}

.user-profile__modal-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  justify-content: flex-end;
  padding-top: 0.5rem;
}

.user-profile__btn {
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 700;
  min-width: 110px;
  padding: 0.6rem 1.1rem;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.user-profile__btn:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.user-profile__btn--ghost {
  background: #f3f4f6;
  color: #374151;
}

.user-profile__btn--ghost:hover:not(:disabled) {
  background: #e5e7eb;
}

.user-profile__btn--primary {
  background-color: #c93312 !important;
  color: #fff !important;
}

.user-profile__btn--primary:hover:not(:disabled) {
  background-color: #a82910;
  opacity: 1;
  transform: translateY(-1px);
}

@media (max-width: 991px) {
  .user-profile__layout {
    grid-template-columns: 1fr;
  }

  .user-profile__sidebar {
    order: 1;
  }

  .user-profile__main {
    order: 2;
  }
}

@media (max-width: 575px) {
  .user-profile__header {
    margin-bottom: 1.5rem;
  }

  .user-profile__card {
    padding: 1.15rem;
  }

  .user-profile__avatar {
    height: 100px;
    width: 100px;
  }

  .user-profile__field-value-row {
    align-items: flex-start;
    flex-direction: column;
  }

  .user-profile__edit-btn {
    width: 100%;
    justify-content: center;
  }

  .user-profile__modal-actions {
    flex-direction: column-reverse;
  }

  .user-profile__btn {
    width: 100%;
  }

  .user-profile__danger-btn {
    width: 100%;
  }
}

/* ── Seller grid listing card actions ── */
.seller-listing-card__folder-action {
  width: 100%;
  padding: 0.35rem 0.6rem;
  border: 1px solid #e2e5e9;
  border-radius: 8px;
  background: #f7f8f9;
  color: #5f6670;
  font-size: 0.75rem;
  font-weight: 600;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.seller-listing-card__folder-action:hover {
  border-color: #c9ced5;
  background: #eef0f2;
  color: #343a40;
}

.seller-listing-card__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
  padding: 0 0.25rem;
}

.seller-listing-card__primary-action,
.seller-listing-card__icon-action {
  min-height: 36px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease;
}

.listing-card .seller-listing-card__primary-action {
  flex: 1;
  gap: 0.4rem;
  min-width: 0;
  padding: 0.45rem 0.75rem;
  border: 1px solid #171717;
  background: #171717 !important;
  color: #fff !important;
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1;
  opacity: 1;
}

.listing-card .seller-listing-card__primary-action:hover {
  background: #303030 !important;
  border-color: #303030;
  color: #fff !important;
}

.listing-card .seller-listing-card__primary-action span,
.listing-card .seller-listing-card__primary-action svg {
  display: inline-block;
  flex: 0 0 auto;
  color: #fff !important;
  fill: currentColor;
  opacity: 1;
}

.seller-listing-card__icon-action {
  flex: 0 0 36px;
  width: 36px;
  border: 1px solid #d9dde2;
  background: #fff;
  color: #30343a;
  font-size: 0.9rem;
}

.seller-listing-card__icon-action:hover {
  border-color: #9da3ab;
  background: #f5f6f7;
}

.seller-listing-card__icon-action:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  transform: none;
}

.seller-listing-card__icon-action--link {
  border-color: #cfe0ff !important;
  background: #edf3ff !important;
  color: #1d4ed8 !important;
}

.seller-listing-card__icon-action--link:hover:not(:disabled) {
  border-color: #1d4ed8 !important;
  background: #1d4ed8 !important;
  color: #fff !important;
}

.seller-listing-card__icon-action--link:disabled {
  border-color: #dbe3f0 !important;
  background: #f3f6fb !important;
  color: #93a4c3 !important;
  opacity: 1;
}

.seller-listing-card__icon-action--danger {
  border-color: #f0c9c1;
  background: #fff5f3;
  color: #c93312;
}

.seller-listing-card__icon-action--danger:hover {
  border-color: #c93312;
  background: #c93312;
  color: #fff;
}

.seller-listing-card__primary-action:hover,
.seller-listing-card__icon-action:hover {
  transform: translateY(-1px);
}

/* ── Seller detailed listing card ── */
.detailed-listing-card {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 1rem;
}

.detailed-listing-card__checkbox {
  align-items: flex-start;
  display: flex;
  flex-shrink: 0;
  padding-top: 0.25rem;
}

.detailed-listing-card__layout {
  display: grid;
  flex: 1;
  gap: 1rem;
  grid-template-columns: 96px 1fr;
  grid-template-areas:
    "media content"
    "stats stats";
  min-width: 0;
}

.detailed-listing-card__media {
  grid-area: media;
  position: relative;
  width: 100%;
}

.detailed-listing-card__image-link {
  display: block;
}

.detailed-listing-card__image {
  border-radius: 10px;
  display: block;
  height: 96px;
  object-fit: cover;
  object-position: center;
  width: 100%;
}

.detailed-listing-card__content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  grid-area: content;
  min-width: 0;
}

.detailed-listing-card__info {
  min-width: 0;
}

.detailed-listing-card__title {
  color: #111;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.35;
  margin: 0 0 0.35rem;
  word-break: break-word;
}

.detailed-listing-card__description {
  -webkit-box-orient: vertical;
  color: #6b7280;
  display: -webkit-box;
  font-size: 0.875rem;
  -webkit-line-clamp: 3;
  line-height: 1.5;
  margin: 0;
  overflow: hidden;
}

.detailed-listing-card__remove-folder {
  margin-top: 0.5rem;
}

.detailed-listing-card__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.detailed-listing-card__primary-action {
  align-items: center;
  background: #171717 !important;
  border: 1px solid #171717 !important;
  border-radius: 8px;
  color: #fff !important;
  display: inline-flex;
  font-size: 0.875rem;
  font-weight: 700;
  gap: 0.45rem;
  justify-content: center;
  min-height: 36px;
  min-width: 88px;
  padding: 0.45rem 1rem;
  text-decoration: none !important;
  transition: background-color 0.15s ease, transform 0.15s ease;
}

.detailed-listing-card__primary-action:hover,
.detailed-listing-card__primary-action:focus,
.detailed-listing-card__primary-action:active {
  background: #303030 !important;
  border-color: #303030 !important;
  color: #fff !important;
  text-decoration: none !important;
  transform: translateY(-1px);
}

.detailed-listing-card__primary-action span,
.detailed-listing-card__primary-action svg {
  color: #fff !important;
  fill: currentColor;
  opacity: 1;
}

.detailed-listing-card__btn {
  align-items: center;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.875rem;
  font-weight: 600;
  justify-content: center;
  min-height: 36px;
  padding: 0.45rem 1.1rem;
  text-decoration: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.detailed-listing-card__btn:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}

.detailed-listing-card__btn--dark {
  background: #0e0e0e;
  color: #fff;
}

.detailed-listing-card__btn--danger {
  background: #c93312;
  color: #fff;
}

.detailed-listing-card__icon-btn {
  align-items: center;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  min-width: 36px;
  padding: 0 0.55rem;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.detailed-listing-card__icon-btn:hover:not(:disabled) {
  opacity: 0.92;
  transform: translateY(-1px);
}

.detailed-listing-card__icon-btn--primary {
  background: #c93312;
  color: #fff;
}

.detailed-listing-card__icon-btn--ghost {
  background: #f3f4f6;
  color: #374151;
}

.detailed-listing-card__icon-btn--edit {
  background: #171717 !important;
  border: 1px solid #171717 !important;
  color: #fff !important;
}

.detailed-listing-card__icon-btn--edit:hover:not(:disabled) {
  background: #303030 !important;
  border-color: #303030 !important;
  color: #fff !important;
}

.detailed-listing-card__icon-btn--edit svg {
  color: #fff !important;
  fill: currentColor;
}

.detailed-listing-card__icon-btn--link {
  background: #edf3ff !important;
  border: 1px solid #cfe0ff !important;
  color: #1d4ed8 !important;
}

.detailed-listing-card__icon-btn--link:hover:not(:disabled) {
  background: #1d4ed8 !important;
  border-color: #1d4ed8 !important;
  color: #fff !important;
}

.detailed-listing-card__icon-btn--link:disabled {
  background: #f3f6fb !important;
  border-color: #dbe3f0 !important;
  color: #93a4c3 !important;
  opacity: 1;
}

.detailed-listing-card__icon-btn--danger {
  background: #fff5f3;
  border: 1px solid #f0c9c1;
  color: #c93312;
}

.detailed-listing-card__icon-btn--danger:hover:not(:disabled) {
  background: #c93312;
  border-color: #c93312;
  color: #fff;
}

.detailed-listing-card__icon-btn:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.detailed-listing-card__btn--mobile {
  display: none;
}

.detailed-listing-card__stats {
  background: #f9fafb;
  border: 1px solid #eee;
  border-radius: 12px;
  display: grid;
  gap: 0.65rem;
  grid-area: stats;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 0.75rem;
}

.detailed-listing-card__stat {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}

.detailed-listing-card__stat-label {
  color: #6b7280;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.3;
  text-transform: uppercase;
}

.detailed-listing-card__stat-value {
  color: #111;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.2;
  word-break: break-word;
}

.detailed-listing-card__stat-value--success {
  color: #15803d;
}

@media (min-width: 576px) {
  .detailed-listing-card {
    padding: 1.1rem 1.15rem;
  }

  .detailed-listing-card__layout {
    grid-template-columns: 112px 1fr;
  }

  .detailed-listing-card__image {
    height: 112px;
  }

  .detailed-listing-card__stats {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {
  .detailed-listing-card__layout {
    align-items: center;
    gap: 1.25rem;
    grid-template-columns: 120px minmax(0, 1fr) minmax(0, 1.4fr);
    grid-template-areas: "media content stats";
  }

  .detailed-listing-card__image {
    height: 100px;
  }

  .detailed-listing-card__content {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
  }

  .detailed-listing-card__info {
    flex: 1;
    padding-right: 1rem;
  }

  .detailed-listing-card__description {
    -webkit-line-clamp: 2;
  }

  .detailed-listing-card__actions {
    flex-shrink: 0;
    justify-content: flex-end;
  }

  .detailed-listing-card__stats {
    background: transparent;
    border: none;
    gap: 0.5rem 0.75rem;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    padding: 0;
  }

  .detailed-listing-card__stat {
    align-items: center;
    text-align: center;
  }

  .detailed-listing-card__stat-label {
    font-size: 0.72rem;
  }
}

@media (min-width: 1200px) {
  .detailed-listing-card__layout {
    grid-template-columns: 120px minmax(0, 1fr) minmax(0, 1.8fr);
  }

  .detailed-listing-card__stats {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .detailed-listing-card__btn--desktop {
    display: inline;
  }

  .detailed-listing-card__btn--mobile {
    display: none !important;
  }
}

@media (max-width: 1199px) {
  .detailed-listing-card__btn--desktop {
    display: none !important;
  }

  .detailed-listing-card__btn--mobile {
    align-items: center;
    display: inline-flex !important;
    justify-content: center;
  }

  .detailed-listing-card__btn.detailed-listing-card__btn--dark,
  .detailed-listing-card__btn.detailed-listing-card__btn--danger {
    min-width: 36px;
    padding: 0 0.55rem;
  }
}

/* ── My Listings toolbar ── */
.my-listings-page-header {
  margin-top: 1.25rem;
}

.my-listings-toolbar {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
}

.my-listings-toolbar__controls {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}

.my-listings-toolbar__selection {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.my-listings-toolbar__actions {
  display: grid;
  gap: 0.65rem;
  grid-template-columns: 1fr;
  width: 100%;
}

.my-listings-toolbar__btn--action {
  width: 100%;
}

.my-listings-view-toggle {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.25rem;
  padding: 0.25rem;
  width: 100%;
}

.my-listings-view-toggle__btn {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 10px;
  color: #4b5563;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.875rem;
  font-weight: 600;
  gap: 0.4rem;
  justify-content: center;
  min-height: 40px;
  padding: 0.5rem 0.75rem;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  white-space: nowrap;
}

.my-listings-view-toggle__btn:hover {
  background: rgba(255, 255, 255, 0.7);
  color: #111;
}

.my-listings-view-toggle__btn--active {
  background: #fff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
  color: #111;
}

.my-listings-sort-row {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.my-listings-sort {
  width: 100%;
}

@media (min-width: 576px) {
  .my-listings-toolbar__actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {
  .my-listings-toolbar {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }

  .my-listings-toolbar__controls {
    align-items: center;
    flex: 1;
    flex-direction: row;
    flex-wrap: wrap;
    min-width: 0;
  }

  .my-listings-toolbar__actions {
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    gap: 0.65rem;
    justify-content: flex-end;
    width: auto;
  }

  .my-listings-toolbar__btn--action {
    width: auto;
    min-width: 140px;
  }

  .my-listings-view-toggle {
    max-width: 280px;
    width: auto;
  }

  .my-listings-sort {
    max-width: 280px;
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,2DAAiD;AACnD;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,2DAAuD;AACzD;;AAEA,+BAA+B;;AAE/B,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,yBAAyB;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;;;;;;EAME,yCAAyC;AAC3C;AACA;EACE,wBAAwB,EAAE,qCAAqC;EAC/D,0BAA0B,EAAE,6BAA6B;AAC3D;;AAEA;;EAEE,wBAAwB,EAAE,0CAA0C;EACpE,SAAS;AACX;AACA;;EAEE,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,4DAA4D;AAC9D;AACA,4BAA4B;AAC5B;EACE,oCAAoC;EACpC,mBAAmB;EACnB;;2BAEyB;EACzB,6BAA6B;;EAE7B,0BAA0B;;EAE1B,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA,qDAAqD;AACrD;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;EACzB;AACF;;AAEA,0DAA0D;AAC1D;EACE;;IAEE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC;;;;GAIC;AACH;;AAEA;;;;;;;GAOG;;AAEH;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;AACA;;;;;;;;;;;;;EAaE,cAAc;AAChB;;AAEA;;;;;;EAME,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,iCAAiC;EACjC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,wBAAwB;;AAExB;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,6CAA6C;EAC7C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,MAAM;EACN,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;EAC/B,yEAAyE;EACzE,WAAW;AACb;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,wBAAwB;EACxB,gBAAgB;EAChB,mDAAmD;EACnD,WAAW;AACb;;AAEA;;EAEE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,mDAAmD;EACnD,WAAW;AACb;;AAEA;;EAEE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;IACb,WAAW;IACX,gDAAgD;IAChD,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gDAAgD;IAChD,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,2DAA2D;EAC3D,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA,yBAAyB;;AAEzB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;;;;EAKE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,6BAA6B;EAC7B,yEAAyE;EACzE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;;EAEjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,2BAA2B;AAC3B;EACE;IACE,mBAAmB;IACnB,kCAAkC;EACpC;EACA;IACE,qBAAqB;IACrB,yCAAyC;EAC3C;AACF;;AAEA;EACE,eAAe;EACf;;wBAEsB;AACxB;;AAEA;EACE,gDAAgD;AAClD;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;AACb;;AAEA,qDAAqD;AACrD;EACE;;4BAE0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,cAAc;EACd,eAAe;EACf,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;;IAGE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,OAAO;EACP,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,wCAAwC;EACxE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,qCAAqC;EACpD,2BAA2B,EAAE,4BAA4B;EACzD,kCAAkC,EAAE,0BAA0B;AAChE;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC,EAAE,yBAAyB;EAC7D,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B,EAAE,gCAAgC;EAChE,2CAA2C,EAAE,yCAAyC;AACxF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,MAAM;AACR;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB;;0BAEwB;EACxB;;0BAEwB;EACxB;;kBAEgB;EAChB;;kBAEgB;EAChB;;;0BAGwB;EACxB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;;0BAEwB;EACxB;;0BAEwB;EACxB;;kBAEgB;EAChB;;kBAEgB;EAChB;;;0BAGwB;EACxB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;;;EAME,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE;;;;;;IAME,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;;;IAME,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;;;;;;IAME,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;;;;;;IAME,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;;;;;;IAME,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,0BAA0B;EAC5B;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,6BAA6B;IAC7B,2DAA2D;IAC3D,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;EAC9B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,qCAAqC;;AAErC,gBAAgB;;AAEhB;EACE;IACE,gCAAgC;EAClC;AACF;AACA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA;EACE;IACE,oCAAoC;EACtC;AACF;AACA;EACE;IACE,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uCAAuC;IACvC,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wCAAwC;IACxC,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sEAAsE;AACtE;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA,kDAAkD;AAClD;;;;EAIE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;EACvB,oCAAoC;EACpC,kDAAkD;EAClD,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uEAAuE;EACvE,sCAAsC;EACtC,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,qDAAqD;AACvD;;AAEA;EACE;IACE,8CAA8C;IAC9C,2BAA2B;EAC7B;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,2DAA2D;EAC3D,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE;IACE,0DAA0D;EAC5D;AACF;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yDAAyD;EACzD,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yDAAyD;EACzD,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,0DAA0D;AAC1D;EACE,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,uEAAuE;EACvE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;EACd,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kDAAkD;EAClD,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB;;;yCAGuC;EACvC;;;UAGQ;EACR,4BAA4B;EAC5B;;;gBAGc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC;;;8BAG4B;EAC5B,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB;;;;wBAIsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,6CAA6C;EAC7C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,sEAAsE;AACtE;EACE,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kDAAkD;EAClD,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,8CAA8C;EAC9C,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,sEAAsE;AACxE;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,+CAA+C;EAC/C,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE;IACE,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;EACnB;;;EAGA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;;IAEE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,+DAA+D;AAC/D;EACE,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yDAAyD;EACzD,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,6CAA6C;EAC7C,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,iDAAiD;EACjD,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4DAA4D;EAC5D,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,OAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,wBAAwB;EACxB,sBAAsB;EACtB,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uEAAuE;EACvE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,2DAA2D;EAC3D,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,6EAA6E;AAC/E;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;;;EAGE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,iDAAiD;EACjD,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;;;EAGE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,6EAA6E;EAC7E,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kDAAkD;EAClD,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,6EAA6E;AAC/E;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,OAAO;EACP,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO;IACP,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,0BAA0B;EAC1B,wBAAwB;EACxB,qCAAqC;EACrC,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,6EAA6E;EAC7E,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qDAAqD;EACrD,sBAAsB;EACtB,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,oBAAoB;EACpB,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,wDAAwD;EACxD,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB;2BACyB;AAC3B;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,SAAS;EACT,+BAA+B;EAC/B;;iBAEe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;;;EAGE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;EACtB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;IACZ,4DAA4D;IAC5D,0CAA0C;EAC5C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,OAAO;IACP,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,gDAAgD;IAChD,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,4DAA4D;EAC9D;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;;IAEE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,uEAAuE;EACvE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,OAAO;IACP,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;IACd,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF","sourcesContent":["/* font family helvetica */\n@font-face {\n  font-family: \"Helvetica\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"./fonts/Helvetica.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Helvetica Bold\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"./fonts//Helvetica-Bold.woff\") format(\"woff\");\n}\n\n/* Common styles for elements */\n\n/* Add this CSS to your stylesheet */\n.canvas-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh; /* Full viewport height */\n}\n\ncanvas {\n  width: auto;\n  height: 100%;\n}\n\nbody {\n  font-family: Helvetica, sans-serif;\n  margin: 0;\n  padding: 0;\n  font-size: 18px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Helvetica Bold\", sans-serif;\n}\ninput[type=\"number\"] {\n  -webkit-appearance: none; /* Remove arrows in WebKit browsers */\n  -moz-appearance: textfield; /* Remove arrows in Firefox */\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none; /* Remove arrows in Chrome, Safari, Edge */\n  margin: 0;\n}\n.affialiate-form-style input::placeholder,\n.affialiate-form-style textarea::placeholder {\n  color: #b4b4b4;\n}\n.cookie-preferences-container {\n  padding: 20px;\n  max-width: 600px;\n  margin: 40px auto;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n}\n\n.cookie-settings-modal .modal-content {\n  max-height: min(90vh, 720px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.cookie-settings-modal__header {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  flex-shrink: 0;\n  background: #fff;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.cookie-settings-modal__body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 20px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.cookie-settings-modal__footer {\n  flex-shrink: 0;\n  border-top: 1px solid #e0e0e0;\n  padding: 15px;\n  display: flex;\n  justify-content: space-between;\n  background: #fff;\n}\n\n.cookie-settings-modal__footer .cookie-settings-modal__btn-save:hover,\n.cookie-settings-modal__footer .cookie-settings-modal__btn-save:focus {\n  background-color: #c93312 !important;\n  border-color: #c93312 !important;\n  color: #fff !important;\n}\n\n.cookie-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 15px 0;\n  font-size: 14px;\n}\n\n.cookie-category-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.cookie-category-panel {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.cookie-category-panel__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n}\n\n.cookie-category-panel__toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n  color: #111;\n  text-align: left;\n  min-width: 0;\n}\n\n.cookie-category-panel__chevron {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n  color: #555;\n}\n\n.cookie-category-panel__chevron.is-expanded {\n  transform: rotate(180deg);\n}\n\n.cookie-category-panel__title {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.cookie-category-panel__always-active {\n  color: #1f8a3b;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.cookie-category-panel__body {\n  padding: 0 16px 16px;\n}\n\n.cookie-category-panel__description {\n  font-size: 14px;\n  color: #666;\n  margin: 0 0 12px;\n  line-height: 1.5;\n}\n\n.cookie-detail-list {\n  background: #f5f5f5;\n  border-radius: 6px;\n  padding: 4px 14px;\n}\n\n.cookie-detail-item {\n  padding: 14px 0;\n  border-bottom: 1px solid #e4e4e4;\n}\n\n.cookie-detail-item:last-child {\n  border-bottom: 0;\n}\n\n.cookie-detail-row {\n  display: grid;\n  grid-template-columns: 110px 1fr;\n  gap: 10px;\n  margin-bottom: 8px;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.cookie-detail-row:last-child {\n  margin-bottom: 0;\n}\n\n.cookie-detail-label {\n  color: #666;\n  font-weight: 600;\n}\n\n.cookie-detail-value {\n  color: #222;\n  word-break: break-word;\n}\n\n@media (max-width: 575.98px) {\n  .cookie-detail-row {\n    grid-template-columns: 1fr;\n    gap: 2px;\n  }\n}\n\n.cookie-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 30px;\n}\n\n.cookie-actions button {\n  padding: 8px 14px;\n  font-size: 14px;\n  border: none;\n  background: #000;\n  color: white;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.cookie-actions button:nth-child(1) {\n  background: #c93312;\n}\n.cookie-actions button:nth-child(2) {\n  background: #000;\n}\n.cookie-actions button:nth-child(3) {\n  background: #c93312;\n}\n\n/* Toggle Switch */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 42px;\n  height: 24px;\n}\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.slider {\n  position: absolute;\n  cursor: pointer;\n  background-color: #ccc;\n  border-radius: 34px;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transition: 0.4s;\n}\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 4px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\ninput:checked + .slider {\n  background-color: #c93312;\n}\ninput:checked + .slider:before {\n  transform: translateX(18px);\n}\n\np {\n  font-size: 18px;\n  line-height: 1.5;\n  font-family: \"Helvetica\", sans-serif;\n}\n\np.large {\n  font-size: 20px;\n  line-height: 1.5;\n}\n\na {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.btn:hover {\n  opacity: 0.75;\n}\n\n.back-arrow {\n  left: -4.5%;\n  transition: all 0.3s ease-in-out;\n  cursor: pointer;\n}\n\n.back-arrow:hover {\n  border: 1px solid #000;\n}\n\n.text-muted {\n  text-align: end;\n  font-size: 14px;\n}\n\nhtml body h1 {\n  font-size: 4.6rem !important;\n  line-height: 1.1;\n  font-family: \"Helvetica\", sans-serif;\n}\n\nhtml body .grey-btn {\n  background-color: #0e0e0e !important;\n  color: #fff !important;\n  border: none;\n  padding: 7px 36px !important;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 600 !important;\n}\n\n.red-buy {\n  background-color: #c93312 !important;\n  color: #fff !important;\n  border: none;\n  padding: 7px 36px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 400 !important;\n  text-decoration: none;\n  border: 1px solid #00000072;\n  display: inline-block;\n}\n\n.grey-use {\n  background-color: #0e0e0e !important;\n  color: #fff !important;\n  border: none;\n  padding: 7px 36px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 400 !important;\n  text-decoration: none;\n  display: inline-block;\n}\n.css-shadow-6 {\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important;\n}\n/* Base styles for the tab */\n.tabcust {\n  background-color: #f1f4f9 !important;\n  border-radius: 19px;\n  transition:\n    background-color 1s,\n    transform 1s !important;\n  padding: 10px 20px !important;\n\n  cursor: pointer !important;\n\n  font-family: Arial, sans-serif;\n}\n\n/* Active state styles */\n.tabcust.active {\n  background-color: #a8c0ff !important;\n  transform: scale(1.1) !important;\n}\n\n/* Example hover effect (optional) */\n.tabcust:hover {\n  background-color: #dce6f9 !important;\n  cursor: pointer !important;\n}\n\nhtml body .red-btn {\n  background-color: #c93312 !important;\n  color: #fff !important;\n  border: none;\n  font-weight: 600 !important;\n  padding: 6px 36px !important;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 15px;\n  text-decoration: none;\n}\n\nhtml body .shadow {\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px !important;\n}\n\n.card-img-wrapper {\n  position: relative;\n  overflow: hidden;\n}\n\n.listing-img {\n  border-top-right-radius: 30px;\n}\n\n.card-img-wrapper img {\n  width: 100%;\n  height: 220px;\n  object-fit: cover;\n  object-position: center;\n  transition: transform 0.3s ease-in-out;\n}\n\n/* 👇 Apply 4:3 frame only on small → large screens */\n@media (max-width: 1024px) {\n  .card-img-wrapper {\n    aspect-ratio: 4 / 3;\n  }\n\n  .listing-img {\n    aspect-ratio: 4 / 3;\n  }\n  .card-img-wrapper img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n}\n\n/* 👇 Keep the rounded corner on large screens and above */\n@media (min-width: 1024px) {\n  .card-img-wrapper,\n  .listing-img {\n    border-top-right-radius: 30px;\n  }\n}\n\n@media (min-width: 992px) {\n  .rounded-tr-lg {\n    border-top-right-radius: 30px !important;\n  }\n}\n\n.p-image-mask {\n  z-index: 1300 !important;\n}\n.p-component-overlay-enter {\n  z-index: 1300 !important;\n}\n.p-image-action {\n  color: #fff !important;\n}\n.testelips {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.modal {\n  z-index: 1210 !important;\n}\n\n.modal-width {\n  max-width: 80% !important;\n  margin: auto !important;\n  z-index: 1210;\n  height: 100%;\n  background-color: transparent;\n}\n\n.seller-popup {\n  max-width: 73% !important;\n}\n\n.seller-popup .modal-content {\n  height: 76vh !important;\n  margin-bottom: 4% !important;\n}\n\n.stepper-modal {\n  max-width: 90% !important;\n  margin: auto !important;\n  z-index: 1210;\n  height: 100%;\n  background-color: transparent;\n}\n\n.modal-width .modal-content {\n  background-color: transparent;\n  border: none;\n  height: 90vh;\n}\n\n.modal-width .modal-body {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.tabs-wrapper .MuiTabs-root {\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.tabs-wrapper .MuiTabs-scroller,\n.tabs-wrapper .MuiTabs-flexContainer,\n.tabs-wrapper .MuiTabs-flexContainerVertical {\n  width: 100%;\n}\n\n.tabs-wrapper .MuiTabs-flexContainerVertical {\n  align-items: stretch;\n  gap: 4px;\n}\n\n.tabs-wrapper .MuiButtonBase-root {\n  align-items: flex-start !important;\n  text-transform: none !important;\n  font-weight: 700;\n  border-radius: 12px;\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  justify-content: flex-start !important;\n  box-sizing: border-box;\n}\n\n.alert-modal .modal-content {\n  border-radius: 32px;\n}\n\n.tabs-wrapper .MuiTabs-indicator {\n  display: none;\n}\n\n.bg-announcement {\n  background: rgba(235, 138, 62, 0.4);\n  background: linear-gradient(\n    173deg,\n    rgba(235, 138, 62, 0.4) 0%,\n    rgba(235, 138, 62, 0.2) 100%\n  );\n}\n\n/* .seller-board{\n opacity: 0;\n}\n\n.avatar-wrapper:hover + .seller-board{\n    opacity: 1;\n\n} */\n\n.tabs-wrapper .MuiButtonBase-root.Mui-selected {\n  background-color: #373a3b !important;\n  color: #fff !important;\n}\n\n.card:hover img {\n  transform: scale(1.15);\n}\n\n.card .card-title {\n  font-weight: 600;\n}\n\n.login-logo {\n  max-width: 210px;\n}\n\ninput {\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.main-wrapper {\n  position: relative;\n  min-height: 100vh;\n}\n\n.test {\n  border: 2px solid red;\n}\n\n.main-content {\n  padding-bottom: 60px !important;\n}\n.breadcrumb {\n  background-color: #f8f9fa;\n}\n\n.card {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  border-radius: 0.25rem;\n}\n\n.card-title {\n  margin-bottom: 1.5rem;\n}\n\n.display-4 {\n  font-weight: 300;\n  font-size: 3.5rem;\n}\n\n.badge-success {\n  background-color: #28a745;\n}\n\n.pagination .page-item .page-link {\n  color: #007bff;\n}\n\n.pagination .page-item.disabled .page-link {\n  color: #6c757d;\n}\n\n.nav-tabs .nav-link.active {\n  background-color: #fff;\n  border-color: #dee2e6 #dee2e6 #fff;\n}\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-bottom: 10px;\n  font-weight: 700;\n}\n\nh1 {\n  margin-top: 20px;\n  font-size: 38px;\n  line-height: 44px;\n}\n\nh2 {\n  margin-top: 20px;\n  font-size: 32px;\n  line-height: 36px;\n}\n\nh3 {\n  margin-top: 20px;\n  font-size: 24px;\n  line-height: 30px;\n}\n\nh4 {\n  margin-top: 10px;\n  font-size: 18px;\n  line-height: 24px;\n}\n\nh5 {\n  margin-top: 10px;\n  font-size: 14px;\n  line-height: 20px;\n}\n\nh6 {\n  margin-top: 10px;\n  font-size: 12px;\n  line-height: 18px;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n\nblockquote {\n  border-left: 5px solid #e2e2e2;\n  margin: 0 0 10px;\n  padding: 10px 20px;\n  font-size: 18px;\n  line-height: 22px;\n}\n\nfigure {\n  margin: 0 0 10px;\n}\n\nfigcaption {\n  text-align: center;\n  margin-top: 5px;\n}\n\nul,\nol {\n  margin-top: 0;\n  margin-bottom: 10px;\n  padding-left: 40px;\n}\n\na {\n  color: #0f141f;\n}\n\n.post-template-custom_blog_post_template {\n  background-color: #fbfcfd;\n}\n\n.custom-blog-post {\n  padding-top: 90px;\n}\n\n.custom-blog-post#content.post {\n  max-width: 1114px;\n  margin-top: 0;\n}\n\n.article-grid {\n  max-width: 1114px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 110px;\n  display: grid;\n  grid-column-gap: 0px;\n  grid-row-gap: 0px;\n  grid-template-rows: auto;\n  grid-template-columns: 2.75fr 1fr;\n  border-bottom: 1px solid #eceef0;\n  border-left: 1px solid #eceef0;\n  border-right: 1px solid #eceef0;\n  border-radius: 0 0 8px 8px;\n  background-color: #fff;\n}\n\n.article {\n  padding: 70px 80px 50px 50px;\n  font-style: normal;\n}\n\n.article #ez-toc-container {\n  display: none;\n}\n\n.sidebar {\n  border-left: 1px solid #f8f9fa;\n  padding: 70px 25px;\n}\n\n.sidebar-sticky {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 100px;\n}\n\n.sidebar-sticky #ez-toc-container {\n  background: none;\n  border: none;\n  box-shadow: none;\n}\n\n.sidebar-sticky div#ez-toc-container .ez-toc-title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.5;\n  color: #0f141f;\n}\n\n.sidebar-sticky .table-of-content nav {\n  margin-top: 15px;\n}\n\n.sidebar-sticky .table-of-content nav ul {\n  grid-row-gap: 4px;\n  flex-direction: column;\n  margin-bottom: 40px;\n  display: flex;\n}\n\n.sidebar-sticky #ez-toc-container a {\n  color: #667085;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n.sidebar-sticky #ez-toc-container a.active {\n  color: #0a8bfe;\n}\n\n.post-head {\n  width: 100%;\n  padding-top: 50px;\n  padding-left: 50px;\n  padding-right: 50px;\n  position: relative;\n  max-width: 1114px;\n  margin-left: auto;\n  margin-right: auto;\n  border-top: 1px solid #eceef0;\n  border-bottom: 1px solid #f8f9fa;\n  border-left: 1px solid #eceef0;\n  border-right: 1px solid #eceef0;\n  background-color: #fff;\n  border-radius: 8px 8px 0 0;\n}\n\n/* post author wrapper */\n\n.post-fields-wrap {\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 60px;\n  display: flex;\n}\n\n.post-main-heading {\n  max-width: 33ch;\n  letter-spacing: -1.28px;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 35.5px;\n  font-weight: 600;\n  line-height: 54px;\n}\n\n.post-subtitle-text {\n  max-width: 66ch;\n  color: #344054;\n  margin-bottom: 0;\n  line-height: 26px;\n}\n\n.post-subtitle-wrap {\n  margin-top: 40px;\n  margin-bottom: 60px;\n}\n\n.reading-time-wrap,\n.fields-wrapper,\n.author-wrap {\n  grid-column-gap: 15px;\n  align-items: center;\n  display: flex;\n}\n\n.date-wrap {\n  grid-column-gap: 5px;\n  border-left: 0.5px solid rgba(152, 162, 179, 0.4);\n  padding-left: 15px;\n  display: flex;\n}\n\n.category-wrap {\n  border-left: 1px rgba(152, 162, 179, 0.8);\n  padding-left: 0;\n}\n\n.post-author-image {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n}\n\n.reading-time-text {\n  grid-column-gap: 3.5px;\n  color: #667085;\n  background-color: #eff0f4;\n  border: 1px dashed #d0d5dd;\n  border-radius: 10px;\n  align-items: center;\n  padding: 7px 10px;\n  font-family: Geistmono, sans-serif;\n  font-weight: 500;\n  line-height: 18px;\n  display: flex;\n}\n\n.category-text {\n  color: #0081f1;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 23px;\n}\n\n.category-nav-btn {\n  transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.category-nav-btn:hover:not(.category-nav-btn--active) {\n  color: #f5c4b8 !important;\n}\n\n.category-nav-btn--active {\n  color: #c93312 !important;\n  font-weight: 700 !important;\n}\n\n/* Categories page — main category navigation bar */\n.category-nav-bar {\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 14px;\n  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.06);\n  overflow: visible;\n  position: relative;\n}\n\n.category-nav-bar__list {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 0.35rem 0.5rem;\n  scrollbar-width: thin;\n}\n\n.category-nav-bar__list::-webkit-scrollbar {\n  height: 6px;\n}\n\n.category-nav-bar__list::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.15);\n  border-radius: 999px;\n}\n\n.category-nav-bar__item {\n  flex: 1 1 0;\n  min-width: 108px;\n  position: relative;\n}\n\n.category-nav-bar__trigger {\n  align-items: center;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  border-radius: 10px;\n  color: #333;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  justify-content: center;\n  min-height: 88px;\n  padding: 0.65rem 0.5rem 0.55rem;\n  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;\n  width: 100%;\n}\n\n.category-nav-bar__trigger:hover,\n.category-nav-bar__item--open .category-nav-bar__trigger {\n  background: rgba(201, 51, 18, 0.04);\n}\n\n.category-nav-bar__trigger--active {\n  border-bottom-color: #c93312;\n  color: #c93312;\n}\n\n.category-nav-bar__icon {\n  height: 28px;\n  object-fit: contain;\n  width: 28px;\n}\n\n.category-nav-bar__icon--fallback {\n  align-items: center;\n  color: #666;\n  display: flex;\n  flex-shrink: 0;\n  height: 28px;\n  justify-content: center;\n  width: 28px;\n}\n\n.category-nav-bar__icon--fallback svg {\n  display: block;\n}\n\n.category-nav-bar__trigger--active .category-nav-bar__icon--fallback {\n  color: #c93312;\n}\n\n.category-nav-bar__label {\n  align-items: center;\n  display: grid;\n  font-size: 0.82rem;\n  font-weight: 600;\n  grid-template-columns: 1fr auto 1fr;\n  line-height: 1.25;\n  width: 100%;\n}\n\n.category-nav-bar__label-text {\n  grid-column: 2;\n  text-align: center;\n}\n\n.category-nav-bar__chevron {\n  align-self: center;\n  grid-column: 3;\n  justify-self: start;\n  margin-left: 0.1rem;\n}\n\n.category-nav-bar--panel-open .category-nav-bar__list {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.category-nav-bar__mega-panel {\n  animation: categoryMegaFadeIn 0.15s ease;\n  background: #fafafa;\n  border-radius: 0 0 14px 14px;\n  overflow: hidden;\n}\n\n@keyframes categoryMegaFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.category-nav-bar__mega-columns {\n  display: flex;\n  min-height: 220px;\n}\n\n.category-nav-bar__mega-columns--stacked {\n  flex-direction: column;\n  min-height: 0;\n}\n\n.category-nav-bar__mega-columns--subs-only {\n  min-height: 0;\n}\n\n.category-nav-bar__mega-columns--subs-only .category-nav-bar__mega-col--subs {\n  border-right: none;\n  width: 100%;\n}\n\n.category-nav-bar__mega-col {\n  padding: 1rem 1.15rem;\n}\n\n.category-nav-bar__mega-col--subs {\n  border-right: 1px solid rgba(0, 0, 0, 0.08);\n  min-width: 240px;\n  width: 38%;\n}\n\n.category-nav-bar__mega-columns--stacked .category-nav-bar__mega-col--subs {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  border-right: none;\n  min-width: 0;\n  width: 100%;\n}\n\n.category-nav-bar__mega-col--subsubs {\n  flex: 1;\n  min-width: 0;\n}\n\n.category-nav-bar__mega-heading {\n  color: #6c757d;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  margin-bottom: 0.65rem;\n  text-transform: uppercase;\n}\n\n.category-nav-bar__sub-list {\n  list-style: none;\n  margin: 0;\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.category-nav-bar__sub-btn {\n  align-items: center;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  color: #222;\n  cursor: pointer;\n  display: flex;\n  font-size: 0.9rem;\n  font-weight: 500;\n  gap: 0.5rem;\n  justify-content: space-between;\n  padding: 0.65rem 0.75rem;\n  text-align: left;\n  transition: background 0.15s ease, color 0.15s ease;\n  width: 100%;\n}\n\n.category-nav-bar__sub-btn:hover,\n.category-nav-bar__sub-btn--hover {\n  background: rgba(201, 51, 18, 0.08);\n  color: #c93312;\n}\n\n.category-nav-bar__sub-btn--active {\n  background: rgba(201, 51, 18, 0.14);\n  color: #c93312;\n  font-weight: 600;\n}\n\n.category-nav-bar__subsub-list--panel {\n  list-style: none;\n  margin: 0;\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.category-nav-bar__subsub-btn {\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  color: #444;\n  cursor: pointer;\n  display: block;\n  font-size: 0.875rem;\n  padding: 0.55rem 0.75rem;\n  text-align: left;\n  transition: background 0.15s ease, color 0.15s ease;\n  width: 100%;\n}\n\n.category-nav-bar__subsub-btn:hover,\n.category-nav-bar__subsub-btn--active {\n  background: rgba(201, 51, 18, 0.08);\n  color: #c93312;\n  font-weight: 600;\n}\n\n.category-nav-bar__view-all {\n  align-items: center;\n  background: #fff;\n  border: none;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n  color: #c93312;\n  cursor: pointer;\n  display: flex;\n  font-size: 0.88rem;\n  font-weight: 700;\n  gap: 0.25rem;\n  justify-content: flex-start;\n  padding: 0.85rem 1.15rem;\n  width: 100%;\n}\n\n.category-nav-bar__view-all:hover {\n  background: rgba(201, 51, 18, 0.04);\n}\n\n.category-nav-bar__empty {\n  color: #6c757d;\n  font-size: 0.85rem;\n  padding: 0.5rem 0.75rem;\n}\n\n@media (max-width: 991px) {\n  .category-nav-bar__list {\n    display: grid;\n    gap: 0.3rem;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    overflow-x: hidden;\n    padding: 0.4rem;\n  }\n\n  .category-nav-bar__item {\n    min-width: 0;\n  }\n\n  .category-nav-bar__trigger {\n    min-height: 78px;\n    padding: 0.55rem 0.35rem 0.5rem;\n  }\n\n  .category-nav-bar__icon,\n  .category-nav-bar__icon--fallback {\n    height: 24px;\n    width: 24px;\n  }\n\n  .category-nav-bar__label {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    font-size: 0.76rem;\n    gap: 0.1rem;\n    width: 100%;\n  }\n\n  .category-nav-bar__label-text {\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    display: -webkit-box;\n    line-height: 1.15;\n    max-width: 100%;\n    overflow: hidden;\n    text-align: center;\n    white-space: normal;\n    word-break: break-word;\n  }\n\n  .category-nav-bar__chevron {\n    display: none;\n  }\n\n  .category-nav-bar__mega-columns {\n    min-height: 0;\n  }\n}\n\n@media (max-width: 767px) {\n  .category-nav-bar {\n    border-radius: 12px;\n  }\n\n  .category-nav-bar__list {\n    gap: 0.35rem;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    padding: 0.5rem;\n  }\n\n  .category-nav-bar__item {\n    min-width: 0;\n  }\n\n  .category-nav-bar__trigger {\n    min-height: 84px;\n    padding: 0.55rem 0.4rem 0.5rem;\n  }\n\n  .category-nav-bar__label {\n    font-size: 0.74rem;\n  }\n\n  .category-nav-bar__mega-panel {\n    border-radius: 0 0 12px 12px;\n  }\n\n  .category-nav-bar__mega-col {\n    padding: 0.85rem 1rem;\n  }\n}\n\n.category-selection-breadcrumb {\n  padding-left: 0.25rem;\n  border-left: 2px solid #dee2e6;\n  margin-left: 0.25rem;\n  padding-left: 0.75rem;\n}\n\n/* Blog detail page */\n.blog-detail__article {\n  max-width: 100%;\n  width: 100%;\n}\n\n.blog-detail__title {\n  color: #1e1e1e;\n  font-family: \"Helvetica Bold\", Helvetica, Arial, sans-serif;\n  font-size: clamp(1.5rem, 5vw, 2.75rem);\n  font-weight: 700;\n  line-height: 1.3;\n  margin: 0 0 1rem;\n  max-width: 100%;\n  word-break: break-word;\n}\n\n/* article post content */\n\n.article p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #0f141f;\n  letter-spacing: -0.14px;\n  margin-bottom: 14px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.article a {\n  color: #0a8bfe;\n}\n\n.article em {\n  background-color: #dcf6e1;\n  font-style: normal;\n}\n\n.article img {\n  display: block;\n  max-width: 100%;\n  border-radius: 8px;\n}\n\n.article ul,\n.article ol {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.article ul li,\n.article ol li {\n  font-size: 16px;\n}\n\n.article h2,\n.article h3,\n.article h4,\n.article h5,\n.article h6 {\n  color: #0f141f;\n  margin-bottom: 25px;\n  margin-top: 50px;\n  line-height: 1.3;\n}\n\n.article blockquote {\n  /* border-left: 5px dashed #d0d5dd; */\n  border: 1px solid #eaeaea;\n  border-radius: 12px;\n  padding: 20px 30px;\n  font-size: 16px;\n  line-height: 2;\n  color: #344054;\n  margin-top: 30px;\n  margin-bottom: 30px;\n  background: #f2f4f7;\n}\n\n.article figure {\n  max-width: 100%;\n  border-radius: 8px;\n}\n\n.article video {\n  border-radius: 8px;\n}\n\n.sidebar-cta {\n  background-color: #fff;\n  border: 1px dashed #d0d5dd;\n  border-radius: 14px;\n  padding: 30px;\n  display: block;\n}\n\n.sidebar-cta-paragraph {\n  letter-spacing: -0.04px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  line-height: 21px;\n}\n\n.sidebar-cta-button {\n  background-color: #0081f1;\n  border-radius: 10px;\n  justify-content: space-between;\n  align-items: center;\n  padding: 11.5px 15px;\n  display: flex;\n  cursor: pointer;\n  gap: 8px;\n}\n\n.sidebar-cta-button:hover {\n  background-color: #006adc;\n}\n\n.sidebar-cta-text {\n  color: #fff;\n  font-size: 12.8px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.after-blog-post-container {\n  color: #fff;\n  border: 1px solid #dfe3e6;\n  background-color: transparent;\n  background-image: radial-gradient(at top center, #172a3f 0%, #0f1720 63%);\n  border-radius: 8px;\n  padding-left: 20px;\n  padding-right: 20px;\n  max-width: 1114px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 48px 0 64px 0;\n  grid-row-gap: 20px;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  display: flex;\n  margin-bottom: 150px;\n}\n\n.after-blog-post-container .forminator-custom-form {\n  max-width: 360px;\n}\n\n.related-articles-container {\n  max-width: 1114px;\n\n  margin-left: auto;\n  margin-right: auto;\n  grid-row-gap: 20px;\n  flex-direction: column;\n  align-items: center;\n  display: flex;\n  padding-bottom: 20px;\n}\n\n.related-articles-container .collection-title {\n  margin: 20px 0 60px 0;\n}\n\n.related-collection-list {\n  grid-column-gap: 14px;\n  grid-row-gap: 14px;\n  grid-template-rows: auto;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-columns: 1fr;\n  align-content: stretch;\n  justify-content: stretch;\n  margin: -1px;\n  display: grid;\n}\n\n.post-card-wrapper {\n  font-weight: normal;\n}\n\n.blog-cta-block {\n  border-radius: 8px;\n  border: 1px solid #b7d9f8;\n  padding: 24px;\n  width: 100%;\n  background-color: #edf6ff;\n  flex-direction: column;\n  align-items: flex-start;\n  display: flex;\n}\n.slider-container {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: auto;\n}\n\n.slider-container img {\n  width: 100%;\n  height: auto;\n  display: block;\n  transition: transform 0.3s ease-in-out;\n}\n\n.image-slide-in-right {\n  animation: slideInRight 0.3s ease-in-out forwards;\n}\n\n.image-slide-out-left {\n  animation: slideOutLeft 0.3s ease-in-out forwards;\n}\n\n.image-slide-in-left {\n  animation: slideInLeft 0.3s ease-in-out forwards;\n}\n\n.image-slide-out-right {\n  animation: slideOutRight 0.3s ease-in-out forwards;\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideOutLeft {\n  from {\n    transform: translateX(0);\n    opacity: 1;\n  }\n  to {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n}\n\n@keyframes slideInLeft {\n  from {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideOutRight {\n  from {\n    transform: translateX(0);\n    opacity: 1;\n  }\n  to {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n}\n\n/* Slider button styles */\n.slider-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  background: linear-gradient(135deg, #ff3e1f, #ff6b4e);\n  border-radius: 50%;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.slider-button svg {\n  color: #fff;\n  font-size: 18px;\n}\n\n.slider-button:hover:not(.disabled) {\n  background: linear-gradient(135deg, #e63515, #f75a3d);\n  transform: scale(1.1);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);\n}\n\n.slider-button.disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.slider-button.disabled svg {\n  color: #888;\n}\n\n/* Adjust spacing for buttons */\n.d-flex.justify-content-end.gap-3 {\n  margin-right: 10px;\n}\n\n/* Slider Image Animation */\n@keyframes slideInFromRight {\n  0% {\n    opacity: 0;\n    transform: translateX(20%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideOutToLeft {\n  0% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(-20%);\n  }\n}\n\n@keyframes slideInFromLeft {\n  0% {\n    opacity: 0;\n    transform: translateX(-20%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideOutToRight {\n  0% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(20%);\n  }\n}\n\n.image-slide-in-right {\n  animation: slideInFromRight 0.8s ease-in-out;\n}\n\n.image-slide-out-left {\n  animation: slideOutToLeft 0.8s ease-in-out;\n}\n\n.image-slide-in-left {\n  animation: slideInFromLeft 0.8s ease-in-out;\n}\n\n.image-slide-out-right {\n  animation: slideOutToRight 0.8s ease-in-out;\n}\n\n/* Button Hover Animation */\n@keyframes buttonHover {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 rgba(0, 0, 0, 0);\n  }\n  100% {\n    transform: scale(1.1);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n  }\n}\n\n.arrow-button {\n  cursor: pointer;\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.arrow-button:hover {\n  animation: buttonHover 0.3s ease-in-out forwards;\n}\n\n/* Optional: Styling for the buttons to make them more visible */\n.arrow-button {\n  font-size: 48px;\n  padding: 10px;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.1);\n  color: #000;\n}\n\n/* Adding transitions for the entire slider section */\n.slider-container {\n  transition:\n    transform 0.8s ease-in-out,\n    opacity 0.8s ease-in-out;\n}\n\n.blog-cta-block .actions-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.blog-cta-block .actions-wrapper span {\n  font-size: 12px;\n  color: #00254d;\n}\n\n.blog-cta-block .letter-heading {\n  font-size: 24px;\n}\n\n.blog-cta-block .letter-paragraph,\n.blog-cta-block .letter-heading {\n  margin-top: 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.blog-cta-block .actions-wrapper {\n  align-items: center;\n}\n\n.blog-cta-block .letter-heading {\n  color: #006adc;\n}\n\n.blog-cta-block .letter-paragraph {\n  color: #00254d;\n}\n\n.blog-cta-block .secondary-button {\n  background-color: #fff;\n  border-radius: 10px;\n  justify-content: space-between;\n  align-items: center;\n  padding: 11.5px 15px;\n  display: flex;\n  cursor: pointer;\n  border: 1px solid #d0d5dd;\n}\n\n.blog-cta-block .secondary-button:hover {\n  background-color: #eceef0;\n}\n\n.blog-cta-block .secondary-button-text {\n  color: #0f1720;\n  font-size: 12.8px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.after-blog-post-container .actions-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.custom-blog-post .video-wrapper {\n  padding: 0 24px;\n  margin-bottom: 110px;\n}\n\n.custom-blog-post .video-wrapper video {\n  width: 100%;\n  border-radius: 8px;\n  box-shadow: 0px 0px 0px 8px #0081f1;\n}\n\n.after-blog-post-container .actions-wrapper span {\n  font-size: 12px;\n  color: #7e868c;\n}\n.comments-area a,\n.page-content a {\n  text-decoration: underline;\n}\n\n.alignright {\n  float: right;\n  margin-left: 1rem;\n}\n\n.alignleft {\n  float: left;\n  margin-right: 1rem;\n}\n\n.aligncenter {\n  clear: both;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.alignwide {\n  margin-left: -80px;\n  margin-right: -80px;\n}\n\n.alignfull {\n  margin-left: calc(50% - 50vw);\n  margin-right: calc(50% - 50vw);\n  max-width: 100vw;\n}\n\n.alignfull,\n.alignfull img {\n  width: 100vw;\n}\n\n.wp-caption {\n  margin-bottom: 1.25rem;\n  max-width: 100%;\n}\n\n.wp-caption.alignleft {\n  margin: 5px 20px 20px 0;\n}\n\n.wp-caption.alignright {\n  margin: 5px 0 20px 20px;\n}\n\n.wp-caption img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.wp-caption-text {\n  margin: 0;\n}\n\n.gallery-caption {\n  display: block;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  margin: 0;\n  padding: 0.75rem;\n}\n\n.pagination {\n  margin: 20px auto;\n}\n\n.sticky {\n  position: relative;\n  display: block;\n}\n\n.bypostauthor {\n  font-size: inherit;\n}\n\n.hide {\n  display: none !important;\n}\n\n.post-password-form p {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n}\n\n.post-password-form [type=\"submit\"] {\n  margin-left: 3px;\n}\n\n.screen-reader-text {\n  clip: rect(1px, 1px, 1px, 1px);\n  height: 1px;\n  overflow: hidden;\n  position: absolute !important;\n  width: 1px;\n  word-wrap: normal !important;\n}\n\n.screen-reader-text:focus {\n  background-color: #eee;\n  clip: auto !important;\n  -webkit-clip-path: none;\n  clip-path: none;\n  color: #333;\n  display: block;\n  font-size: 1rem;\n  height: auto;\n  left: 5px;\n  line-height: normal;\n  padding: 15px 23px 14px;\n  text-decoration: none;\n  top: 5px;\n  width: auto;\n  z-index: 100000;\n}\n\n.site-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  position: relative;\n}\n\n.site-header .site-navigation {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.site-header .site-branding {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.site-header .header-inner {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.site-header .header-inner .custom-logo-link {\n  display: block;\n}\n\n.site-header .header-inner .site-branding .site-description,\n.site-header .header-inner .site-branding .site-title {\n  margin: 0;\n}\n\n.site-header .header-inner .site-branding.show-logo .site-title,\n.site-header .header-inner .site-branding.show-title .site-logo {\n  display: none !important;\n}\n\n.site-header:not(.header-stacked) .header-inner .site-branding {\n  max-width: 30%;\n}\n\n.site-header:not(.header-stacked) .header-inner .site-navigation {\n  max-width: 70%;\n}\n\n.site-header.header-inverted .header-inner {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n}\n\n.site-header.header-inverted .header-inner .site-branding {\n  text-align: right;\n}\n\n.site-header.header-inverted .header-inner .site-navigation {\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: start;\n}\n\n.site-header.header-stacked .header-inner {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  text-align: center;\n}\n\n@media (max-width: 576px) {\n  .site-header .header-inner:not(.header-stacked) .site-branding {\n    max-width: 80%;\n  }\n}\n\n.site-footer {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  position: relative;\n}\n\n.site-footer .footer-inner {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.site-footer .footer-inner .custom-logo-link {\n  display: block;\n}\n\n.site-footer .footer-inner .site-navigation {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.site-footer .footer-inner .site-branding {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.site-footer .footer-inner .site-branding .site-description,\n.site-footer .footer-inner .site-branding .site-title {\n  margin: 0;\n}\n\n.site-footer .footer-inner .site-branding.show-logo .site-title,\n.site-footer .footer-inner .site-branding.show-title .site-logo {\n  display: none !important;\n}\n\n.site-footer .footer-inner .copyright {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.site-footer .footer-inner .copyright p {\n  margin: 0;\n}\n\n.site-footer.footer-inverted .footer-inner {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n}\n\n.site-footer.footer-inverted .footer-inner .site-branding {\n  text-align: right;\n}\n\n.site-footer.footer-inverted .footer-inner .site-navigation {\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n\n.site-footer.footer-has-copyright .footer-inner .site-navigation {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.site-footer.footer-stacked .footer-inner {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  text-align: center;\n}\n\n.site-footer.footer-stacked .footer-inner .site-branding h4.site-title {\n  text-align: center;\n}\n\n.site-footer.footer-stacked .footer-inner .site-navigation .menu {\n  padding: 0;\n}\n\n.site-footer:not(.footer-stacked) .footer-inner .site-branding {\n  max-width: 20%;\n}\n\n.site-footer:not(.footer-stacked) .footer-inner .site-navigation {\n  max-width: 60%;\n}\n\n.site-footer:not(.footer-stacked) .footer-inner .copyright {\n  max-width: 20%;\n}\n\n@media (max-width: 576px) {\n  .site-footer:not(.footer-stacked) .footer-inner .copyright,\n  .site-footer:not(.footer-stacked) .footer-inner .site-branding,\n  .site-footer:not(.footer-stacked) .footer-inner .site-navigation {\n    display: block;\n    text-align: center;\n    width: 100%;\n    max-width: none;\n  }\n\n  .site-footer .footer-inner .site-navigation ul.menu {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n\n  .site-footer .footer-inner .site-navigation ul.menu li {\n    display: inline-block;\n  }\n}\n\n.post .entry-title a {\n  text-decoration: none;\n}\n\n.post .wp-post-image {\n  width: 100%;\n  max-height: 500px;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n@media (max-width: 991px) {\n  .post .wp-post-image {\n    max-height: 400px;\n  }\n}\n\n@media (max-width: 575px) {\n  .post .wp-post-image {\n    max-height: 300px;\n  }\n}\n\n#comments .comment-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-size: 0.9em;\n}\n\n#comments .comment,\n#comments .pingback {\n  position: relative;\n}\n\n#comments .comment .comment-body,\n#comments .pingback .comment-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding: 30px 0 30px 60px;\n  border-bottom: 1px solid #ccc;\n}\n\nbody.rtl #comments .comment .comment-body,\nbody.rtl #comments .pingback .comment-body {\n  padding: 30px 60px 30px 0;\n}\n\n.thumbnail-container {\n  position: relative;\n  display: inline-block;\n}\n\n.delete-icon {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  z-index: 10;\n  transition: opacity 0.2s;\n}\n\n.delete-button {\n  cursor: pointer;\n  background-color: white;\n  border-radius: 50%;\n  padding: 2px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.delete-button:hover {\n  background-color: #f5f5f5;\n}\n\n#comments .comment .avatar,\n#comments .pingback .avatar {\n  position: absolute;\n  left: 0;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\nbody.rtl #comments .comment .avatar,\nbody.rtl #comments .pingback .avatar {\n  left: auto;\n  right: 0;\n  margin-right: 0;\n  margin-left: 10px;\n}\n\n#comments .comment-meta {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  margin-bottom: 0.9rem;\n}\n\n#comments .comment-metadata,\n#comments .reply {\n  font-size: 11px;\n  line-height: 1;\n}\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Slightly darker for better contrast */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000; /* Ensure it is above other content */\n  backdrop-filter: blur(10px); /* Blurring the background */\n  animation: fadeIn 0.5s ease-in-out; /* Smooth fade-in effect */\n}\n\n.loader-icon {\n  border: 6px solid rgba(255, 255, 255, 0.3);\n  border-top: 6px solid white;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite; /* Spinning loader icon */\n  margin-bottom: 20px;\n}\n\n.loader-text {\n  font-size: 24px;\n  color: white;\n  font-weight: bold;\n  text-align: center;\n  animation: pulse 1.5s infinite; /* Pulsing effect for the text */\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6); /* Subtle shadow for better readability */\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.loader-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.1),\n    rgba(0, 0, 0, 0.1)\n  );\n  z-index: -1;\n  pointer-events: none;\n}\n\n#comments .children {\n  position: relative;\n  list-style: none;\n  margin: 0;\n  padding-left: 30px;\n}\n\nbody.rtl #comments .children {\n  padding-left: 0;\n  padding-right: 30px;\n}\n\n#comments .children li:last-child {\n  padding-bottom: 0;\n}\n\n#comments ol.comment-list .children:before {\n  display: inline-block;\n  font-size: 1em;\n  font-weight: 400;\n  line-height: 100%;\n  content: \"\\21AA\";\n  position: absolute;\n  top: 45px;\n  left: 0;\n  width: auto;\n}\n\nbody.rtl #comments ol.comment-list .children:before {\n  content: \"\\21A9\";\n  left: auto;\n  right: 0;\n}\n\n@media (min-width: 768px) {\n  #comments .comment-author,\n  #comments .comment-metadata {\n    line-height: 1;\n  }\n}\n\n@media (min-width: 1800px) {\n  .stepper-modal {\n    max-width: 70% !important;\n  }\n}\n\n@media (max-width: 767px) {\n  #comments .comment .comment-body {\n    padding: 30px 0;\n  }\n\n  #comments .children {\n    padding-left: 20px;\n  }\n\n  #comments .comment .avatar {\n    position: inherit;\n    float: left;\n  }\n\n  body.rtl #comments .comment .avatar {\n    float: right;\n  }\n}\n\n.site-header.header-inverted .site-navigation-toggle-holder {\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n\n.site-header.header-stacked .site-navigation-toggle-holder {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  max-width: 100%;\n}\n\n.site-header.menu-layout-dropdown .site-navigation {\n  display: none;\n}\n\n.site-navigation-toggle-holder {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  max-width: 20%;\n  padding: 8px 15px;\n}\n\n.site-navigation-toggle-holder,\n.site-navigation-toggle-holder .site-navigation-toggle {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.site-navigation-toggle-holder .site-navigation-toggle {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  font-size: 22px;\n  padding: 0.25em;\n  cursor: pointer;\n  border: 0 solid;\n  border-radius: 3px;\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #494c4f;\n}\n\n.site-navigation-toggle-holder.elementor-active\n  .site-navigation-toggle\n  i:before {\n  content: \"\\e87f\";\n}\n\n.site-navigation {\n  grid-area: nav-menu;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n}\n\n.site-navigation ul.menu,\n.site-navigation ul.menu ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.site-navigation ul.menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.site-navigation ul.menu li {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.site-navigation ul.menu li a {\n  display: block;\n  padding: 8px 15px;\n}\n\n.site-navigation ul.menu li.menu-item-has-children {\n  padding-right: 15px;\n}\n\n.site-navigation ul.menu li.menu-item-has-children:after {\n  display: block;\n  content: \"\\25BE\";\n  font-size: 1.5em;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #666;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  text-decoration: none;\n}\n\n.site-navigation ul.menu li.menu-item-has-children:focus-within > ul {\n  display: block;\n}\n\n.site-navigation ul.menu li ul {\n  background: #fff;\n  display: none;\n  min-width: 150px;\n  position: absolute;\n  z-index: 2;\n  left: 0;\n  top: 100%;\n}\n\n.site-navigation ul.menu li ul li {\n  border-bottom: 1px solid #eee;\n}\n\n.site-navigation ul.menu li ul li:last-child {\n  border-bottom: none;\n}\n\n.site-navigation ul.menu li ul li.menu-item-has-children a {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n}\n\n.site-navigation ul.menu li ul li.menu-item-has-children:after {\n  -webkit-transform: translateY(-50%) rotate(-90deg);\n  -ms-transform: translateY(-50%) rotate(-90deg);\n  transform: translateY(-50%) rotate(-90deg);\n}\n\n.site-navigation ul.menu li ul ul {\n  left: 100%;\n  top: 0;\n}\n\n.site-navigation ul.menu li:hover > ul {\n  display: block;\n}\n\nfooter .site-navigation ul.menu li ul {\n  top: auto;\n  bottom: 100%;\n}\n\nfooter .site-navigation ul.menu li ul ul {\n  bottom: 0;\n}\n\nfooter .site-navigation ul.menu a {\n  padding: 5px 15px;\n}\n\n.site-navigation-dropdown {\n  margin-top: 10px;\n  -webkit-transition:\n    max-height 0.3s,\n    -webkit-transform 0.3s;\n  transition:\n    max-height 0.3s,\n    -webkit-transform 0.3s;\n  -o-transition:\n    max-height 0.3s,\n    transform 0.3s;\n  transition:\n    max-height 0.3s,\n    transform 0.3s;\n  transition:\n    max-height 0.3s,\n    transform 0.3s,\n    -webkit-transform 0.3s;\n  -webkit-transform-origin: top;\n  -ms-transform-origin: top;\n  transform-origin: top;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 10000;\n  width: 100%;\n}\n\n.site-navigation-toggle-holder:not(.elementor-active)\n  + .site-navigation-dropdown {\n  -webkit-transform: scaleY(0);\n  -ms-transform: scaleY(0);\n  transform: scaleY(0);\n  max-height: 0;\n}\n\n.site-navigation-toggle-holder.elementor-active + .site-navigation-dropdown {\n  -webkit-transform: scaleY(1);\n  -ms-transform: scaleY(1);\n  transform: scaleY(1);\n  max-height: 100vh;\n}\n\n.site-navigation-dropdown ul {\n  padding: 0;\n}\n\n.site-navigation-dropdown ul.menu {\n  position: absolute;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  background: #fff;\n}\n\n.site-navigation-dropdown ul.menu li {\n  display: block;\n  width: 100%;\n  position: relative;\n}\n\n.site-navigation-dropdown ul.menu li a {\n  display: block;\n  padding: 20px;\n  background: #fff;\n  color: #55595c;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.10196078431372549);\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.10196078431372549);\n}\n\n.site-navigation-dropdown ul.menu li.current-menu-item a {\n  color: #fff;\n  background: #55595c;\n}\n\n.site-navigation-dropdown ul.menu > li li {\n  -webkit-transition:\n    max-height 0.3s,\n    -webkit-transform 0.3s;\n  transition:\n    max-height 0.3s,\n    -webkit-transform 0.3s;\n  -o-transition:\n    max-height 0.3s,\n    transform 0.3s;\n  transition:\n    max-height 0.3s,\n    transform 0.3s;\n  transition:\n    max-height 0.3s,\n    transform 0.3s,\n    -webkit-transform 0.3s;\n  -webkit-transform-origin: top;\n  -ms-transform-origin: top;\n  transform-origin: top;\n  -webkit-transform: scaleY(0);\n  -ms-transform: scaleY(0);\n  transform: scaleY(0);\n  max-height: 0;\n}\n\n.site-navigation-dropdown ul.menu li.elementor-active > ul > li {\n  -webkit-transform: scaleY(1);\n  -ms-transform: scaleY(1);\n  transform: scaleY(1);\n  max-height: 100vh;\n}\n.no-hover-img:hover img {\n  transform: none !important;\n}\n@media (max-width: 576px) {\n  .site-header.menu-dropdown-mobile:not(.menu-layout-dropdown)\n    .site-navigation {\n    display: none !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .site-header.menu-dropdown-mobile:not(.menu-layout-dropdown)\n    .site-navigation-toggle-holder {\n    display: none !important;\n  }\n}\n\n@media (min-width: 576px) and (max-width: 767px) {\n  .site-header.menu-dropdown-mobile:not(.menu-layout-dropdown)\n    .site-navigation {\n    display: none !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .site-header.menu-dropdown-tablet:not(.menu-layout-dropdown)\n    .site-navigation-toggle-holder {\n    display: none !important;\n  }\n}\n\n@media (max-width: 992px) {\n  .site-header.menu-dropdown-tablet:not(.menu-layout-dropdown)\n    .site-navigation {\n    display: none !important;\n  }\n}\n\n.site-header.menu-dropdown-none:not(.menu-layout-dropdown)\n  .site-navigation-toggle-holder {\n  display: none !important;\n}\n\n.page-header .entry-title,\n.site-footer .footer-inner,\n.site-footer:not(.dynamic-footer),\n.site-header .header-inner,\n.site-header:not(.dynamic-header),\nbody:not([class*=\"elementor-page-\"]) .site-main {\n  margin-right: auto;\n  margin-left: auto;\n  width: 100%;\n}\n\n@media (max-width: 575px) {\n  .page-header .entry-title,\n  .site-footer .footer-inner,\n  .site-footer:not(.dynamic-footer),\n  .site-header .header-inner,\n  .site-header:not(.dynamic-header),\n  body:not([class*=\"elementor-page-\"]) .site-main {\n    padding-right: 10px;\n    padding-left: 10px;\n  }\n}\n\n@media (min-width: 576px) {\n  .page-header .entry-title,\n  .site-footer .footer-inner,\n  .site-footer:not(.dynamic-footer),\n  .site-header .header-inner,\n  .site-header:not(.dynamic-header),\n  body:not([class*=\"elementor-page-\"]) .site-main {\n    max-width: 500px;\n  }\n\n  .site-footer.footer-full-width .footer-inner,\n  .site-header.header-full-width .header-inner {\n    max-width: 100%;\n  }\n}\n\n@media (min-width: 768px) {\n  .page-header .entry-title,\n  .site-footer .footer-inner,\n  .site-footer:not(.dynamic-footer),\n  .site-header .header-inner,\n  .site-header:not(.dynamic-header),\n  body:not([class*=\"elementor-page-\"]) .site-main {\n    max-width: 600px;\n  }\n\n  .site-footer.footer-full-width,\n  .site-header.header-full-width {\n    max-width: 100%;\n  }\n}\n\n@media (min-width: 992px) {\n  .page-header .entry-title,\n  .site-footer .footer-inner,\n  .site-footer:not(.dynamic-footer),\n  .site-header .header-inner,\n  .site-header:not(.dynamic-header),\n  body:not([class*=\"elementor-page-\"]) .site-main {\n    max-width: 800px;\n  }\n\n  .site-footer.footer-full-width,\n  .site-header.header-full-width {\n    max-width: 100%;\n  }\n}\n\n@media (min-width: 1200px) {\n  .page-header .entry-title,\n  .site-footer .footer-inner,\n  .site-footer:not(.dynamic-footer),\n  .site-header .header-inner,\n  .site-header:not(.dynamic-header),\n  body:not([class*=\"elementor-page-\"]) .site-main {\n    max-width: 1140px;\n  }\n\n  .site-footer.footer-full-width,\n  .site-header.header-full-width {\n    max-width: 100%;\n  }\n}\n\n.site-header + .elementor {\n  min-height: calc(100vh - 320px);\n}\n\n@media screen and (max-width: 1440px) {\n  .related-collection-list {\n    margin-bottom: -2px;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .article {\n    padding: 40px 30px 40px 20px;\n  }\n  .related-collection-list {\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .post-head {\n    padding-top: 30px;\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n  .article-grid {\n    grid-template-columns: 1fr;\n  }\n  .sidebar {\n    padding-top: 40px;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .post-fields-wrap {\n    width: 100%;\n    grid-row-gap: 15px;\n    flex-direction: column;\n    margin-bottom: 30px;\n  }\n  .post-main-heading {\n    font-size: 30px;\n    line-height: 42px;\n  }\n  .post-subtitle-wrap {\n    margin-top: 25px;\n    margin-bottom: 35px;\n  }\n  .post-subtitle-text {\n    font-size: 14px;\n  }\n\n  .reading-time-wrap {\n    align-items: center;\n    margin-right: auto;\n  }\n\n  .fields-wrapper {\n    width: 100%;\n    flex-direction: row;\n  }\n  .category-text {\n    font-size: 14px;\n  }\n  .related-collection-list {\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n  }\n  .post-head,\n  .article-grid {\n    border-radius: 0;\n  }\n  .related-articles-container {\n    padding: 0 20px;\n  }\n  .after-blog-post-container {\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n}\n\n@media screen and (max-width: 479px) {\n  .site-main.custom-blog_post {\n    padding-top: 20px;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .post-head {\n    padding: 20px 20px 0;\n  }\n  .article-grid {\n    grid-template-rows: auto auto;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    overflow: hidden;\n  }\n\n  .article {\n    padding-right: 20px;\n  }\n\n  .sidebar {\n    border-left-style: none;\n    order: -9999;\n    padding: 40px 20px 10px 20px;\n  }\n  .sidebar-sticky #ez-toc-container {\n    margin-bottom: 40px;\n  }\n  .post-fields-wrap {\n    grid-row-gap: 10px;\n    margin-bottom: 0;\n    padding-bottom: 20px;\n  }\n  .post-main-heading {\n    font-size: 27.8px;\n  }\n\n  .post-subtitle-text {\n    max-width: 100%;\n    line-height: 23px;\n  }\n\n  .reading-time-wrap {\n    grid-column-gap: 15px;\n    align-items: center;\n    display: flex;\n  }\n\n  .fields-wrapper {\n    grid-column-gap: 10px;\n    justify-content: flex-start;\n  }\n\n  .author-wrap {\n    grid-column-gap: 10px;\n  }\n\n  .date-wrap {\n    border-left-color: rgba(152, 162, 179, 0.4);\n    align-items: center;\n    padding-left: 10px;\n    font-size: 12px;\n  }\n\n  .category-wrap {\n    border-left-style: none;\n    padding-left: 0;\n  }\n\n  .post-author-image {\n    width: 24px;\n    height: 24px;\n  }\n\n  .post-date {\n    font-size: 12px;\n  }\n\n  .reading-time-text {\n    padding: 4px 6px;\n    font-size: 12px;\n  }\n  .category-text {\n    font-size: 12px;\n  }\n  #ez-toc-container {\n    padding: 0;\n  }\n  .after-blog-post-container {\n    padding: 20px;\n  }\n  .blog-cta-block {\n    padding: 20px;\n    grid-row-gap: 16px;\n  }\n  .blog-cta-block .letter-heading {\n    font-size: 24px;\n  }\n\n  .blog-cta-block .letter-paragraph {\n    white-space: normal;\n    margin: 10px 0;\n  }\n  .blog-cta-block .actions-wrapper {\n    flex-direction: column;\n  }\n  .related-articles-container .collection-title {\n    margin: 20px 0 30px 0;\n  }\n  .post-card-heading {\n    min-height: 10px;\n  }\n}\n\n/* Add more common styles as needed */\n\n/* media query */\n\n@media (min-width: 940px) and (max-width: 1170px) {\n  .main-content {\n    padding-bottom: 360px !important;\n  }\n}\n@media (max-width: 1024px) {\n  .main-wrapper {\n    position: relative;\n  }\n\n  html body h1 {\n    font-size: 3.6rem !important;\n  }\n\n  .back-arrow {\n    left: 0px;\n    top: -36px;\n  }\n}\n\n@media (max-width: 900px) {\n  .navbar {\n    background-color: #c93312 !important;\n  }\n}\n@media (max-width: 768px) {\n  .navbar {\n    background-color: #c93312 !important;\n  }\n\n  .seller-popup .modal-content {\n    margin-bottom: 0vh;\n  }\n\n  .sales-items-wrapper h5 {\n    font-size: 17px;\n    margin-bottom: 4px;\n  }\n\n  .sales-items-wrapper p {\n    font-size: 15px;\n  }\n\n  .card .card-body {\n    padding: 12px;\n  }\n\n  body {\n    font-size: 16px;\n  }\n\n  p.large {\n    font-size: 17px;\n  }\n\n  .mb-hidden {\n    display: none !important;\n  }\n\n  .modal-width {\n    max-width: calc(100% - 24px) !important;\n    margin: 12px auto !important;\n  }\n\n  .modal-width .modal-content {\n    height: auto;\n    max-height: 92vh;\n  }\n\n  p {\n    font-size: 16px;\n    line-height: 1.5;\n  }\n\n  .seller-popup {\n    max-width: 80% !important;\n  }\n\n  html body h1 {\n    font-size: 2.4rem !important;\n  }\n  .tabs-wrapper {\n    flex-wrap: wrap;\n  }\n\n  .tabs-wrapper .MuiTabs-root {\n    width: 60%;\n    margin: auto;\n  }\n\n  .tabs-wrapper .MuiBox-root {\n    padding: 20px 10px;\n  }\n\n  .mb-radius {\n    border-top-right-radius: 75px !important;\n    border-bottom-left-radius: 75px !important;\n  }\n}\n\n@media (max-width: 510px) {\n  .btn-nav > a[href] > div {\n    width: 30px;\n  }\n}\n\n@media (max-width: 474px) {\n  .login-btn {\n    padding: 8px !important;\n  }\n\n  .login-logo {\n    max-width: 170px;\n  }\n\n  .card .card-title {\n    font-size: 17px;\n  }\n\n  .card .card-body {\n    padding: 10px 8px;\n  }\n\n  .text-muted {\n    font-size: 13px;\n  }\n}\n\n/* Custom styles for Bootstrap toggle switches in cookie preferences */\n.form-check-input:checked {\n  background-color: #c93312 !important;\n  border-color: #c93312 !important;\n}\n\n.form-check-input:focus {\n  border-color: #c93312 !important;\n  box-shadow: 0 0 0 0.25rem rgba(201, 51, 18, 0.25) !important;\n}\n\n.form-check-input:checked:focus {\n  box-shadow: 0 0 0 0.25rem rgba(201, 51, 18, 0.25) !important;\n}\n\n/* Hide PrimeReact Image preview toolbar buttons */\n.p-image-toolbar,\n.p-image-preview-container .p-image-toolbar,\n.p-component .p-image-toolbar,\ndiv[data-pc-name=\"image\"] .p-image-toolbar {\n  display: none !important;\n  visibility: hidden !important;\n}\n\n/* Seller dashboard */\n.seller-dashboard {\n  --seller-accent: #c93312;\n  --seller-accent-dark: #954001;\n  --seller-surface: #ffffff;\n  --seller-muted: #6c757d;\n  --seller-border: rgba(0, 0, 0, 0.06);\n  --seller-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n.seller-dashboard__hero {\n  background: linear-gradient(135deg, #fff8f3 0%, #fff 55%, #faf6ef 100%);\n  border: 1px solid var(--seller-border);\n  border-radius: 20px;\n  padding: 1.5rem 1.75rem;\n  box-shadow: var(--seller-shadow);\n}\n\n.seller-dashboard__eyebrow {\n  color: var(--seller-accent);\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.seller-dashboard__title {\n  color: #1a1a1a;\n  font-size: clamp(1.75rem, 3vw, 2.25rem);\n  font-weight: 700;\n  line-height: 1.15;\n}\n\n.seller-dashboard__subtitle {\n  color: var(--seller-muted);\n  font-size: 0.95rem;\n  max-width: 42rem;\n}\n\n.seller-dashboard__stats-grid {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: minmax(0, 1fr);\n}\n\n@media (min-width: 576px) {\n  .seller-dashboard__stats-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .seller-dashboard__stat-card:last-child:nth-child(3) {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (min-width: 992px) {\n  .seller-dashboard__stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .seller-dashboard__stat-card:last-child:nth-child(3) {\n    grid-column: auto;\n  }\n}\n\n.seller-dashboard__stat-card {\n  background: var(--seller-surface);\n  border: 1px solid var(--seller-border);\n  border-radius: 18px;\n  box-shadow: var(--seller-shadow);\n  display: flex;\n  gap: 1rem;\n  min-height: 118px;\n  min-width: 0;\n  padding: 1.25rem 1.35rem;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n@media (hover: hover) {\n  .seller-dashboard__stat-card:hover {\n    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);\n    transform: translateY(-2px);\n  }\n}\n\n.seller-dashboard__stat-icon {\n  align-items: center;\n  border-radius: 14px;\n  display: flex;\n  flex-shrink: 0;\n  height: 52px;\n  justify-content: center;\n  width: 52px;\n}\n\n.seller-dashboard__stat-icon--earnings {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.seller-dashboard__stat-icon--listings {\n  background: #e3f2fd;\n  color: #1565c0;\n}\n\n.seller-dashboard__stat-icon--balance {\n  background: #fff0eb;\n  color: var(--seller-accent);\n}\n\n.seller-dashboard__pln-glyph,\n.seller-dashboard__currency-glyph {\n  font-family: \"Helvetica Bold\", Helvetica, Arial, sans-serif;\n  font-size: 1.15rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1;\n}\n\n.admin-dashboard__pln-icon {\n  align-items: center;\n  color: #c93312;\n  display: flex;\n  height: 48px;\n  justify-content: center;\n  width: 48px;\n}\n\n.admin-dashboard__pln-glyph {\n  font-family: \"Helvetica Bold\", Helvetica, Arial, sans-serif;\n  font-size: 1.35rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1;\n}\n\n.seller-dashboard__stat-label {\n  color: var(--seller-muted);\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 0.35rem;\n}\n\n.seller-dashboard__stat-value {\n  color: #111;\n  font-size: clamp(1.25rem, 2.5vw, 1.75rem);\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n.seller-dashboard__actions-grid {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: minmax(0, 1fr);\n}\n\n@media (min-width: 992px) {\n  .seller-dashboard__actions-grid {\n    grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);\n  }\n}\n\n.seller-dashboard__panel {\n  background: var(--seller-surface);\n  border: 1px solid var(--seller-border);\n  border-radius: 20px;\n  box-shadow: var(--seller-shadow);\n  height: 100%;\n  padding: 1.5rem;\n}\n\n.seller-dashboard__panel-header {\n  align-items: flex-start;\n  display: flex;\n  gap: 0.875rem;\n  margin-bottom: 1.25rem;\n}\n\n.seller-dashboard__panel-icon {\n  align-items: center;\n  background: #fff4ec;\n  border-radius: 14px;\n  color: var(--seller-accent-dark);\n  display: flex;\n  flex-shrink: 0;\n  height: 48px;\n  justify-content: center;\n  width: 48px;\n}\n\n.seller-dashboard__panel-title {\n  color: #111;\n  font-size: 1.15rem;\n  font-weight: 700;\n  margin-bottom: 0.25rem;\n}\n\n.seller-dashboard__panel-text {\n  color: var(--seller-muted);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.seller-dashboard__sale-form {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: minmax(0, 1fr);\n}\n\n@media (min-width: 576px) and (max-width: 991px) {\n  .seller-dashboard__sale-form {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .seller-dashboard__sale-form .seller-dashboard__field:first-child {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (min-width: 992px) {\n  .seller-dashboard__sale-form {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.seller-dashboard__field-label {\n  color: #444;\n  display: block;\n  font-size: 0.8rem;\n  font-weight: 600;\n  margin-bottom: 0.4rem;\n}\n\n.seller-dashboard__field .form-control,\n.seller-dashboard__field .form-select {\n  background: #f8f9fb;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  min-height: 44px;\n}\n\n.seller-dashboard__field .form-control:focus,\n.seller-dashboard__field .form-select:focus {\n  border-color: rgba(201, 51, 18, 0.45);\n  box-shadow: 0 0 0 0.2rem rgba(201, 51, 18, 0.12);\n}\n\n.seller-dashboard__btn {\n  appearance: none;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n  line-height: 1.2;\n  padding: 0.7rem 1.25rem;\n  transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease;\n}\n\n.seller-dashboard__btn:hover:not(:disabled) {\n  opacity: 0.92;\n  transform: translateY(-1px);\n}\n\n.seller-dashboard__btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.seller-dashboard .seller-dashboard__btn--primary {\n  background-color: #954001;\n  color: #fff;\n}\n\n.seller-dashboard .seller-dashboard__btn--primary:hover:not(:disabled) {\n  background-color: #7d3601;\n  color: #fff;\n}\n\n.seller-dashboard .seller-dashboard__btn--primary:disabled {\n  background-color: #954001;\n  color: #fff;\n}\n\n.seller-dashboard .seller-dashboard__btn--danger {\n  background-color: #c93312;\n  color: #fff;\n}\n\n.seller-dashboard .seller-dashboard__btn--danger:hover:not(:disabled) {\n  background-color: #a82910;\n  color: #fff;\n}\n\n.seller-dashboard .seller-dashboard__btn--danger:disabled {\n  background-color: #c93312;\n  color: #fff;\n}\n\n.seller-dashboard__btn--ghost {\n  background-color: #fff;\n  border: 1px solid #ddd;\n  color: #333;\n}\n\n.seller-dashboard__sale-actions {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  justify-content: flex-start;\n  margin-top: 1.25rem;\n}\n\n.seller-dashboard__sale-actions .seller-dashboard__btn {\n  flex: 1 1 140px;\n  min-width: 140px;\n}\n\n.seller-dashboard__panel--sale {\n  display: flex;\n  flex-direction: column;\n}\n\n.seller-dashboard__sale-status {\n  align-items: center;\n  background: linear-gradient(90deg, #fff8f5 0%, #fff 100%);\n  border: 1px solid rgba(149, 64, 1, 0.18);\n  border-radius: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  padding: 0.85rem 1rem;\n}\n\n.seller-dashboard__sale-status-label {\n  color: #666;\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.seller-dashboard__sale-status-value {\n  color: #111;\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.seller-dashboard__sale-hint {\n  color: var(--seller-muted);\n  font-size: 0.85rem;\n  margin-top: 0.85rem;\n}\n\n.seller-dashboard__current-sale {\n  align-items: center;\n  background: linear-gradient(90deg, #fff8f5 0%, #fff 100%);\n  border: 1px solid rgba(149, 64, 1, 0.18);\n  border-radius: 16px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n}\n\n.seller-dashboard__current-sale-title {\n  color: #111;\n  font-size: 1rem;\n  font-weight: 700;\n  margin-bottom: 0.75rem;\n}\n\n.seller-dashboard__badge {\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.35rem 0.75rem;\n}\n\n.seller-dashboard__badge--active {\n  background: #d1e7dd;\n  color: #0f5132;\n}\n\n.seller-dashboard__badge--inactive {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.seller-dashboard__payout-card {\n  background: linear-gradient(160deg, #1f2937 0%, #111827 100%);\n  border-radius: 20px;\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1.5rem;\n}\n\n.seller-dashboard__payout-header {\n  align-items: center;\n  display: flex;\n  gap: 0.875rem;\n}\n\n.seller-dashboard__payout-icon {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.12);\n  border-radius: 14px;\n  display: flex;\n  height: 48px;\n  justify-content: center;\n  width: 48px;\n}\n\n.seller-dashboard__payout-label {\n  color: rgba(255, 255, 255, 0.72);\n  font-size: 0.8rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.seller-dashboard__payout-title {\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.seller-dashboard__payout-copy {\n  color: rgba(255, 255, 255, 0.78);\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.seller-dashboard__payout-footer {\n  align-items: center;\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: space-between;\n  margin-top: auto;\n  padding-top: 1rem;\n}\n\n.seller-dashboard__payout-balance-label {\n  color: rgba(255, 255, 255, 0.65);\n  display: block;\n  font-size: 0.78rem;\n  margin-bottom: 0.15rem;\n}\n\n.seller-dashboard__payout-balance {\n  color: #fff;\n  display: block;\n  font-size: 1.5rem;\n  line-height: 1.1;\n}\n\n\n.seller-dashboard__balance-split {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.seller-dashboard__balance-row {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 1rem;\n  justify-content: space-between;\n}\n\n.seller-dashboard__balance-meta {\n  align-items: center;\n  display: inline-flex;\n  gap: 0.45rem;\n}\n\n.seller-dashboard__balance-dot {\n  border-radius: 50%;\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.12);\n  display: inline-block;\n  flex: 0 0 auto;\n  height: 0.55rem;\n  width: 0.55rem;\n}\n\n.seller-dashboard__balance-dot--available {\n  background: #34d399;\n  box-shadow: 0 0 0 3px rgba(52, 211, 153, 0.22);\n}\n\n.seller-dashboard__balance-dot--pending {\n  background: #fbbf24;\n  box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.22);\n}\n\n.seller-dashboard__payout-balance--pending {\n  color: rgba(255, 255, 255, 0.78);\n  font-size: 1.2rem;\n}\n\n.seller-dashboard__stat-subvalue {\n  color: #6b7280;\n  font-size: 0.82rem;\n  font-weight: 600;\n  margin-top: 0.35rem;\n}\n\n.seller-dashboard__stat-label .seller-dashboard__balance-dot--available {\n  box-shadow: 0 0 0 3px rgba(52, 211, 153, 0.18);\n}\n\n.seller-dashboard__stat-subvalue .seller-dashboard__balance-dot--pending {\n  box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.18);\n}\n\n.seller-dashboard__payout-hint {\n  color: rgba(255, 255, 255, 0.62);\n  font-size: 0.82rem;\n}\n\n.seller-dashboard__transactions-header {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.seller-dashboard__section-title {\n  color: #111;\n  font-size: 1.35rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.seller-dashboard__billing-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.seller-dashboard__billing-card--pro {\n  background: linear-gradient(160deg, #fffdfb 0%, #fff 45%, #fff8f3 100%);\n}\n\n.seller-dashboard__billing-title-row {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.75rem;\n  margin-bottom: 0.35rem;\n}\n\n.seller-dashboard__billing-stripe-icon {\n  align-items: center;\n  background: #f6f9fc;\n  border: 1px solid #e6ebf1;\n  border-radius: 14px;\n  display: flex;\n  flex-shrink: 0;\n  height: 48px;\n  justify-content: center;\n  width: 48px;\n}\n\n.seller-dashboard__billing-features {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  margin-top: 1rem;\n}\n\n.seller-dashboard__billing-feature {\n  align-items: flex-start;\n  color: var(--seller-muted);\n  display: flex;\n  font-size: 0.875rem;\n  gap: 0.5rem;\n  line-height: 1.45;\n}\n\n.seller-dashboard__billing-feature svg {\n  color: #2e7d32;\n  flex-shrink: 0;\n  margin-top: 0.1rem;\n}\n\n.seller-dashboard__billing-status-text {\n  color: var(--seller-muted);\n  font-size: 0.9rem;\n  line-height: 1.5;\n  margin-top: 0.75rem;\n}\n\n.seller-dashboard__billing-actions {\n  border-top: 1px solid var(--seller-border);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-top: auto;\n  padding-top: 1.25rem;\n}\n\n.seller-dashboard__billing-info {\n  background: linear-gradient(135deg, #f8fafc 0%, #fff 100%);\n}\n\n.seller-dashboard__badge--warning {\n  background: #fff3cd;\n  color: #664d03;\n}\n\n@media (max-width: 575.98px) {\n  .seller-dashboard__billing-title-row {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 0.35rem;\n  }\n\n  .seller-dashboard__billing-actions .seller-dashboard__btn {\n    width: 100%;\n  }\n}\n\n/* Stripe region selection modal (Payments connect flow) */\n.stripe-region-modal .modal-content {\n  border: none;\n  border-radius: 20px;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18);\n  overflow: hidden;\n}\n\n.stripe-region-modal__header {\n  background: linear-gradient(135deg, #f8fafc 0%, #fff 55%, #f6f9fc 100%);\n  border-bottom: 1px solid #e8edf3;\n  padding: 1.35rem 1.5rem 1.15rem;\n}\n\n.stripe-region-modal__header-content {\n  align-items: flex-start;\n  display: flex;\n  gap: 0.85rem;\n  padding-right: 1.5rem;\n}\n\n.stripe-region-modal__icon-wrap {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e6ebf1;\n  border-radius: 14px;\n  box-shadow: 0 4px 12px rgba(99, 91, 255, 0.08);\n  color: #635bff;\n  display: flex;\n  flex-shrink: 0;\n  height: 44px;\n  justify-content: center;\n  width: 44px;\n}\n\n.stripe-region-modal__title {\n  font-size: 1.2rem;\n  font-weight: 700;\n  line-height: 1.3;\n  margin-bottom: 0.35rem;\n}\n\n.stripe-region-modal__subtitle {\n  color: #64748b;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.stripe-region-modal__body {\n  padding: 1.25rem 1.5rem 0.5rem;\n}\n\n.stripe-region-modal__search-wrap {\n  align-items: center;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  display: flex;\n  gap: 0.65rem;\n  margin-bottom: 1rem;\n  padding: 0.85rem 1rem;\n}\n\n.stripe-region-modal__search-icon {\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.stripe-region-modal__search-input {\n  background: transparent;\n  border: none;\n  box-shadow: none !important;\n  color: #0f172a;\n  font-size: 0.92rem;\n  padding: 0;\n}\n\n.stripe-region-modal__search-input::placeholder {\n  color: #94a3b8;\n}\n\n.stripe-region-modal__select-shell {\n  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 18px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);\n  padding: 1rem;\n}\n\n.stripe-region-modal__select-label {\n  color: #475569;\n  display: block;\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  margin-bottom: 0.5rem;\n}\n\n.stripe-region-modal__select {\n  appearance: none;\n  -webkit-appearance: none;\n  background:\n    linear-gradient(45deg, transparent 50%, #475569 50%),\n    linear-gradient(135deg, #475569 50%, transparent 50%),\n    linear-gradient(to right, #fff, #fff);\n  background-position:\n    calc(100% - 20px) calc(50% - 3px),\n    calc(100% - 14px) calc(50% - 3px),\n    100% 0;\n  background-repeat: no-repeat;\n  background-size:\n    6px 6px,\n    6px 6px,\n    2.75rem 100%;\n  border: 1px solid #dbe4ee;\n  border-radius: 14px;\n  color: #0f172a;\n  font-size: 0.95rem;\n  font-weight: 500;\n  outline: none;\n  padding: 0.9rem 3rem 0.9rem 1rem;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease,\n    background-color 0.2s ease;\n  width: 100%;\n}\n\n.stripe-region-modal__select:focus {\n  border-color: #635bff;\n  box-shadow: 0 0 0 4px rgba(99, 91, 255, 0.12);\n}\n\n.stripe-region-modal__selected-card {\n  align-items: center;\n  background: linear-gradient(135deg, #111827 0%, #1f2937 100%);\n  border-radius: 18px;\n  color: #fff;\n  display: flex;\n  gap: 0.9rem;\n  margin-top: 1rem;\n  padding: 1rem;\n}\n\n.stripe-region-modal__selected-flag {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 16px;\n  display: flex;\n  flex-shrink: 0;\n  font-size: 1.9rem;\n  height: 56px;\n  justify-content: center;\n  width: 56px;\n}\n\n.stripe-region-modal__selected-copy {\n  flex: 1;\n  min-width: 0;\n}\n\n.stripe-region-modal__selected-topline {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.3rem;\n}\n\n.stripe-region-modal__selected-name {\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.stripe-region-modal__selected-code {\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  padding: 0.2rem 0.55rem;\n}\n\n.stripe-region-modal__selected-text {\n  color: rgba(255, 255, 255, 0.78);\n  font-size: 0.84rem;\n  line-height: 1.5;\n}\n\n.stripe-region-modal__selected-check {\n  color: #86efac;\n  flex-shrink: 0;\n}\n\n.stripe-region-modal__empty-state {\n  align-items: center;\n  background: #f8fafc;\n  border: 1px dashed #cbd5e1;\n  border-radius: 16px;\n  color: #64748b;\n  display: flex;\n  gap: 0.55rem;\n  justify-content: center;\n  margin-top: 1rem;\n  padding: 0.95rem 1rem;\n  text-align: center;\n}\n\n.stripe-region-modal__empty-search {\n  color: #b91c1c;\n  font-size: 0.82rem;\n  margin-top: 0.85rem;\n  text-align: center;\n}\n\n.stripe-region-modal__note {\n  color: #94a3b8;\n  font-size: 0.78rem;\n  line-height: 1.5;\n  margin: 1rem 0 0;\n  text-align: center;\n}\n\n.stripe-region-modal__footer {\n  background: #f8fafc;\n  border-top: 1px solid #e8edf3;\n  gap: 0.65rem;\n  justify-content: flex-end;\n  padding: 1rem 1.5rem 1.25rem;\n}\n\n.stripe-region-modal__btn {\n  appearance: none;\n  -webkit-appearance: none;\n  border: none;\n  border-radius: 999px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  line-height: 1.2;\n  padding: 0.65rem 1.35rem;\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease,\n    opacity 0.2s ease,\n    transform 0.15s ease;\n}\n\n.stripe-region-modal__btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.stripe-region-modal__btn:disabled {\n  cursor: not-allowed;\n}\n\n.stripe-region-modal__btn--ghost {\n  background-color: transparent;\n  border: 1px solid #cbd5e1;\n  color: #475569;\n}\n\n.stripe-region-modal__btn--ghost:hover:not(:disabled) {\n  background-color: #e8edf3;\n  border-color: #94a3b8;\n  color: #334155;\n}\n\n.stripe-region-modal__footer .stripe-region-modal__btn--primary {\n  background-color: #111;\n  border: 2px solid #111;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.18);\n  color: #fff;\n  min-width: 170px;\n}\n\n.stripe-region-modal__footer .stripe-region-modal__btn--primary:hover:not(:disabled) {\n  background-color: #2d2d2d;\n  border-color: #2d2d2d;\n  color: #fff;\n}\n\n.stripe-region-modal__footer .stripe-region-modal__btn--primary:disabled {\n  background-color: #94a3b8;\n  border-color: #94a3b8;\n  box-shadow: none;\n  color: #fff;\n  opacity: 1;\n}\n\n@media (max-width: 575.98px) {\n  .stripe-region-modal__header,\n  .stripe-region-modal__body,\n  .stripe-region-modal__footer {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .stripe-region-modal__footer {\n    flex-direction: column-reverse;\n  }\n\n  .stripe-region-modal__selected-card {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .stripe-region-modal__selected-check {\n    display: none;\n  }\n\n  .stripe-region-modal__btn {\n    width: 100%;\n  }\n}\n\n/* Dashboard sidebar (seller + user, mobile/tablet drawer + desktop) */\n.dashboard-sidebar {\n  background: linear-gradient(180deg, #171b26 0%, #12151d 100%);\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 100%;\n  overflow: hidden;\n}\n\n.dashboard-sidebar__header {\n  align-items: flex-start;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  gap: 0.75rem;\n  justify-content: space-between;\n  padding: 1.25rem 1rem 1rem;\n}\n\n.dashboard-sidebar__brand {\n  align-items: center;\n  display: flex;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.dashboard-sidebar__logo {\n  flex-shrink: 0;\n  height: 36px;\n  width: 36px;\n}\n\n.dashboard-sidebar__eyebrow {\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.dashboard-sidebar__title {\n  color: #fff;\n  font-size: 1.15rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.dashboard-sidebar__close {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.08);\n  border: none;\n  border-radius: 10px;\n  color: #fff;\n  cursor: pointer;\n  display: inline-flex;\n  flex-shrink: 0;\n  height: 36px;\n  justify-content: center;\n  transition: background 0.2s ease;\n  width: 36px;\n}\n\n.dashboard-sidebar__close:hover {\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.dashboard-sidebar__switch {\n  align-items: center;\n  background: linear-gradient(90deg, #c93312 0%, #a82910 100%);\n  border-radius: 12px;\n  color: #fff !important;\n  display: flex;\n  font-size: 0.875rem;\n  font-weight: 600;\n  gap: 0.5rem;\n  justify-content: space-between;\n  margin: 1rem 1rem 0.5rem;\n  padding: 0.85rem 1rem;\n  text-decoration: none;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.dashboard-sidebar__switch:hover {\n  box-shadow: 0 8px 20px rgba(201, 51, 18, 0.28);\n  color: #fff;\n  transform: translateY(-1px);\n}\n\n.dashboard-sidebar__nav {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 0.35rem;\n  overflow-y: auto;\n  padding: 0.75rem 0.75rem 1rem;\n}\n\n.dashboard-sidebar__link {\n  align-items: center;\n  border-radius: 12px;\n  color: rgba(255, 255, 255, 0.78);\n  display: flex;\n  gap: 0.75rem;\n  min-height: 48px;\n  padding: 0.65rem 0.85rem;\n  text-decoration: none;\n  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;\n}\n\n.dashboard-sidebar__link:hover {\n  background: rgba(255, 255, 255, 0.06);\n  color: #fff;\n}\n\n.dashboard-sidebar__link--active {\n  background: rgba(201, 51, 18, 0.16);\n  box-shadow: inset 3px 0 0 #c93312;\n  color: #fff;\n}\n\n.dashboard-sidebar__link-icon {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 10px;\n  display: inline-flex;\n  flex-shrink: 0;\n  height: 36px;\n  justify-content: center;\n  width: 36px;\n}\n\n.dashboard-sidebar__link--active .dashboard-sidebar__link-icon {\n  background: rgba(201, 51, 18, 0.22);\n  color: #ffb09a;\n}\n\n.dashboard-sidebar__link-label {\n  font-size: 0.95rem;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.dashboard-sidebar__footer {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.04);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  gap: 0.75rem;\n  margin-top: auto;\n  min-width: 0;\n  overflow: hidden;\n  padding: 1rem;\n}\n\n.dashboard-sidebar__profile {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.dashboard-sidebar__profile-name {\n  color: #fff;\n  font-size: 0.95rem;\n  font-weight: 700;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dashboard-sidebar__profile-email {\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 0.78rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (max-width: 767px) {\n  .dashboard-sidebar__header {\n    padding-top: 1rem;\n  }\n\n  .dashboard-sidebar__switch {\n    margin-left: 0.85rem;\n    margin-right: 0.85rem;\n  }\n\n  .dashboard-sidebar__nav {\n    padding-left: 0.65rem;\n    padding-right: 0.65rem;\n  }\n\n  .dashboard-sidebar__link {\n    min-height: 50px;\n  }\n}\n\n.seller-dashboard__transactions-scroll {\n  -webkit-overflow-scrolling: touch;\n  margin-left: -0.25rem;\n  margin-right: -0.25rem;\n  overflow-x: auto;\n  padding-bottom: 0.25rem;\n  width: 100%;\n}\n\n@media (max-width: 767px) {\n  .seller-dashboard .container {\n    padding-left: 0.75rem !important;\n    padding-right: 0.75rem !important;\n  }\n\n  .seller-dashboard__hero {\n    border-radius: 16px;\n    padding: 1.1rem 1rem;\n  }\n\n  .seller-dashboard__title {\n    font-size: clamp(1.45rem, 6vw, 1.85rem);\n  }\n\n  .seller-dashboard__subtitle {\n    font-size: 0.9rem;\n  }\n\n\n  .seller-dashboard__stat-card {\n    min-height: 100px;\n    padding: 1rem;\n  }\n\n  .seller-dashboard__stat-icon {\n    height: 46px;\n    width: 46px;\n  }\n\n  .seller-dashboard__panel,\n  .seller-dashboard__payout-card {\n    border-radius: 16px;\n    padding: 1.1rem 1rem;\n  }\n\n  .seller-dashboard__panel-header {\n    align-items: center;\n  }\n\n  .seller-dashboard__payout-footer {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .seller-dashboard__payout-footer .seller-dashboard__btn {\n    width: 100%;\n  }\n\n  .seller-dashboard__sale-actions .seller-dashboard__btn {\n    flex: 1 1 100%;\n    width: 100%;\n  }\n\n  .seller-dashboard__current-sale {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .seller-dashboard__transactions-header {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .seller-dashboard__transactions-header .btn {\n    width: 100%;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .seller-dashboard__hero {\n    padding: 1.35rem 1.5rem;\n  }\n\n  .seller-dashboard__panel,\n  .seller-dashboard__payout-card {\n    padding: 1.25rem 1.35rem;\n  }\n\n  .seller-dashboard__payout-footer {\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .seller-dashboard__current-sale {\n    gap: 1rem;\n  }\n}\n\n/* Site mobile/tablet nav drawer (main header hamburger menu) */\n.site-mobile-nav {\n  background: linear-gradient(180deg, #ffffff 0%, #faf8f5 100%);\n  color: #111;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 100%;\n  overflow: hidden;\n}\n\n.site-mobile-nav__header {\n  align-items: flex-start;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  display: flex;\n  gap: 0.75rem;\n  justify-content: space-between;\n  padding: 1rem 1rem 0.9rem;\n}\n\n.site-mobile-nav__brand {\n  align-items: center;\n  display: flex;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.site-mobile-nav__logo {\n  flex-shrink: 0;\n  height: 34px;\n  width: 34px;\n}\n\n.site-mobile-nav__eyebrow {\n  color: #c93312;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.site-mobile-nav__title {\n  color: #111;\n  font-size: 1.2rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.site-mobile-nav__close {\n  align-items: center;\n  background: #f3f4f6;\n  border: none;\n  border-radius: 10px;\n  color: #333;\n  cursor: pointer;\n  display: inline-flex;\n  flex-shrink: 0;\n  height: 36px;\n  justify-content: center;\n  transition: background 0.2s ease;\n  width: 36px;\n}\n\n.site-mobile-nav__close:hover {\n  background: #e9ecef;\n}\n\n.site-mobile-nav__account-card {\n  align-items: center;\n  background: linear-gradient(90deg, #fff4f0 0%, #fff 100%);\n  border: 1px solid rgba(201, 51, 18, 0.12);\n  border-radius: 14px;\n  color: inherit;\n  display: flex;\n  gap: 0.75rem;\n  margin: 0.85rem 1rem 0.25rem;\n  padding: 0.85rem;\n  text-decoration: none;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.site-mobile-nav__account-card:hover {\n  box-shadow: 0 8px 20px rgba(201, 51, 18, 0.1);\n  color: inherit;\n  transform: translateY(-1px);\n}\n\n.site-mobile-nav__account-name {\n  color: #111;\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.site-mobile-nav__account-link {\n  color: #c93312;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.site-mobile-nav__account-icon {\n  color: #c93312;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.site-mobile-nav__body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0.5rem 0.75rem 1rem;\n}\n\n.site-mobile-nav__group + .site-mobile-nav__group {\n  margin-top: 1rem;\n}\n\n.site-mobile-nav__group-title {\n  color: #6c757d;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  margin-bottom: 0.45rem;\n  padding: 0 0.35rem;\n  text-transform: uppercase;\n}\n\n.site-mobile-nav__links {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.site-mobile-nav__link {\n  align-items: center;\n  background: transparent;\n  border: none;\n  border-radius: 12px;\n  color: #222;\n  cursor: pointer;\n  display: flex;\n  font: inherit;\n  gap: 0.75rem;\n  min-height: 48px;\n  padding: 0.65rem 0.75rem;\n  text-align: left;\n  text-decoration: none;\n  transition: background 0.2s ease, color 0.2s ease;\n  width: 100%;\n}\n\n.site-mobile-nav__link:hover {\n  background: rgba(201, 51, 18, 0.06);\n  color: #111;\n}\n\n.site-mobile-nav__link-icon {\n  align-items: center;\n  background: #f5f6f8;\n  border-radius: 10px;\n  color: #c93312;\n  display: inline-flex;\n  flex-shrink: 0;\n  height: 36px;\n  justify-content: center;\n  width: 36px;\n}\n\n.site-mobile-nav__link-label {\n  font-size: 0.92rem;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.site-mobile-nav__footer {\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n  margin-top: auto;\n  padding: 0.85rem 1rem 1rem;\n}\n\n.site-mobile-nav__logout {\n  align-items: center;\n  background: #fff;\n  border: 1px solid rgba(201, 51, 18, 0.22);\n  border-radius: 12px;\n  color: #c93312;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 0.92rem;\n  font-weight: 700;\n  gap: 0.55rem;\n  justify-content: center;\n  min-height: 46px;\n  padding: 0.7rem 1rem;\n  transition: background 0.2s ease;\n  width: 100%;\n}\n\n.site-mobile-nav__logout:hover {\n  background: rgba(201, 51, 18, 0.06);\n}\n\n.site-mobile-nav__login {\n  background: linear-gradient(90deg, #c93312 0%, #a82910 100%);\n  border: none;\n  border-radius: 12px;\n  color: #fff;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 700;\n  min-height: 46px;\n  padding: 0.75rem 1rem;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n  width: 100%;\n}\n\n.site-mobile-nav__login:hover {\n  opacity: 0.94;\n  transform: translateY(-1px);\n}\n\n@media (max-width: 767px) {\n  .site-mobile-nav__link {\n    min-height: 50px;\n  }\n}\n\n/* ── Filters panel (Categories & Search) ── */\n.filters-panel {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n}\n\n.filters-panel__header {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1rem;\n  min-height: 52px;\n  padding: 0.75rem 1.25rem;\n  user-select: none;\n}\n\n.filters-panel__header-left {\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  gap: 0.5rem;\n}\n\n.filters-panel__icon {\n  align-items: center;\n  color: #c93312;\n  display: flex;\n}\n\n.filters-panel__title {\n  color: #111;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.filters-panel__chevron {\n  color: #666 !important;\n  font-size: 1.35rem !important;\n}\n\n.filters-panel__breadcrumb {\n  color: #555;\n  flex: 1;\n  font-size: 0.9rem;\n  font-weight: 500;\n  min-width: 0;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.filters-panel__breadcrumb--empty {\n  flex: 1;\n}\n\n.filters-panel__path {\n  color: #444;\n}\n\n.filters-panel__clear {\n  background: none;\n  border: none;\n  color: #c93312;\n  cursor: pointer;\n  flex-shrink: 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-left: auto;\n  padding: 0.25rem 0;\n  transition: opacity 0.2s ease;\n}\n\n.filters-panel__clear:hover {\n  opacity: 0.75;\n  text-decoration: underline;\n}\n\n.filters-panel__body {\n  border-top: 1px solid #eee;\n  padding: 1.25rem 1.5rem 1.5rem;\n}\n\n.filters-panel__content {\n  display: flex;\n  flex-direction: column;\n}\n\n.filters-panel__subtitle {\n  color: #111;\n  font-size: 1rem;\n  font-weight: 700;\n  margin-bottom: 1.25rem;\n}\n\n.filters-panel__grid {\n  display: grid;\n  gap: 1.5rem 2rem;\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.filters-panel__column-title {\n  color: #111;\n  font-size: 0.95rem;\n  font-weight: 700;\n  margin-bottom: 0.75rem;\n}\n\n.filters-panel__options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.filters-panel__option {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  gap: 0.5rem;\n  margin: 0;\n}\n\n.filters-panel__option-label {\n  color: #333;\n  font-size: 0.9rem;\n  line-height: 1.3;\n}\n\n.filters-panel__checkbox {\n  accent-color: #c93312;\n  appearance: none;\n  background: #fff;\n  border: 1.5px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n  flex-shrink: 0;\n  height: 18px;\n  margin: 0;\n  position: relative;\n  width: 18px;\n}\n\n.filters-panel__checkbox:checked {\n  background: #c93312;\n  border-color: #c93312;\n}\n\n.filters-panel__checkbox:checked::after {\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  content: \"\";\n  height: 9px;\n  left: 5px;\n  position: absolute;\n  top: 1px;\n  transform: rotate(45deg);\n  width: 5px;\n}\n\n.filters-panel__checkbox:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.filters-panel__actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n  padding-top: 0.5rem;\n}\n\n.filters-panel__apply {\n  background: #fff;\n  border: 1.5px solid #222;\n  border-radius: 8px;\n  color: #111;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 600;\n  min-width: 140px;\n  padding: 0.55rem 1.5rem;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.filters-panel__apply:hover {\n  background: #f8f8f8;\n  border-color: #000;\n}\n\n@media (max-width: 991px) {\n  .filters-panel__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .filters-panel__breadcrumb {\n    flex-basis: 100%;\n    order: 3;\n    text-align: left;\n  }\n\n  .filters-panel__clear {\n    margin-left: auto;\n  }\n}\n\n@media (max-width: 575px) {\n  .filters-panel__header {\n    padding: 0.75rem 1rem;\n  }\n\n  .filters-panel__body {\n    padding: 1rem;\n  }\n\n  .filters-panel__grid {\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n  }\n\n  .filters-panel__apply {\n    width: 100%;\n  }\n\n  .filters-panel__actions {\n    justify-content: stretch;\n  }\n}\n\n/* ── Learn page ── */\n.learn-page {\n  --learn-accent: #c93312;\n  --learn-accent-soft: rgba(201, 51, 18, 0.08);\n  --learn-surface: #ffffff;\n  --learn-muted: #6b7280;\n  --learn-border: rgba(0, 0, 0, 0.08);\n  --learn-shadow: 0 8px 32px rgba(15, 23, 42, 0.06);\n}\n\n.learn-page__hero-section {\n  margin-top: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.learn-page__hero {\n  background: linear-gradient(135deg, #faefd1 0%, #fff6e8 45%, #fff 100%);\n  border-bottom-left-radius: 24px;\n  overflow: hidden;\n}\n\n@media (min-width: 768px) {\n  .learn-page__hero {\n    border-bottom-left-radius: 50px;\n  }\n}\n\n.learn-page__hero-copy {\n  max-width: 540px;\n}\n\n.learn-page__eyebrow {\n  color: var(--learn-accent);\n  display: inline-block;\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  margin-bottom: 0.75rem;\n  text-transform: uppercase;\n}\n\n.learn-page__title {\n  color: #111;\n  font-family: \"Helvetica Bold\", Helvetica, Arial, sans-serif;\n  font-size: clamp(2rem, 5vw, 4rem);\n  font-weight: 700;\n  line-height: 1.1;\n  margin: 0 0 1rem;\n}\n\n.learn-page__lead {\n  color: #444;\n  font-size: clamp(0.95rem, 2vw, 1.05rem);\n  line-height: 1.65;\n  margin-bottom: 1.5rem;\n  max-width: 480px;\n}\n\n.learn-page__hero-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.learn-page__stat {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.75);\n  border: 1px solid var(--learn-border);\n  border-radius: 14px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 88px;\n  padding: 0.65rem 1rem;\n  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;\n}\n\n.learn-page__stat:hover {\n  background: #fff;\n  border-color: rgba(201, 51, 18, 0.25);\n  transform: translateY(-1px);\n}\n\n.learn-page__stat--active,\n.learn-page__stat--active:hover,\n.learn-page__stat--active:focus-visible {\n  background: #373a3b !important;\n  border-color: #373a3b !important;\n  color: #fff !important;\n}\n\n.learn-page__stat--active .learn-page__stat-value,\n.learn-page__stat--active .learn-page__stat-label {\n  color: #fff !important;\n}\n\n.learn-page__stat:not(.learn-page__stat--active) .learn-page__stat-value {\n  color: #111;\n}\n\n.learn-page__stat:not(.learn-page__stat--active) .learn-page__stat-label {\n  color: var(--learn-muted);\n}\n\n.learn-page__stat-value {\n  font-size: 1.25rem;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.learn-page__stat-label {\n  color: var(--learn-muted);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.learn-page__hero-art {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: flex-end;\n  min-height: 220px;\n}\n\n.learn-page__hero-img {\n  border-top-left-radius: 60px;\n  height: 100%;\n  max-height: 320px;\n  object-fit: contain;\n  object-position: right center;\n  width: 75%;\n}\n\n.learn-page__layout {\n  background: var(--learn-surface);\n  border: 1px solid var(--learn-border);\n  border-radius: 20px;\n  box-shadow: var(--learn-shadow);\n  display: grid;\n  grid-template-columns: 260px 1fr;\n  min-height: 420px;\n  overflow: hidden;\n}\n\n.learn-page__nav {\n  background: #eef1f3;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 1rem;\n}\n\n.learn-page__nav-item {\n  align-items: center;\n  background: transparent;\n  border: none;\n  border-radius: 12px;\n  color: #333;\n  cursor: pointer;\n  display: flex;\n  font-size: 0.95rem;\n  font-weight: 700;\n  gap: 0.65rem;\n  padding: 0.85rem 1rem;\n  text-align: left;\n  transition: background 0.2s ease, color 0.2s ease;\n  width: 100%;\n}\n\n.learn-page__nav-item:hover:not(.learn-page__nav-item--active) {\n  background: rgba(255, 255, 255, 0.7);\n  color: #333;\n}\n\n.learn-page__nav-item.learn-page__nav-item--active,\n.learn-page__nav-item.learn-page__nav-item--active:hover,\n.learn-page__nav-item.learn-page__nav-item--active:focus-visible {\n  background: #373a3b !important;\n  color: #fff !important;\n}\n\n.learn-page__nav-item--active .learn-page__nav-icon,\n.learn-page__nav-item--active .learn-page__nav-label {\n  color: #fff !important;\n}\n\n.learn-page__nav-item:not(.learn-page__nav-item--active) .learn-page__nav-icon,\n.learn-page__nav-item:not(.learn-page__nav-item--active) .learn-page__nav-label {\n  color: #333;\n}\n\n.learn-page__nav-icon {\n  flex-shrink: 0;\n  font-size: 1.25rem;\n  color: inherit;\n}\n\n.learn-page__nav-label {\n  flex: 1;\n  min-width: 0;\n  color: inherit;\n}\n\n.learn-page__nav-count {\n  background: rgba(0, 0, 0, 0.06);\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  min-width: 1.5rem;\n  padding: 0.15rem 0.45rem;\n  text-align: center;\n}\n\n.learn-page__nav-item--active .learn-page__nav-count {\n  background: rgba(255, 255, 255, 0.2);\n  color: #fff !important;\n}\n\n.learn-page__nav-item:not(.learn-page__nav-item--active) .learn-page__nav-count {\n  background: rgba(0, 0, 0, 0.06);\n  color: #333;\n}\n\n.learn-page__content {\n  padding: 1.75rem 2rem 2rem;\n}\n\n.learn-page__panel-header {\n  border-bottom: 1px solid #eee;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1.25rem;\n}\n\n.learn-page__panel-title {\n  color: #111;\n  font-size: clamp(1.35rem, 3vw, 1.75rem);\n  font-weight: 800;\n  margin: 0 0 0.35rem;\n}\n\n.learn-page__panel-desc {\n  color: var(--learn-muted);\n  font-size: 0.95rem;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.learn-page__loader {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: 200px;\n  padding: 2rem 0;\n}\n\n.learn-page__empty {\n  background: #f9fafb;\n  border: 1px dashed #ddd;\n  border-radius: 14px;\n  color: var(--learn-muted);\n  padding: 2.5rem 1.5rem;\n  text-align: center;\n}\n\n.learn-page__empty p {\n  margin: 0;\n}\n\n/* FAQ accordion overrides */\n.learn-page__faq .MuiAccordion-root {\n  background: #fff;\n  border: 1px solid #eee !important;\n  border-radius: 12px !important;\n  box-shadow: none !important;\n  margin-bottom: 0.65rem !important;\n  overflow: hidden;\n}\n\n.learn-page__faq .MuiAccordion-root::before {\n  display: none;\n}\n\n.learn-page__faq .MuiAccordionSummary-root {\n  min-height: 56px !important;\n  padding: 0 1.25rem;\n}\n\n.learn-page__faq .MuiAccordionSummary-content {\n  margin: 0.85rem 0 !important;\n}\n\n.learn-page__faq .MuiAccordionSummary-content b {\n  color: #111;\n  font-size: 0.95rem;\n  font-weight: 700;\n  line-height: 1.4;\n}\n\n.learn-page__faq .MuiAccordionDetails-root {\n  border-top: 1px solid #f0f0f0;\n  color: #555;\n  line-height: 1.65;\n  padding: 0 1.25rem 1.1rem;\n}\n\n.learn-page__faq .MuiSvgIcon-root {\n  color: var(--learn-accent);\n}\n\n/* Video cards */\n.learn-page__video-grid {\n  display: grid;\n  gap: 1.25rem;\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.learn-page__video-card {\n  background: #fff;\n  border: 1px solid #eee;\n  border-radius: 16px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 0;\n  text-align: left;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n  width: 100%;\n}\n\n.learn-page__video-card:hover {\n  border-color: rgba(201, 51, 18, 0.3);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n  transform: translateY(-2px);\n}\n\n.learn-page__video-thumb {\n  aspect-ratio: 16 / 9;\n  background: #1a1a1a;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n\n.learn-page__video-thumb img {\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.35s ease;\n  width: 100%;\n}\n\n.learn-page__video-card:hover .learn-page__video-thumb img {\n  transform: scale(1.04);\n}\n\n.learn-page__video-thumb-placeholder {\n  background: linear-gradient(135deg, #2d2d2d, #444);\n  height: 100%;\n  width: 100%;\n}\n\n.learn-page__video-play {\n  align-items: center;\n  background: rgba(201, 51, 18, 0.92);\n  border-radius: 50%;\n  color: #fff;\n  display: flex;\n  height: 52px;\n  justify-content: center;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transition: transform 0.2s ease, background 0.2s ease;\n  width: 52px;\n}\n\n.learn-page__video-card:hover .learn-page__video-play {\n  background: #c93312;\n  transform: translate(-50%, -50%) scale(1.08);\n}\n\n.learn-page__video-body {\n  padding: 1rem 1.15rem 1.15rem;\n}\n\n/* Blog cards */\n.learn-page__blog-grid {\n  display: grid;\n  gap: 1.25rem;\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.learn-page__blog-card {\n  background: #fff;\n  border: 1px solid #eee;\n  border-radius: 16px;\n  color: inherit;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  text-decoration: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.learn-page__blog-card:hover {\n  border-color: rgba(201, 51, 18, 0.3);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n  color: inherit;\n  text-decoration: none;\n  transform: translateY(-2px);\n}\n\n.learn-page__blog-thumb {\n  aspect-ratio: 16 / 9;\n  background: #f3f4f6;\n  overflow: hidden;\n}\n\n.learn-page__blog-thumb img {\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.35s ease;\n  width: 100%;\n}\n\n.learn-page__blog-card:hover .learn-page__blog-thumb img {\n  transform: scale(1.04);\n}\n\n.learn-page__blog-thumb-placeholder {\n  align-items: center;\n  color: #bbb;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n}\n\n.learn-page__blog-body {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 1rem 1.15rem 1.15rem;\n}\n\n.learn-page__blog-date {\n  color: var(--learn-accent);\n  display: block;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  margin-bottom: 0.45rem;\n  text-transform: uppercase;\n}\n\n.learn-page__card-title {\n  color: #111;\n  font-size: 1.05rem;\n  font-weight: 700;\n  line-height: 1.35;\n  margin: 0 0 0.5rem;\n}\n\n.learn-page__card-desc {\n  -webkit-box-orient: vertical;\n  color: var(--learn-muted);\n  display: -webkit-box;\n  flex: 1;\n  font-size: 0.9rem;\n  -webkit-line-clamp: 3;\n  line-height: 1.55;\n  margin: 0;\n  overflow: hidden;\n}\n\n.learn-page__read-more {\n  align-items: center;\n  color: var(--learn-accent);\n  display: inline-flex;\n  font-size: 0.875rem;\n  font-weight: 700;\n  gap: 0.35rem;\n  margin-top: 0.85rem;\n}\n\n.learn-page__blog-card:hover .learn-page__read-more {\n  gap: 0.55rem;\n}\n\n@media (max-width: 991px) {\n  .learn-page__layout {\n    grid-template-columns: 220px 1fr;\n  }\n\n  .learn-page__content {\n    padding: 1.5rem;\n  }\n\n  .learn-page__video-grid,\n  .learn-page__blog-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 767px) {\n  .learn-page__hero-section {\n    margin-top: 1rem;\n    margin-bottom: 1.25rem;\n  }\n\n  .learn-page__hero-stats {\n    gap: 0.5rem;\n  }\n\n  .learn-page__stat {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .learn-page__layout {\n    display: flex;\n    flex-direction: column;\n    grid-template-columns: unset;\n  }\n\n  .learn-page__nav {\n    border-bottom: 1px solid #dde1e4;\n    flex-direction: row;\n    flex-shrink: 0;\n    gap: 0.35rem;\n    overflow-x: hidden;\n    padding: 0.65rem;\n    scrollbar-width: none;\n  }\n\n  .learn-page__nav::-webkit-scrollbar {\n    display: none;\n  }\n\n  .learn-page__nav-item {\n    align-items: center;\n    flex: 1 1 0;\n    flex-direction: column;\n    justify-content: center;\n    min-width: 0;\n    padding: 0.6rem 0.35rem;\n    text-align: center;\n    width: auto;\n  }\n\n  .learn-page__nav-label {\n    font-size: 0.72rem;\n    line-height: 1.2;\n    white-space: normal;\n  }\n\n  .learn-page__nav-count {\n    display: none;\n  }\n\n  .learn-page__content {\n    padding: 1.25rem 1rem 1.5rem;\n  }\n\n  .learn-page__panel-header {\n    margin-bottom: 1.25rem;\n    padding-bottom: 1rem;\n  }\n}\n\n@media (max-width: 575px) {\n  .learn-page__hero {\n    border-bottom-left-radius: 20px;\n  }\n\n  .learn-page__nav-item {\n    font-size: 0.82rem;\n    gap: 0.3rem;\n    padding: 0.55rem 0.25rem;\n  }\n\n  .learn-page__nav-label {\n    font-size: 0.68rem;\n  }\n\n  .learn-page__faq .MuiAccordionSummary-root {\n    padding: 0 0.85rem;\n  }\n\n  .learn-page__faq .MuiAccordionDetails-root {\n    padding: 0 0.85rem 1rem;\n  }\n}\n\n/* ── User profile settings ── */\n.user-profile {\n  --profile-accent: #c93312;\n  --profile-accent-soft: rgba(201, 51, 18, 0.08);\n  --profile-surface: #ffffff;\n  --profile-muted: #6b7280;\n  --profile-border: rgba(0, 0, 0, 0.08);\n  --profile-shadow: 0 4px 24px rgba(15, 23, 42, 0.06);\n  min-height: 60vh;\n}\n\n.user-profile__header {\n  align-items: flex-start;\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.user-profile__back {\n  align-items: center;\n  background: #fff;\n  border: 1px solid var(--profile-border);\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  color: #111;\n  cursor: pointer;\n  display: inline-flex;\n  flex-shrink: 0;\n  height: 44px;\n  justify-content: center;\n  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;\n  width: 44px;\n}\n\n.user-profile__back:hover {\n  background: #f8f8f8;\n  border-color: rgba(0, 0, 0, 0.14);\n  transform: translateY(-1px);\n}\n\n.user-profile__eyebrow {\n  color: var(--profile-accent);\n  display: inline-block;\n  font-size:clamp(1.75rem, 4vw, 2.25rem);\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  margin-bottom: 0.35rem;\n  text-transform: uppercase;\n}\n\n.user-profile__title {\n  color: #111;\n  font-family: \"Helvetica Bold\", Helvetica, Arial, sans-serif;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.15;\n  margin: 0 0 0.5rem;\n}\n\n.user-profile__subtitle {\n  color: var(--profile-muted);\n  font-size: 0.95rem;\n  line-height: 1.55;\n  margin: 0;\n  max-width: 520px;\n}\n\n.user-profile__layout {\n  display: grid;\n  gap: 1.25rem;\n  grid-template-columns: minmax(260px, 320px) 1fr;\n}\n\n.user-profile__card {\n  background: var(--profile-surface);\n  border: 1px solid var(--profile-border);\n  border-radius: 18px;\n  box-shadow: var(--profile-shadow);\n  padding: 1.5rem;\n}\n\n.user-profile__card--identity {\n  height: 100%;\n  text-align: center;\n}\n\n.user-profile__card-head {\n  margin-bottom: 1.25rem;\n}\n\n.user-profile__card-title {\n  color: #111;\n  font-size: 1.05rem;\n  font-weight: 800;\n  margin: 0 0 0.35rem;\n}\n\n.user-profile__card-title--danger {\n  color: #b42318;\n}\n\n.user-profile__card-desc {\n  color: var(--profile-muted);\n  font-size: 0.875rem;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.user-profile__card-desc--danger {\n  color: #9a3412;\n}\n\n.user-profile__main {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.user-profile__avatar-block {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n.user-profile__avatar {\n  align-items: center;\n  background: linear-gradient(135deg, #fff4ee, #fde8dc);\n  border: 3px solid #fff;\n  border-radius: 50%;\n  box-shadow: 0 8px 24px rgba(201, 51, 18, 0.12);\n  display: flex;\n  height: 120px;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n  width: 120px;\n}\n\n.user-profile__avatar img {\n  height: 100%;\n  object-fit: cover;\n  width: 100%;\n}\n\n.user-profile__avatar-initials {\n  color: var(--profile-accent);\n  font-size: 2rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.user-profile__avatar--loading {\n  opacity: 0.85;\n}\n\n.user-profile__avatar-overlay {\n  align-items: center;\n  background: rgba(0, 0, 0, 0.45);\n  bottom: 0;\n  color: #fff;\n  display: flex;\n  font-size: 0.75rem;\n  font-weight: 600;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.user-profile__upload-btn {\n  align-items: center;\n  background: #111;\n  border: none;\n  border-radius: 10px;\n  color: #fff;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 0.875rem;\n  font-weight: 600;\n  gap: 0.4rem;\n  padding: 0.55rem 1rem;\n  transition: background 0.2s ease, transform 0.2s ease;\n}\n\n.user-profile__upload-btn:hover {\n  background: #222;\n  transform: translateY(-1px);\n}\n\n.user-profile__upload-btn--disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n  pointer-events: none;\n}\n\n.user-profile__identity-name {\n  color: #111;\n  font-size: 1.2rem;\n  font-weight: 800;\n  margin: 0 0 0.25rem;\n  word-break: break-word;\n}\n\n.user-profile__identity-email {\n  color: var(--profile-muted);\n  font-size: 0.875rem;\n  margin: 0;\n  word-break: break-all;\n}\n\n.user-profile__identity-meta {\n  margin-bottom: 1rem;\n}\n\n.user-profile__identity-badge {\n  align-items: center;\n  background: var(--profile-accent-soft);\n  border-radius: 999px;\n  color: var(--profile-accent);\n  display: inline-flex;\n  font-size: 0.8rem;\n  font-weight: 700;\n  gap: 0.35rem;\n  padding: 0.4rem 0.85rem;\n}\n\n.user-profile__fields {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.user-profile__field-label {\n  color: #374151;\n  display: block;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  margin-bottom: 0.45rem;\n  text-transform: uppercase;\n}\n\n.user-profile__field-value-row {\n  align-items: center;\n  background: #f9fafb;\n  border: 1px solid #eee;\n  border-radius: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  justify-content: space-between;\n  min-height: 52px;\n  padding: 0.75rem 1rem;\n}\n\n.user-profile__field-value {\n  color: #111;\n  font-size: 0.95rem;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.user-profile__field-value--with-icon {\n  align-items: center;\n  display: inline-flex;\n  gap: 0.5rem;\n}\n\n.user-profile__field-hint {\n  color: var(--profile-muted);\n  display: block;\n  font-size: 0.8rem;\n  line-height: 1.45;\n  margin-top: 0.45rem;\n}\n\n.user-profile__edit-btn {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  color: #111;\n  cursor: pointer;\n  display: inline-flex;\n  flex-shrink: 0;\n  font-size: 0.82rem;\n  font-weight: 600;\n  gap: 0.35rem;\n  padding: 0.4rem 0.75rem;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.user-profile__edit-btn:hover {\n  background: #f8f8f8;\n  border-color: #bbb;\n}\n\n.user-profile__pref {\n  align-items: flex-start;\n  background: #fafafa;\n  border: 1px solid #eee;\n  border-radius: 14px;\n  cursor: pointer;\n  display: flex;\n  gap: 0.85rem;\n  margin: 0;\n  padding: 1rem 1.1rem;\n  transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.user-profile__pref:hover {\n  background: #fff;\n  border-color: rgba(201, 51, 18, 0.25);\n}\n\n.user-profile__pref-input {\n  height: 0;\n  opacity: 0;\n  position: absolute;\n  width: 0;\n}\n\n.user-profile__pref-box {\n  background: #fff;\n  border: 2px solid #ccc;\n  border-radius: 6px;\n  flex-shrink: 0;\n  height: 20px;\n  margin-top: 2px;\n  position: relative;\n  transition: background 0.2s ease, border-color 0.2s ease;\n  width: 20px;\n}\n\n.user-profile__pref-input:checked + .user-profile__pref-box {\n  background: var(--profile-accent);\n  border-color: var(--profile-accent);\n}\n\n.user-profile__pref-input:checked + .user-profile__pref-box::after {\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  content: \"\";\n  height: 10px;\n  left: 5px;\n  position: absolute;\n  top: 1px;\n  transform: rotate(45deg);\n  width: 6px;\n}\n\n.user-profile__pref-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.user-profile__pref-title {\n  color: #111;\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.user-profile__pref-text {\n  color: var(--profile-muted);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.user-profile__card--danger {\n  background: linear-gradient(180deg, #fff8f7 0%, #fff 100%);\n  border-color: rgba(180, 35, 24, 0.15);\n}\n\n.user-profile__danger-head {\n  align-items: flex-start;\n  display: flex;\n  gap: 0.75rem;\n}\n\n.user-profile__danger-icon {\n  align-items: center;\n  background: rgba(180, 35, 24, 0.1);\n  border-radius: 12px;\n  color: #b42318;\n  display: inline-flex;\n  flex-shrink: 0;\n  height: 44px;\n  justify-content: center;\n  width: 44px;\n}\n\n.user-profile__danger-btn {\n  background: #fff;\n  border: 1.5px solid #b42318;\n  border-radius: 10px;\n  color: #b42318;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 700;\n  padding: 0.65rem 1.15rem;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.user-profile__danger-btn:hover:not(:disabled) {\n  background: #b42318;\n  color: #fff;\n}\n\n.user-profile__danger-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.user-profile__modal {\n  --profile-accent: #c93312;\n  --profile-accent-soft: rgba(201, 51, 18, 0.08);\n  border-radius: 16px !important;\n}\n\n.user-profile__modal .modal-body {\n  padding-bottom: 1.5rem;\n}\n\n.user-profile__modal-title {\n  font-size: 1.15rem;\n  font-weight: 800;\n}\n\n.user-profile__modal-field {\n  margin-bottom: 1.15rem;\n}\n\n.user-profile__input {\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  color: #111;\n  font-size: 0.95rem;\n  padding: 0.65rem 0.85rem;\n  width: 100%;\n}\n\n.user-profile__input:focus {\n  border-color: #c93312;\n  box-shadow: 0 0 0 3px rgba(201, 51, 18, 0.12);\n  outline: none;\n}\n\n.user-profile__modal-readonly {\n  color: #111;\n  font-size: 0.95rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.user-profile__modal-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n  justify-content: flex-end;\n  padding-top: 0.5rem;\n}\n\n.user-profile__btn {\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 700;\n  min-width: 110px;\n  padding: 0.6rem 1.1rem;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.user-profile__btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.user-profile__btn--ghost {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.user-profile__btn--ghost:hover:not(:disabled) {\n  background: #e5e7eb;\n}\n\n.user-profile__btn--primary {\n  background-color: #c93312 !important;\n  color: #fff !important;\n}\n\n.user-profile__btn--primary:hover:not(:disabled) {\n  background-color: #a82910;\n  opacity: 1;\n  transform: translateY(-1px);\n}\n\n@media (max-width: 991px) {\n  .user-profile__layout {\n    grid-template-columns: 1fr;\n  }\n\n  .user-profile__sidebar {\n    order: 1;\n  }\n\n  .user-profile__main {\n    order: 2;\n  }\n}\n\n@media (max-width: 575px) {\n  .user-profile__header {\n    margin-bottom: 1.5rem;\n  }\n\n  .user-profile__card {\n    padding: 1.15rem;\n  }\n\n  .user-profile__avatar {\n    height: 100px;\n    width: 100px;\n  }\n\n  .user-profile__field-value-row {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .user-profile__edit-btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .user-profile__modal-actions {\n    flex-direction: column-reverse;\n  }\n\n  .user-profile__btn {\n    width: 100%;\n  }\n\n  .user-profile__danger-btn {\n    width: 100%;\n  }\n}\n\n/* ── Seller grid listing card actions ── */\n.seller-listing-card__folder-action {\n  width: 100%;\n  padding: 0.35rem 0.6rem;\n  border: 1px solid #e2e5e9;\n  border-radius: 8px;\n  background: #f7f8f9;\n  color: #5f6670;\n  font-size: 0.75rem;\n  font-weight: 600;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.seller-listing-card__folder-action:hover {\n  border-color: #c9ced5;\n  background: #eef0f2;\n  color: #343a40;\n}\n\n.seller-listing-card__actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0 0.25rem;\n}\n\n.seller-listing-card__primary-action,\n.seller-listing-card__icon-action {\n  min-height: 36px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.15s ease, background-color 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.listing-card .seller-listing-card__primary-action {\n  flex: 1;\n  gap: 0.4rem;\n  min-width: 0;\n  padding: 0.45rem 0.75rem;\n  border: 1px solid #171717;\n  background: #171717 !important;\n  color: #fff !important;\n  font-size: 0.82rem;\n  font-weight: 700;\n  line-height: 1;\n  opacity: 1;\n}\n\n.listing-card .seller-listing-card__primary-action:hover {\n  background: #303030 !important;\n  border-color: #303030;\n  color: #fff !important;\n}\n\n.listing-card .seller-listing-card__primary-action span,\n.listing-card .seller-listing-card__primary-action svg {\n  display: inline-block;\n  flex: 0 0 auto;\n  color: #fff !important;\n  fill: currentColor;\n  opacity: 1;\n}\n\n.seller-listing-card__icon-action {\n  flex: 0 0 36px;\n  width: 36px;\n  border: 1px solid #d9dde2;\n  background: #fff;\n  color: #30343a;\n  font-size: 0.9rem;\n}\n\n.seller-listing-card__icon-action:hover {\n  border-color: #9da3ab;\n  background: #f5f6f7;\n}\n\n.seller-listing-card__icon-action:disabled {\n  cursor: not-allowed;\n  opacity: 0.45;\n  transform: none;\n}\n\n.seller-listing-card__icon-action--link {\n  border-color: #cfe0ff !important;\n  background: #edf3ff !important;\n  color: #1d4ed8 !important;\n}\n\n.seller-listing-card__icon-action--link:hover:not(:disabled) {\n  border-color: #1d4ed8 !important;\n  background: #1d4ed8 !important;\n  color: #fff !important;\n}\n\n.seller-listing-card__icon-action--link:disabled {\n  border-color: #dbe3f0 !important;\n  background: #f3f6fb !important;\n  color: #93a4c3 !important;\n  opacity: 1;\n}\n\n.seller-listing-card__icon-action--danger {\n  border-color: #f0c9c1;\n  background: #fff5f3;\n  color: #c93312;\n}\n\n.seller-listing-card__icon-action--danger:hover {\n  border-color: #c93312;\n  background: #c93312;\n  color: #fff;\n}\n\n.seller-listing-card__primary-action:hover,\n.seller-listing-card__icon-action:hover {\n  transform: translateY(-1px);\n}\n\n/* ── Seller detailed listing card ── */\n.detailed-listing-card {\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 16px;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);\n  display: flex;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  padding: 1rem;\n}\n\n.detailed-listing-card__checkbox {\n  align-items: flex-start;\n  display: flex;\n  flex-shrink: 0;\n  padding-top: 0.25rem;\n}\n\n.detailed-listing-card__layout {\n  display: grid;\n  flex: 1;\n  gap: 1rem;\n  grid-template-columns: 96px 1fr;\n  grid-template-areas:\n    \"media content\"\n    \"stats stats\";\n  min-width: 0;\n}\n\n.detailed-listing-card__media {\n  grid-area: media;\n  position: relative;\n  width: 100%;\n}\n\n.detailed-listing-card__image-link {\n  display: block;\n}\n\n.detailed-listing-card__image {\n  border-radius: 10px;\n  display: block;\n  height: 96px;\n  object-fit: cover;\n  object-position: center;\n  width: 100%;\n}\n\n.detailed-listing-card__content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  grid-area: content;\n  min-width: 0;\n}\n\n.detailed-listing-card__info {\n  min-width: 0;\n}\n\n.detailed-listing-card__title {\n  color: #111;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.35;\n  margin: 0 0 0.35rem;\n  word-break: break-word;\n}\n\n.detailed-listing-card__description {\n  -webkit-box-orient: vertical;\n  color: #6b7280;\n  display: -webkit-box;\n  font-size: 0.875rem;\n  -webkit-line-clamp: 3;\n  line-height: 1.5;\n  margin: 0;\n  overflow: hidden;\n}\n\n.detailed-listing-card__remove-folder {\n  margin-top: 0.5rem;\n}\n\n.detailed-listing-card__actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.detailed-listing-card__primary-action {\n  align-items: center;\n  background: #171717 !important;\n  border: 1px solid #171717 !important;\n  border-radius: 8px;\n  color: #fff !important;\n  display: inline-flex;\n  font-size: 0.875rem;\n  font-weight: 700;\n  gap: 0.45rem;\n  justify-content: center;\n  min-height: 36px;\n  min-width: 88px;\n  padding: 0.45rem 1rem;\n  text-decoration: none !important;\n  transition: background-color 0.15s ease, transform 0.15s ease;\n}\n\n.detailed-listing-card__primary-action:hover,\n.detailed-listing-card__primary-action:focus,\n.detailed-listing-card__primary-action:active {\n  background: #303030 !important;\n  border-color: #303030 !important;\n  color: #fff !important;\n  text-decoration: none !important;\n  transform: translateY(-1px);\n}\n\n.detailed-listing-card__primary-action span,\n.detailed-listing-card__primary-action svg {\n  color: #fff !important;\n  fill: currentColor;\n  opacity: 1;\n}\n\n.detailed-listing-card__btn {\n  align-items: center;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 0.875rem;\n  font-weight: 600;\n  justify-content: center;\n  min-height: 36px;\n  padding: 0.45rem 1.1rem;\n  text-decoration: none;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.detailed-listing-card__btn:hover {\n  opacity: 0.92;\n  transform: translateY(-1px);\n}\n\n.detailed-listing-card__btn--dark {\n  background: #0e0e0e;\n  color: #fff;\n}\n\n.detailed-listing-card__btn--danger {\n  background: #c93312;\n  color: #fff;\n}\n\n.detailed-listing-card__icon-btn {\n  align-items: center;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  height: 36px;\n  justify-content: center;\n  min-width: 36px;\n  padding: 0 0.55rem;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.detailed-listing-card__icon-btn:hover:not(:disabled) {\n  opacity: 0.92;\n  transform: translateY(-1px);\n}\n\n.detailed-listing-card__icon-btn--primary {\n  background: #c93312;\n  color: #fff;\n}\n\n.detailed-listing-card__icon-btn--ghost {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.detailed-listing-card__icon-btn--edit {\n  background: #171717 !important;\n  border: 1px solid #171717 !important;\n  color: #fff !important;\n}\n\n.detailed-listing-card__icon-btn--edit:hover:not(:disabled) {\n  background: #303030 !important;\n  border-color: #303030 !important;\n  color: #fff !important;\n}\n\n.detailed-listing-card__icon-btn--edit svg {\n  color: #fff !important;\n  fill: currentColor;\n}\n\n.detailed-listing-card__icon-btn--link {\n  background: #edf3ff !important;\n  border: 1px solid #cfe0ff !important;\n  color: #1d4ed8 !important;\n}\n\n.detailed-listing-card__icon-btn--link:hover:not(:disabled) {\n  background: #1d4ed8 !important;\n  border-color: #1d4ed8 !important;\n  color: #fff !important;\n}\n\n.detailed-listing-card__icon-btn--link:disabled {\n  background: #f3f6fb !important;\n  border-color: #dbe3f0 !important;\n  color: #93a4c3 !important;\n  opacity: 1;\n}\n\n.detailed-listing-card__icon-btn--danger {\n  background: #fff5f3;\n  border: 1px solid #f0c9c1;\n  color: #c93312;\n}\n\n.detailed-listing-card__icon-btn--danger:hover:not(:disabled) {\n  background: #c93312;\n  border-color: #c93312;\n  color: #fff;\n}\n\n.detailed-listing-card__icon-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n\n.detailed-listing-card__btn--mobile {\n  display: none;\n}\n\n.detailed-listing-card__stats {\n  background: #f9fafb;\n  border: 1px solid #eee;\n  border-radius: 12px;\n  display: grid;\n  gap: 0.65rem;\n  grid-area: stats;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  padding: 0.75rem;\n}\n\n.detailed-listing-card__stat {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.detailed-listing-card__stat-label {\n  color: #6b7280;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  line-height: 1.3;\n  text-transform: uppercase;\n}\n\n.detailed-listing-card__stat-value {\n  color: #111;\n  font-size: 0.9rem;\n  font-weight: 700;\n  line-height: 1.2;\n  word-break: break-word;\n}\n\n.detailed-listing-card__stat-value--success {\n  color: #15803d;\n}\n\n@media (min-width: 576px) {\n  .detailed-listing-card {\n    padding: 1.1rem 1.15rem;\n  }\n\n  .detailed-listing-card__layout {\n    grid-template-columns: 112px 1fr;\n  }\n\n  .detailed-listing-card__image {\n    height: 112px;\n  }\n\n  .detailed-listing-card__stats {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 768px) {\n  .detailed-listing-card__layout {\n    align-items: center;\n    gap: 1.25rem;\n    grid-template-columns: 120px minmax(0, 1fr) minmax(0, 1.4fr);\n    grid-template-areas: \"media content stats\";\n  }\n\n  .detailed-listing-card__image {\n    height: 100px;\n  }\n\n  .detailed-listing-card__content {\n    align-items: flex-start;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .detailed-listing-card__info {\n    flex: 1;\n    padding-right: 1rem;\n  }\n\n  .detailed-listing-card__description {\n    -webkit-line-clamp: 2;\n  }\n\n  .detailed-listing-card__actions {\n    flex-shrink: 0;\n    justify-content: flex-end;\n  }\n\n  .detailed-listing-card__stats {\n    background: transparent;\n    border: none;\n    gap: 0.5rem 0.75rem;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    padding: 0;\n  }\n\n  .detailed-listing-card__stat {\n    align-items: center;\n    text-align: center;\n  }\n\n  .detailed-listing-card__stat-label {\n    font-size: 0.72rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .detailed-listing-card__layout {\n    grid-template-columns: 120px minmax(0, 1fr) minmax(0, 1.8fr);\n  }\n\n  .detailed-listing-card__stats {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n\n  .detailed-listing-card__btn--desktop {\n    display: inline;\n  }\n\n  .detailed-listing-card__btn--mobile {\n    display: none !important;\n  }\n}\n\n@media (max-width: 1199px) {\n  .detailed-listing-card__btn--desktop {\n    display: none !important;\n  }\n\n  .detailed-listing-card__btn--mobile {\n    align-items: center;\n    display: inline-flex !important;\n    justify-content: center;\n  }\n\n  .detailed-listing-card__btn.detailed-listing-card__btn--dark,\n  .detailed-listing-card__btn.detailed-listing-card__btn--danger {\n    min-width: 36px;\n    padding: 0 0.55rem;\n  }\n}\n\n/* ── My Listings toolbar ── */\n.my-listings-page-header {\n  margin-top: 1.25rem;\n}\n\n.my-listings-toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n}\n\n.my-listings-toolbar__controls {\n  align-items: stretch;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.my-listings-toolbar__selection {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.my-listings-toolbar__actions {\n  display: grid;\n  gap: 0.65rem;\n  grid-template-columns: 1fr;\n  width: 100%;\n}\n\n.my-listings-toolbar__btn--action {\n  width: 100%;\n}\n\n.my-listings-view-toggle {\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.25rem;\n  padding: 0.25rem;\n  width: 100%;\n}\n\n.my-listings-view-toggle__btn {\n  align-items: center;\n  background: transparent;\n  border: none;\n  border-radius: 10px;\n  color: #4b5563;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 0.875rem;\n  font-weight: 600;\n  gap: 0.4rem;\n  justify-content: center;\n  min-height: 40px;\n  padding: 0.5rem 0.75rem;\n  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n  white-space: nowrap;\n}\n\n.my-listings-view-toggle__btn:hover {\n  background: rgba(255, 255, 255, 0.7);\n  color: #111;\n}\n\n.my-listings-view-toggle__btn--active {\n  background: #fff;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);\n  color: #111;\n}\n\n.my-listings-sort-row {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.my-listings-sort {\n  width: 100%;\n}\n\n@media (min-width: 576px) {\n  .my-listings-toolbar__actions {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 768px) {\n  .my-listings-toolbar {\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .my-listings-toolbar__controls {\n    align-items: center;\n    flex: 1;\n    flex-direction: row;\n    flex-wrap: wrap;\n    min-width: 0;\n  }\n\n  .my-listings-toolbar__actions {\n    display: flex;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n    gap: 0.65rem;\n    justify-content: flex-end;\n    width: auto;\n  }\n\n  .my-listings-toolbar__btn--action {\n    width: auto;\n    min-width: 140px;\n  }\n\n  .my-listings-view-toggle {\n    max-width: 280px;\n    width: auto;\n  }\n\n  .my-listings-sort {\n    max-width: 280px;\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
